/* =========================================================================
   AlienComfort | ac-secties.js — het script van de AC-secties
   =========================================================================
   Stond tot 21 september 2026 als <script> in de Custom Liquid van elke
   sectie en werd dus op elke paginaweergave opnieuw meegestuurd. Hier staat
   het één keer, en de browser bewaart het.

   De kopanimatie van brandbook §4.8 stond in drie secties als kopie; die is
   nu één keer aanwezig in ac-cosmos.js en hieruit verwijderd.

   Alles hieronder is idempotent (data-ac-ready of een eigen vlag) en luistert
   op shopify:section:load, zodat het in de thema-editor blijft werken.
   Gegevens uit Liquid komen binnen via <script type="application/json"> in de
   sectie zelf, niet via ingebakken waarden.
   ========================================================================= */

/* ####### PRODUCTBLOKKEN ####### */
/* ===== ac-pdp-sterren ===== */
(function () {
/* ---- binnenkomen met #beoordelingen ---------------------------------
   De sterrenrij in de collectiesecties linkt naar
   {productpagina}#beoordelingen. Er staat geen element met dat id op de
   pagina, dus de browser doet daar zelf niets mee. Hier wordt hetzelfde
   doel gezocht als bij een klik op de rij, en met dezelfde marge in beeld
   gezet. Draait één keer per pagina, ook als er meerdere rijen staan, en
   ook als er helemaal geen beoordelingen zijn.
   -------------------------------------------------------------------- */
/* ---- de reviewsectie zoeken ------------------------------------------
   De ombouw hernoemt botsende klassenprefixen per sjabloon, en dat raakt
   ook het kenmerk van de reviewsectie: op TITAN, NOVA, VERUNA, LUNA en
   PULSAR PRO heet het data-ac-rev, op ATLAS en ASTRON data-ac-rev-a en op
   PLUTO data-ac-rev-p. De vaste selector [data-ac-rev] vond die laatste
   drie niet, waardoor de sterrenrij daar geen knop werd en de sprong vanaf
   #beoordelingen niet werkte. Zoeken op de NAAM van het kenmerk lost dat
   op, ook voor sjablonen die er later bij komen. 24-09-2026.
   -------------------------------------------------------------------- */
function acRevSectie() {
var kand = document.querySelectorAll('section, div');
for (var i = 0; i < kand.length; i++) {
var at = kand[i].attributes;
for (var j = 0; j < at.length; j++) {
if (/^data-ac-rev(-[a-z]{1,3})?$/.test(at[j].name)) { return kand[i]; }
}
}
return null;
}
function haakHash() {
if (window.__acRevSprong) { return; }
var hash = (window.location.hash || '').toLowerCase();
if (hash !== '#beoordelingen' && hash !== '#reviews') { return; }
window.__acRevSprong = true;
var rij = document.querySelector('[data-ac-sterren]');
var sel = rij ? rij.getAttribute('data-anker') : '[data-ac-rev]';
var marge = rij ? (parseInt(rij.getAttribute('data-offset'), 10) || 0) : 92;
function doel() {
var el = null;
try { el = document.querySelector(sel); } catch (f) { el = null; }
if (!el) { el = acRevSectie(); }
if (!el) { el = document.querySelector('[data-oke-container], .okeReviews, #okendo-reviews'); }
return el;
}
/* Een pagina schuift na het laden nog na. Daarom een paar keer
   bijsturen, maar alleen zolang de pagina nog precies staat waar wij hem
   hebben neergezet: heeft de bezoeker zelf gescrold, dan stopt het. */
var gezet = null;
function spring() {
if (gezet !== null && Math.abs(window.pageYOffset - gezet) > 4) { return; }
var d = doel();
if (!d) { return; }
var top = d.getBoundingClientRect().top + window.pageYOffset - marge;
if (top < 0) { top = 0; }
window.scrollTo({ top: top, behavior: 'auto' });
gezet = Math.round(window.pageYOffset);
}
spring();
[120, 400, 900, 1500].forEach(function (ms) { window.setTimeout(spring, ms); });
window.addEventListener('load', spring);
}
function init() {
document.querySelectorAll('[data-ac-sterren]:not([data-klaar])').forEach(function (rij) {
rij.setAttribute('data-klaar', '1');
var data = {};
try { data = JSON.parse(rij.getAttribute('data-ok') || '{}') || {}; } catch (e) { data = {}; }
/* De optelling van Okendo is leidend. Ontbreekt die, dan rekenen wij
   hem uit de losse reviews, zodat er altijd iets klopt. */
var a = data.reviewAggregate || {};
var lijst = (data.reviews || []).filter(function (r) { return r && r.rating != null; });
var n = a.ratingAndReviewCount != null ? a.ratingAndReviewCount : lijst.length;
if (!n) { return; }
var som = a.ratingAndReviewValuesTotal;
if (som == null) { som = lijst.reduce(function (t, r) { return t + (r.rating || 0); }, 0); }
var gem = som / n;
if (!isFinite(gem) || gem <= 0) { return; }
var PAD = 'm12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.9L12 17.8 5.8 21l1.2-6.9-5-4.9 6.9-1z';
function svg(soort) {
return '<svg class="ac-ster-rij__ster is-' + soort + '" viewBox="0 0 24 24" aria-hidden="true"><path d="' + PAD + '"></path></svg>';
}
function ster(v) {
if (v >= 0.75) { return svg('vol'); }
if (v >= 0.25) { return '<span class="ac-ster-rij__half">' + svg('leeg') + svg('vol') + '</span>'; }
return svg('leeg');
}
var sterren = '';
for (var i = 1; i <= 5; i++) { sterren += ster(gem - i + 1); }
var cijfer = (Math.round(gem * 10) / 10).toFixed(1).replace('.', ',');
var woord = n === 1 ? rij.getAttribute('data-een') : rij.getAttribute('data-meer');
var label = cijfer + ' ' + rij.getAttribute('data-vanwoord') + ' 5, ' + n + ' ' + woord;
var binnen = '<span class="ac-ster-rij__sterren" role="img" aria-label="' + label.replace(/"/g, '&quot;') + '">' + sterren + '</span>' +
'<span class="ac-ster-rij__cijfer">' + cijfer + '</span>' +
'<span class="ac-ster-rij__aantal">' + n + ' ' + woord + '</span>';
/* Doel zoeken op een kenmerk, niet op een sectie-id: dat id verandert
   zodra een sectie wordt gedupliceerd of verplaatst. */
function doel() {
var sel = rij.getAttribute('data-anker');
var el = null;
try { el = document.querySelector(sel); } catch (f) { el = null; }
if (!el) { el = acRevSectie(); }
if (!el) { el = document.querySelector('[data-oke-container], .okeReviews, #okendo-reviews'); }
if (el && el.contains(rij)) { el = null; }
return el;
}
if (doel()) {
var knop = document.createElement('button');
knop.type = 'button';
knop.className = 'ac-ster-rij__knop';
knop.innerHTML = binnen;
knop.addEventListener('click', function () {
var d = doel();
if (!d) { return; }
var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var offset = parseInt(rij.getAttribute('data-offset'), 10) || 0;
var top = d.getBoundingClientRect().top + window.pageYOffset - offset;
window.scrollTo({ top: top < 0 ? 0 : top, behavior: stil ? 'auto' : 'smooth' });
});
rij.appendChild(knop);
} else {
rij.innerHTML = binnen;
}
rij.hidden = false;
});
haakHash();
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-pdp-prijs ===== */
(function () {
  var start = function () {
    var blokken = document.querySelectorAll('[data-ac-price-widget]');
    if (!blokken.length) { return; }
    var bedrag = function (centen) {
      centen = Number(centen || 0);
      var delen = (centen / 100).toFixed(2).split('.');
      return '€' + delen[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + delen[1];
    };
    var bij = function (blok, variantId) {
      var bronEl = blok.querySelector('[data-ac-variant-prices]');
      if (!bronEl || !variantId) { return; }
      var prijzen = {};
      try { prijzen = JSON.parse(bronEl.textContent); } catch (e) { return; }
      var data = prijzen[variantId];
      if (!data) { return; }
      var prijs = Number(data.price || 0);
      var vanaf = Number(data.compare_at_price || 0);
      var nuEl = blok.querySelector('[data-ac-current-price]');
      var subEl = blok.querySelector('[data-ac-sub]');
      var oudEl = blok.querySelector('[data-ac-old-price]');
      var besparingEl = blok.querySelector('[data-ac-saving-badge]');
      var label = blok.getAttribute('data-save-text') || 'Bespaar';
      if (nuEl) { nuEl.textContent = bedrag(prijs); }
      if (vanaf > prijs) {
        if (oudEl) { oudEl.textContent = bedrag(vanaf); }
        if (besparingEl) { besparingEl.textContent = label + ' ' + bedrag(vanaf - prijs); }
        if (subEl) { subEl.style.display = 'flex'; }
      } else if (subEl) {
        subEl.style.display = 'none';
      }
    };
    var huidig = function () {
      var aangevinkt = document.querySelector('form[action*="/cart/add"] input[name="id"]:checked');
      if (aangevinkt && aangevinkt.value) { return aangevinkt.value; }
      var keuze = document.querySelector('form[action*="/cart/add"] select[name="id"]');
      if (keuze && keuze.value) { return keuze.value; }
      var verborgen = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (verborgen && verborgen.value) { return verborgen.value; }
      return new URLSearchParams(window.location.search).get('variant');
    };
    var alles = function (variantId) {
      if (!variantId) { return; }
      blokken.forEach(function (blok) { bij(blok, variantId); });
    };
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant && e.detail.variant.id) { alles(e.detail.variant.id); }
    });
    document.addEventListener('change', function (e) {
      if (!e.target) { return; }
      if (e.target.name === 'id' || e.target.closest('variant-selects') || e.target.closest('variant-radios') || e.target.closest('[data-product-form]')) {
        setTimeout(function () { alles(huidig()); }, 80);
      }
    });
    document.addEventListener('click', function () {
      setTimeout(function () { alles(huidig()); }, 120);
    });
    alles(huidig());
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ===== ac-pdp-knoppen ===== */
/* Rekent de resterende tijd tot ac_verwacht uit (einde van die dag,
   Nederlandse tijd) en ververst elk uur. Geen seconden: dit is een
   verwachting, geen aftelklok. */
(function () {
function init() {
document.querySelectorAll('[data-ac-po-verwacht]:not([data-ac-po-klaar])').forEach(function (box) {
box.setAttribute('data-ac-po-klaar', '1');
var uit = box.querySelector('[data-ac-po-tekst]'), T = {};
if (!uit) { return; }
try { T = JSON.parse(box.nextElementSibling.textContent); } catch (e) { return; }
var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(box.getAttribute('data-ac-po-verwacht') || '');
if (!m) return;
var doel = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10), 23, 59, 59).getTime();
var metUren = box.getAttribute('data-ac-po-uren') !== 'uit';
function zet() {
var rest = doel - Date.now(), tekst;
if (rest <= 0) { tekst = T.voorbij; }
else {
var uren = Math.floor(rest / 3600000), dagen = Math.floor(uren / 24), h = uren % 24;
if (uren < 1) { tekst = T.vandaag; }
else if (dagen < 1) { tekst = T.uren.replace('{h}', uren); }
else if (metUren && h > 0) { tekst = (dagen === 1 ? T.daguren : T.dagenuren.replace('{d}', dagen)).replace('{h}', h); }
else if (dagen === 1) { tekst = T.dag; }
else { tekst = T.dagen.replace('{d}', dagen); }
}
if (uit.textContent !== tekst) { uit.textContent = tekst; }
}
zet();
setInterval(zet, 60000);
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-pdp-knoppen ===== */
/* De bestelknop legt één exemplaar in de winkelwagen en opent de
   winkelwagen van het thema. Lukt dat niet, dan gaat hij naar /cart, zodat
   er nooit een klik verloren gaat. */
(function () {
function init() {
document.querySelectorAll('[data-ac-po-bestel]:not([data-ac-po-klaar])').forEach(function (knop) {
knop.setAttribute('data-ac-po-klaar', '1');
knop.addEventListener('click', function () {
var id = knop.getAttribute('data-variant-id');
if (!id || knop.disabled) { return; }
knop.classList.add('is-bezig');
knop.disabled = true;
fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: 1 }) })
.then(function (r) { if (!r.ok) { throw new Error('toevoegen mislukt'); } return r.json(); })
.then(function () {
document.dispatchEvent(new CustomEvent('cart:refresh'));
document.dispatchEvent(new CustomEvent('cart:updated'));
var lade = document.querySelector('cart-drawer') || document.querySelector('[data-cart-drawer]') || document.querySelector('.cart-drawer');
if (lade && typeof lade.open === 'function') { lade.open(); } else { window.location.href = '/cart'; }
})
.catch(function () { window.location.href = '/cart/add?id=' + id + '&quantity=1'; })
.finally(function () { knop.classList.remove('is-bezig'); knop.disabled = false; });
});
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* ####### SECTIES ####### */

/* ===== ac-pd ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var knop = sec.querySelector('[data-ac-pd-knop]');
var paneel = sec.querySelector('[data-ac-pd-paneel]');
if(knop && paneel){
knop.addEventListener('click', function(){
var open = paneel.classList.contains('is-open');
paneel.classList.toggle('is-open', !open);
knop.classList.toggle('is-open', !open);
knop.setAttribute('aria-expanded', open ? 'false' : 'true');
});
}
var kop = sec.querySelector('[data-ac-pd-kop]');
var binnen = sec.querySelector('.ac-pd__in');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-pd__kern') || k.classList.contains('ac-pd__semi'))){ k.setAttribute('data-accent','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-pd__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-pd__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-pd]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-stretch ===== */
/* Breedtehelper, alleen voor deze sectie en alleen op desktop. Shopify
   zet een Custom Liquid-sectie in een container die smaller is dan het
   scherm. Bij een witte sectie ziet u dat niet, bij een ruimtezwarte
   wordt het een vierkant met witte stroken ernaast. Hoeveel dat is
   verschilt per thema, dus dit meet het op. Onder 750px doet het niets
   en zet het zijn eigen aanpassingen terug. */
(function () {
  if (window.__acStretchBreed) { return; }
  window.__acStretchBreed = true;
  var GRENS = 750;
  function pas() {
    var breed = document.documentElement.clientWidth;
    document.querySelectorAll('.ac-stretch--breed').forEach(function (sec) {
      sec.style.marginLeft = '';
      sec.style.marginRight = '';
      sec.style.width = '';
      sec.style.maxWidth = '';
      if (breed < GRENS) { return; }
      var node = sec.parentElement;
      while (node && node !== document.body) {
        var cs = getComputedStyle(node);
        if (parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) ||
            parseFloat(cs.marginTop) || parseFloat(cs.marginBottom)) {
          node.style.paddingTop = '0px';
          node.style.paddingBottom = '0px';
          node.style.marginTop = '0px';
          node.style.marginBottom = '0px';
        }
        node = node.parentElement;
      }
      sec.style.width = 'auto';
      sec.style.maxWidth = 'none';
      var rect = sec.getBoundingClientRect();
      var links = rect.left;
      var rechts = breed - rect.right;
      if (links > 0.5) { sec.style.marginLeft = (-links) + 'px'; }
      if (rechts > 0.5) { sec.style.marginRight = (-rechts) + 'px'; }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', pas); }
  else { pas(); }
  window.addEventListener('load', pas);
  document.addEventListener('shopify:section:load', pas);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(pas, 120); });
})();

/* ===== ac-vid ===== */
(function () {
  var init = function () {
    document.querySelectorAll('.ac-video:not([data-ac-init])').forEach(function (root) {
      root.setAttribute('data-ac-init', '1');
      var video = root.querySelector('video');
      var bar = root.querySelector('.ac-vid__controls');
      var playBtn = root.querySelector('[data-ac-play]');
      var soundBtn = root.querySelector('[data-ac-sound]');
      if (!video || !bar) { return; }
      /* de knoppen verschijnen pas als JavaScript het overneemt */
      bar.hidden = false;
      /* wie beweging heeft uitgezet, krijgt hier een stilstaand beeld (§5.6) */
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.autoplay = false;
        video.pause();
      }
      var syncPlay = function () {
        root.classList.toggle('is-paused', video.paused);
        if (playBtn) {
          playBtn.setAttribute('aria-label', video.paused ? playBtn.dataset.labelPlay : playBtn.dataset.labelPause);
        }
      };
      var syncSound = function () {
        root.classList.toggle('is-unmuted', !video.muted);
        if (soundBtn) {
          soundBtn.setAttribute('aria-label', video.muted ? soundBtn.dataset.labelOn : soundBtn.dataset.labelOff);
        }
      };
      if (playBtn) {
        playBtn.addEventListener('click', function () {
          if (video.paused) { video.play(); } else { video.pause(); }
        });
      }
      if (soundBtn) {
        soundBtn.addEventListener('click', function () {
          video.muted = !video.muted;
          if (!video.muted && video.paused) { video.play(); }
          syncSound();
        });
      }
      video.addEventListener('play', syncPlay);
      video.addEventListener('pause', syncPlay);
      video.addEventListener('volumechange', syncSound);
      syncPlay();
      syncSound();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* de theme editor bouwt secties opnieuw op */
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-tblok ===== */
(function(){
  var wortel = document.querySelector('[data-ac-tblok]');
  if(!wortel) return;
  var panelen = wortel.querySelectorAll('.ac-tblok__paneel');
  var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(stil || !('IntersectionObserver' in window)){
    for(var i=0;i<panelen.length;i++){ panelen[i].classList.add('is-in'); }
    return;
  }
  var kijker = new IntersectionObserver(function(items){
    items.forEach(function(item){
      if(item.isIntersecting){ item.target.classList.add('is-in'); kijker.unobserve(item.target); }
    });
  },{ rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
  for(var j=0;j<panelen.length;j++){ kijker.observe(panelen[j]); }
})();

/* ===== ac-ms ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-ms]:not([data-ac-ready])').forEach(function (root) {
      root.setAttribute('data-ac-ready', '1');
      var videos = Array.prototype.slice.call(root.querySelectorAll('[data-ac-video]'));
      if (!videos.length) { return; }
      var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* §5.6: bij verminderde beweging spelen de video's niet;
         het posterbeeld blijft staan. */
      if (stil) { return; }
      /* Spelen alleen in beeld; daarbuiten pauzeren ze. Scheelt accu
         en de pagina blijft licht. */
      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (v) { v.play().catch(function () {}); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.play().catch(function () {}); } else { e.target.pause(); }
        });
      }, { threshold: 0.25 });
      videos.forEach(function (v) { io.observe(v); });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-specs ===== */
/* Uitklappen per groep. Op desktop staat de knop op display:none en staat
   alles al open; het script hoeft daar niets te doen. */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-specs]:not([data-ac-ready])').forEach(function (root) {
      root.setAttribute('data-ac-ready', '1');
      root.querySelectorAll('[data-ac-more]').forEach(function (btn) {
        var card = btn.closest('[data-ac-card]');
        var label = btn.querySelector('span');
        btn.addEventListener('click', function () {
          var open = card.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (label) { label.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore; }
        });
      });
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* Flush-helper. Shopify zet een Custom Liquid-sectie in een container die
   smaller is dan het scherm, met eigen ruimte eromheen. Bij een witte
   sectie zie je dat niet, bij een ruimtezwarte krijgt u stroken
   paginakleur links, rechts, boven en onder. Hoeveel dat is verschilt per
   thema en per instelling, dus dit meet het op en trekt de sectie door tot
   de rand. Draait één keer per pagina. */
(function () {
  if (window.__acCosmosFlush) return;
  window.__acCosmosFlush = true;
  function apply() {
    document.querySelectorAll('.ac-cosmos--flush').forEach(function (sec) {
      var node = sec.parentElement;
      while (node && node !== document.body) {
        var cs = getComputedStyle(node);
        if (parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) ||
            parseFloat(cs.marginTop)  || parseFloat(cs.marginBottom)) {
          node.style.paddingTop = '0px'; node.style.paddingBottom = '0px';
          node.style.marginTop = '0px';  node.style.marginBottom = '0px';
        }
        node = node.parentElement;
      }
      sec.style.marginLeft = ''; sec.style.marginRight = '';
      sec.style.width = 'auto'; sec.style.maxWidth = 'none';
      var rect = sec.getBoundingClientRect();
      var docWidth = document.documentElement.clientWidth;
      var left = rect.left, right = docWidth - rect.right;
      if (left  > 0.5) sec.style.marginLeft  = (-left)  + 'px';
      if (right > 0.5) sec.style.marginRight = (-right) + 'px';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  window.addEventListener('load', apply);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 120); });
})();

/* ===== ac-rev ===== */
(function () {
function init() {
document.querySelectorAll('[data-ac-rev]:not([data-ac-klaar])').forEach(function (root) {
root.setAttribute('data-ac-klaar', '1');
var T = JSON.parse(root.querySelector('[data-ac-rev-t]').textContent);
var loc = root.getAttribute('data-loc') || 'nl-NL';
var data = {};
try { data = JSON.parse(root.getAttribute('data-ac-rev-data') || '{}') || {}; } catch (fout) { data = {}; }
var alles = (data.reviews || []).filter(function (r) { return r && r.body != null; });
var elSamen = root.querySelector('[data-ac-rev-samen]');
var elFilters = root.querySelector('[data-ac-rev-filters]');
var elPijlen = root.querySelector('[data-ac-rev-pijlen]');
var spoor = root.querySelector('[data-ac-rev-spoor]');
var licht = root.querySelector('[data-ac-rev-licht]');
var lichtBeeld = root.querySelector('[data-ac-rev-lichtbeeld]');
var alleenFoto = false;
var STERPAD = 'm12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.9L12 17.8 5.8 21l1.2-6.9-5-4.9 6.9-1z';

function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}

/* §4.2: de hele ster is champagne, gevuld of niet. Vol is een vlak, half
   is links gevuld en rechts contour, leeg is alleen de contourlijn.
   Nooit een grijze of lichtgrijze lege ster: dat maakt er twee kleuren
   van. */
function ster(soort, hoog) {
var maat = ' style="width:' + hoog + 'px;height:' + hoog + 'px"';
var vol = '<svg class="ac-rev__ster is-vol" viewBox="0 0 24 24" aria-hidden="true"' + maat + '><path d="' + STERPAD + '"></path></svg>';
var leeg = '<svg class="ac-rev__ster is-leeg" viewBox="0 0 24 24" aria-hidden="true"' + maat + '><path d="' + STERPAD + '"></path></svg>';
if (soort === 'vol') { return vol; }
if (soort === 'leeg') { return leeg; }
return '<span class="ac-rev__ster-half"' + maat + '>' + leeg + vol + '</span>';
}

function sterren(waarde, hoog) {
var uit = '';
for (var i = 1; i <= 5; i++) {
var v = waarde - i + 1;
uit += ster(v >= 0.75 ? 'vol' : (v >= 0.25 ? 'half' : 'leeg'), hoog);
}
return '<span class="ac-rev__sterren" role="img" aria-label="' + (Math.round(waarde * 10) / 10) + ' / 5">' + uit + '</span>';
}

function datum(iso) {
var d = new Date(iso);
if (isNaN(d.getTime())) { return ''; }
return d.toLocaleDateString(loc, { day: 'numeric', month: 'long', year: 'numeric' });
}

function initialen(naam) {
return String(naam || '?').trim().split(/\s+/).slice(0, 2).map(function (w) { return w.charAt(0); }).join('').toUpperCase();
}

/* De optelling van Okendo is leidend. Ontbreekt die, dan rekenen wij hem
   uit de reviews zelf, zodat er altijd iets klopt. */
function optelling() {
var a = data.reviewAggregate || {};
var n = a.ratingAndReviewCount || alles.length;
if (!n) { return null; }
var som = a.ratingAndReviewValuesTotal;
if (som == null) { som = alles.reduce(function (t, r) { return t + (r.rating || 0); }, 0); }
var aanbevolen = a.recommendationCount;
if (aanbevolen == null) { aanbevolen = alles.filter(function (r) { return r.isRecommended; }).length; }
return { n: n, gem: som / n, aanbevolen: aanbevolen };
}

function tekenSamen() {
var o = optelling();
if (!o) { elSamen.innerHTML = '<p class="ac-rev__leeg">' + esc(T.leeg) + '</p>'; return; }
var pct = o.n ? Math.round(o.aanbevolen / o.n * 100) : 0;
elSamen.innerHTML =
'<span class="ac-rev__cijfer">' + o.gem.toFixed(1).replace('.', ',') + '</span>' +
'<span class="ac-rev__cijferbij">' + sterren(o.gem, 17) +
'<span class="ac-rev__aantal">' + o.n + ' ' + esc(T.op) +
(o.aanbevolen ? '<b>' + pct + '% ' + esc(T.aanbevolen) + '</b>' : '') + '</span></span>';
}

function tekenFilters() {
var metFoto = alles.filter(function (r) { return r.media && r.media.length; }).length;
if (!metFoto || alles.length < 3) { elFilters.hidden = true; return; }
elFilters.hidden = false;
elFilters.innerHTML =
'<button type="button" class="ac-rev__chip' + (alleenFoto ? '' : ' is-aan') + '" data-foto="0">' + esc(T.alle) + ' (' + alles.length + ')</button>' +
'<button type="button" class="ac-rev__chip' + (alleenFoto ? ' is-aan' : '') + '" data-foto="1">' + esc(T.metfoto) + ' (' + metFoto + ')</button>';
}

function lijst() {
var uit = alles.slice();
if (alleenFoto) { uit = uit.filter(function (r) { return r.media && r.media.length; }); }
uit.sort(function (a, b) { return new Date(b.dateCreated) - new Date(a.dateCreated); });
return uit;
}

function tekenSpoor() {
var rij = lijst();
/* Bij drie of minder wordt het een rij, anders staat de tweede half leeg. */
spoor.style.gridTemplateRows = rij.length > 3 ? 'repeat(2, minmax(0, 1fr))' : 'minmax(0, 1fr)';
spoor.innerHTML = rij.map(function (r) {
var rv = r.reviewer || {};
var avatar = rv.avatarUrl
? '<span class="ac-rev__avatar"><img src="' + esc(rv.avatarUrl) + '" alt="" loading="lazy"></span>'
: '<span class="ac-rev__avatar ac-rev__avatar--letters">' + esc(initialen(rv.displayName)) + '</span>';

/* De foto is geen bijlage onderaan maar de kop van de kaart. Meer dan
   één foto: de eerste vult de kop, de rest zit onder een telbadge. */
var fotos = (r.media || []).filter(function (m) { return m.thumbnailUrl; });
var kop = '';
if (fotos.length) {
var eerste = fotos[0];
kop = '<button type="button" class="ac-rev__beeld" data-groot="' + esc(eerste.largeUrl || eerste.fullSizeUrl) + '">' +
'<img src="' + esc(eerste.largePortraitThumbnailUrl || eerste.largeUrl || eerste.thumbnailUrl) + '" alt="' + esc(eerste.alt || '') + '" loading="lazy">' +
(fotos.length > 1 ? '<span class="ac-rev__telbadge">+' + (fotos.length - 1) + '</span>' : '') +
'</button>';
}

var regels = String(r.body || '').split(/\n+/).filter(function (t) { return t.trim(); })
.map(function (t) { return '<span>' + esc(t) + '</span>'; }).join('');

return '<article class="ac-rev__kaart' + (fotos.length ? ' ac-rev__kaart--beeld' : '') + '">' + kop +
'<div class="ac-rev__body">' +
'<div class="ac-rev__meta">' + sterren(r.rating || 0, 13) + '<time>' + esc(datum(r.dateCreated)) + '</time></div>' +
(r.title && r.title.trim() ? '<h3 class="ac-rev__kaarttitel">' + esc(r.title.trim()) + '</h3>' : '') +
'<div class="ac-rev__tekst" data-ac-rev-tekst>' + regels + '</div>' +
'<button type="button" class="ac-rev__uitklap" data-ac-rev-uit hidden>' + esc(T.meerlezen) + '</button>' +
'<footer class="ac-rev__voetregel">' + avatar +
'<span class="ac-rev__wie"><strong>' + esc(rv.displayName || '') + '</strong>' +
'<em>' + (rv.isVerified ? esc(T.geverifieerd) : (r.helpfulCount ? r.helpfulCount + ' ' + esc(T.nuttig) : '')) + '</em></span></footer>' +
'</div></article>';
}).join('');

/* Alleen een uitklapknop tonen waar de tekst werkelijk niet past. */
spoor.querySelectorAll('[data-ac-rev-tekst]').forEach(function (el) {
if (el.scrollHeight > el.clientHeight + 2) { el.nextElementSibling.hidden = false; }
});

setTimeout(pijlen, 60);
}

/* De pijlen verdwijnen als alles al past. Niets is vervelender dan een
   pijl die nergens heen gaat. */
function pijlen() {
elPijlen.hidden = spoor.scrollWidth <= spoor.clientWidth + 4;
}

function schuif(kant) {
var stap = Math.max(240, Math.round(spoor.clientWidth * 0.8));
var zacht = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
spoor.scrollBy({ left: kant * stap, behavior: zacht ? 'smooth' : 'auto' });
}

root.querySelector('[data-ac-rev-links]').addEventListener('click', function () { schuif(-1); });
root.querySelector('[data-ac-rev-rechts]').addEventListener('click', function () { schuif(1); });
window.addEventListener('resize', function () { clearTimeout(root.__t); root.__t = setTimeout(pijlen, 150); });

/* Slepen met de muis. Op een aanraakscherm doet de browser dit zelf. */
var sleept = false, startX = 0, startL = 0, bewogen = false;

spoor.addEventListener('pointerdown', function (e) {
if (e.pointerType === 'touch') { return; }
sleept = true;
bewogen = false;
startX = e.clientX;
startL = spoor.scrollLeft;
spoor.classList.add('is-sleep');
});

window.addEventListener('pointermove', function (e) {
if (!sleept) { return; }
var d = e.clientX - startX;
if (Math.abs(d) > 3) { bewogen = true; }
spoor.scrollLeft = startL - d;
});

window.addEventListener('pointerup', function () {
if (!sleept) { return; }
sleept = false;
spoor.classList.remove('is-sleep');
});

spoor.addEventListener('click', function (e) {
if (bewogen) {
e.preventDefault();
e.stopPropagation();
}
}, true);

elFilters.addEventListener('click', function (e) {
var b = e.target.closest('[data-foto]');
if (!b) { return; }
alleenFoto = b.getAttribute('data-foto') === '1';
spoor.scrollLeft = 0;
tekenFilters();
tekenSpoor();
});

spoor.addEventListener('click', function (e) {
var uit = e.target.closest('[data-ac-rev-uit]');
if (uit) {
uit.previousElementSibling.classList.add('is-open');
uit.hidden = true;
setTimeout(pijlen, 60);
return;
}
var b = e.target.closest('.ac-rev__beeld');
if (!b) { return; }
lichtBeeld.src = b.getAttribute('data-groot');
licht.hidden = false;
document.body.style.overflow = 'hidden';
});

function dicht() {
licht.hidden = true;
lichtBeeld.src = '';
document.body.style.overflow = '';
}

licht.addEventListener('click', dicht);
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape' && !licht.hidden) { dicht(); }
});

if (!alles.length) {
root.classList.add('ac-rev--leeg');
}

tekenSamen();
tekenFilters();
tekenSpoor();
});
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}

document.addEventListener('shopify:section:load', init);
})();

(function(){
function plak(){
document.querySelectorAll('.ac-rev').forEach(function(k){
var w=k.closest('.shopify-section')||k.parentElement;
if(!w)return;
w.style.marginBottom='0px';
var b=w.nextElementSibling;
if(b)b.style.marginTop='0px'
})
}
if(document.readyState==='loading'){
document.addEventListener('DOMContentLoaded',plak)
}else{
plak()
}
window.addEventListener('load',plak)
})();

/* Flush-helper: meet de ruimte van de thema-wrapper en trekt de sectie
   door tot de rand van de pagina. Draait één keer per pagina. */

/* ===== ac-vp ===== */
(function(){
  var sec=document.querySelector('[data-ac-vp]:not([data-klaar])');
  if(!sec) return;
  sec.setAttribute('data-klaar','1');
  var LIVE=JSON.parse(sec.querySelector('[data-vp-live]').textContent);
  var D=JSON.parse(sec.querySelector('[data-vp-data]').textContent);
  var T=D.t, S=D.stoelen;
  var ORDE=['pluto','nova','luna','astron','pulsar','atlas','titan'];
  var zelf=sec.getAttribute('data-zelf');
  function esc(x){return String(x==null?'':x).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function niv(id){var v=String(S[id].i).split('|')[0];return v==='*'?5:(parseInt(v,10)||0);}
  /* Buren op de intensiteitsladder: de dichtstbijzijnde zachtere en de
     dichtstbijzijnde stevigere stoel. */
  var i0=ORDE.indexOf(zelf);
  var zachter=null, steviger=null;
  for(var i=i0-1;i>=0;i--){ if(niv(ORDE[i])<niv(zelf)){zachter=ORDE[i];break;} }
  for(var j=i0+1;j<ORDE.length;j++){ if(niv(ORDE[j])>niv(zelf)){steviger=ORDE[j];break;} }
  /* Staat de stoel aan een uiteinde van de ladder, dan bestaat één van de
     twee buren niet. We vullen aan met de dichtstbijzijnde andere stoel en
     geven die een neutraal label. */
  var lZacht = T.zachter, lStevig = T.steviger;
  if(!zachter){
    for(var a=0;a<ORDE.length;a++){ if(ORDE[a]!==zelf && ORDE[a]!==steviger){ zachter=ORDE[a]; break; } }
    lZacht = T.ook;
  }
  if(!steviger){
    for(var b=ORDE.length-1;b>=0;b--){ if(ORDE[b]!==zelf && ORDE[b]!==zachter){ steviger=ORDE[b]; break; } }
    lStevig = T.ook;
  }
  /* Een sterretje in plaats van een cijfer betekent: instelbaar over de hele
     schaal. Vier volle blokjes zouden "altijd maximaal" zeggen, en dat is
     niet hetzelfde (§1.6). Daarom een eigen oplopende stand. */
  function meter(v){
    var d=String(v).split('|'), vrij=d[0]==='*', n=parseInt(d[0],10)||0, bl='';
    for(var k=1;k<=4;k++){bl+='<i'+(vrij?' class="is-vrij"':(k<=n?' class="is-aan"':''))+'></i>';}
    return '<span class="ac-vp__meter"><span class="ac-vp__mblok'+(vrij?' is-vrijrij':'')+'">'+bl+'</span>'+esc(d[1]||'')+'</span>';
  }
  /* De hele buurkaart is de link. Op een telefoon is dat een doel van
     ruim 250 pixels hoog in plaats van één tekstregel. De kaart die de
     bezoeker al bekijkt krijgt bewust geen link. */
  function kaart(id,vlag,isZelf){
    var s=S[id]||{}, c=LIVE[id]||{};
    var tag = (isZelf||!c.url) ? 'div' : 'a';
    var attr = tag==='a' ? ' href="'+esc(c.url)+'"' : '';
    return '<'+tag+attr+' class="ac-vp__kaart'+(isZelf?' ac-vp__kaart--zelf':'')+'">'
      +'<span class="ac-vp__vlag">'+esc(vlag)+'</span>'
      +'<div class="ac-vp__top">'
      +(c.img?'<img class="ac-vp__foto" src="'+esc(c.img)+'" alt="" loading="lazy" decoding="async">':'')
      +'<span class="ac-vp__wie"><span class="ac-vp__naam">'+esc(s.n)+'</span>'
      +'<span class="ac-vp__prijs">'+esc(c.prijs||'')+'</span>'
      +'<span class="ac-vp__status '+(c.op?'is-op':'is-pre')+'">'+esc(c.op?T.op:T.pre)+'</span></span></div>'
      +'<dl class="ac-vp__regels">'
      +'<div><dt>'+esc(T.sys)+'</dt><dd>'+esc(s.sys)+'</dd></div>'
      +'<div><dt>'+esc(T.int)+'</dt><dd>'+meter(s.i)+'</dd></div>'
      +'<div><dt>'+esc(T.diep)+'</dt><dd>'+esc(s.d)+'</dd></div>'
      +'<div><dt>'+esc(T.breed)+'</dt><dd>'+esc(s.b)+'</dd></div>'
      +'<div><dt>'+esc(T.kg)+'</dt><dd'+(s.kg==='–'?' class="is-leeg"':'')+'>'+esc(s.kg)+'</dd></div>'
      +'</dl>'
      +(tag==='a'?'<span class="ac-vp__link">'+esc(T.naar)+' '+esc(s.n)+' &rarr;</span>':'')
      +'</'+tag+'>';
  }
  var rij = sec.querySelector('[data-vp-rij]');
  rij.innerHTML = kaart(zachter,lZacht,false) + kaart(zelf,T.deze,true) + kaart(steviger,lStevig,false);
  sec.querySelector('[data-vp-knop]').textContent = T.knop;
  var kaarten = Array.prototype.slice.call(rij.children);
  var namen = [S[zachter].n, S[zelf].n, S[steviger].n];
  /* ---- stippen ----
     Bij drie kaarten is dit het verschil tussen "er staat iets naast" en
     "ik zie niet dat er iets naast staat". Ze zijn ook aanklikbaar. */
  var bak = sec.querySelector('[data-vp-stippen]');
  bak.innerHTML = kaarten.map(function(k,i){
    return '<button type="button" class="ac-vp__stip" data-i="'+i+'" aria-label="'+esc(namen[i]+' '+T.stip)+'"></button>';
  }).join('');
  bak.hidden = false;
  var stippen = Array.prototype.slice.call(bak.children);
  function mobiel(){ return window.matchMedia('(max-width: 749px)').matches; }
  function naarKaart(i, zacht){
    var k = kaarten[i];
    if(!k) return;
    var doel = k.offsetLeft - (rij.clientWidth - k.offsetWidth) / 2;
    if(zacht && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      rij.scrollTo({ left: doel, behavior: 'smooth' });
    } else {
      rij.scrollLeft = doel;
    }
  }
  function markeer(){
    var mid = rij.scrollLeft + rij.clientWidth / 2;
    var beste = 0, kleinste = Infinity;
    kaarten.forEach(function(k,i){
      var c = k.offsetLeft + k.offsetWidth / 2;
      var afstand = Math.abs(c - mid);
      if(afstand < kleinste){ kleinste = afstand; beste = i; }
    });
    stippen.forEach(function(s,i){ s.setAttribute('aria-current', i===beste ? 'true' : 'false'); });
  }
  stippen.forEach(function(s){
    s.addEventListener('click', function(){ naarKaart(parseInt(s.getAttribute('data-i'),10), true); });
  });
  /* ---- startpositie ----
     Hier ging v2 de mist in: de scrollpositie verzetten terwijl
     scroll-snap op "mandatory" staat, laat de browser meteen terugtrekken
     naar zijn eigen ankerpunt. Het snappen gaat daarom even uit, de
     positie wordt gezet, en daarna gaat het weer aan. */
  function start(){
    if(!mobiel()){ rij.scrollLeft = 0; markeer(); return; }
    rij.classList.add('is-vrij');
    naarKaart(1, false);
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        rij.classList.remove('is-vrij');
        markeer();
      });
    });
  }
  var tik;
  rij.addEventListener('scroll', function(){
    clearTimeout(tik);
    tik = setTimeout(markeer, 60);
  }, { passive: true });
  /* Pijltjes links en rechts voor wie met het toetsenbord werkt. */
  rij.addEventListener('keydown', function(e){
    var huidig = stippen.findIndex(function(s){ return s.getAttribute('aria-current')==='true'; });
    if(huidig < 0) huidig = 0;
    if(e.key === 'ArrowRight'){ e.preventDefault(); naarKaart(Math.min(huidig+1, kaarten.length-1), true); }
    if(e.key === 'ArrowLeft'){ e.preventDefault(); naarKaart(Math.max(huidig-1, 0), true); }
  });
  start();
  var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(start, 150); });
})();

/* ===== ac-faq ===== */

(function () {
function init() {
document.querySelectorAll('[data-ac-faq]').forEach(function (root) {
if (root.dataset.acReady === '1') return;
root.dataset.acReady = '1';
var items = Array.prototype.slice.call(root.querySelectorAll('.ac-faq__item'));
items.forEach(function (item) {
item.addEventListener('toggle', function () {
if (!item.open) return;
items.forEach(function (other) {
if (other !== item) other.open = false;
});
});
});
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

/* ===== ac-xs ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-xs]:not([data-ac-ready])').forEach(function (root) {
      root.setAttribute('data-ac-ready', '1');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ac-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ac-panel]'));
      if (!tabs.length) { return; }
      var select = function (key) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-ac-tab') === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          if (p.getAttribute('data-ac-panel') === key) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
      };
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t.getAttribute('data-ac-tab')); });
        t.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = (i + 1) % tabs.length; }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = (i - 1 + tabs.length) % tabs.length; }
          if (next === null) { return; }
          e.preventDefault();
          select(tabs[next].getAttribute('data-ac-tab'));
          tabs[next].focus();
        });
      });
      /* Productpagina's alvast ophalen zodra een link wordt aangeraakt;
         de doorklik voelt daardoor direct. Elke URL maar een keer. */
      var geladen = {};
      root.querySelectorAll('.ac-xs__main, .ac-xs__var').forEach(function (link) {
        var laad = function () {
          if (!link.href || geladen[link.href]) { return; }
          geladen[link.href] = true;
          var l = document.createElement('link');
          l.rel = 'prefetch';
          l.href = link.href;
          document.head.appendChild(l);
        };
        link.addEventListener('mouseenter', laad);
        link.addEventListener('touchstart', laad, { passive: true });
      });
      /* Over een kleurvariant bewegen wisselt alvast de grote foto van
         het model. Klikken gaat naar de pagina van die kleur. */
      root.querySelectorAll('.ac-xs__card').forEach(function (card) {
        var groot = card.querySelector('.ac-xs__imgwrap img');
        if (!groot) { return; }
        card.querySelectorAll('.ac-xs__var[data-ac-img]').forEach(function (v) {
          v.addEventListener('mouseenter', function () {
            var bron = v.getAttribute('data-ac-img');
            if (!bron || groot.src === bron) { return; }
            groot.src = bron;
            groot.removeAttribute('srcset');
          });
        });
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== preorder ===== */
/* Vult het verborgen samenvattingsveld, zodat de mail leesbaar binnenkomt
   in plaats van als losse velden. */
(function () {
  function init() {
    document.querySelectorAll('.ac-preorder__form').forEach(function (form) {
      if (form.dataset.acReady === '1') return;
      form.dataset.acReady = '1';
      form.addEventListener('submit', function () {
        var summary = form.querySelector('[data-ac-summary]');
        if (!summary) return;
        function val(sel) {
          var el = form.querySelector(sel);
          return el && el.value ? el.value.trim() : '-';
        }
        function checked(name) {
          var el = form.querySelector('input[name="' + name + '"]:checked');
          return el ? el.value : '-';
        }
        /* De aankomstmaand hangt aan de gekozen kleur. Wij zetten hem in het
           verborgen veld en in de samenvatting, zodat in de mail staat welke
           maand de klant heeft gezien. */
        var kleurEl = form.querySelector('input[name="contact[Kleur]"]:checked');
        var eta = kleurEl ? (kleurEl.getAttribute('data-ac-eta') || '-') : '-';
        var etaVeld = form.querySelector('input[name="contact[Verwachte aankomst]"]');
        if (etaVeld) etaVeld.value = eta;
        summary.value = [
          'PRE-ORDER AANVRAAG, MASSAGESTOEL TITAN',
          '',
          'Productpagina: ' + val('input[name="contact[Productpagina]"]'),
          'Verwachte aankomst: ' + eta,
          '',
          'VOORDELEN:',
          /* Stond hier als ingebakken Liquid; komt nu van het data-attribuut op
             de sectie, zodat dit script in een gecachet bestand kan staan. */
          ((form.closest('[data-ac-prijsregel]') || { dataset: {} }).dataset.acPrijsregel || ''),
          '- Voorrang bij levering en installatie',
          '- 50% bij pre-order, 50% na levering',
          '',
          'GEGEVENS:',
          'Naam: ' + val('#ac-po-name'),
          'E-mail: ' + val('#ac-po-email'),
          'Telefoon: ' + val('#ac-po-phone'),
          'Kleur: ' + checked('contact[Kleur]'),
          'Aankomst bij deze kleur: ' + eta,
          'Levering: ' + val('#ac-po-delivery'),
          '',
          'NOTITIE:',
          val('#ac-po-note'),
          '',
          'Actie: neem contact op om de pre-order af te ronden.'
        ].join('\n');
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* Kopanimatie §4.8 — identiek blok in alle AlienComfort-secties, idempotent. */

/* Flush-helper: Shopify zet een Custom Liquid-sectie in een smallere
   container met eigen ruimte eromheen. Dit meet dat op en trekt de sectie
   door tot de rand. Draait één keer per pagina. */

/* ===== mini ===== */
/* Las de varianten uit ingebakken Liquid; nu uit het JSON-blok in de sectie,
   zodat dit script in een gecachet bestand kan staan. De melding bij een
   mislukte poging staat in de balk zelf in plaats van in een alert(): een
   alert blokkeert de pagina en leest als een foutmelding van de browser. */
(function () {
  function init() {
    document.querySelectorAll('[data-ac-mini]:not([data-ac-ready])').forEach(function (root) {
      root.setAttribute('data-ac-ready', '1');
      var btn = root.querySelector('[data-ac-mini-btn]');
      var bron = root.querySelector('[data-ac-mini-data]');
      if (!btn || !bron) { return; }
      var data;
      try { data = JSON.parse(bron.textContent); } catch (e) { return; }
      var ids = (data.varianten || []).map(String);

      function variant() {
        var uit = new URLSearchParams(window.location.search).get('variant');
        if (uit && ids.indexOf(String(uit)) !== -1) { return uit; }
        var veld = document.querySelector('product-form form[action*="/cart/add"] input[name="id"]');
        if (veld && veld.value && ids.indexOf(String(veld.value)) !== -1) { return veld.value; }
        return data.terugval;
      }

      btn.addEventListener('click', function () {
        btn.disabled = true;
        btn.textContent = btn.dataset.bezig || 'Toevoegen...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variant(), quantity: 1 })
        }).then(function (r) {
          if (!r.ok) { throw new Error('toevoegen mislukt'); }
          return r.json();
        }).then(function () {
          window.location.href = '/cart';
        }).catch(function () {
          btn.disabled = false;
          btn.textContent = btn.dataset.fout || 'Niet gelukt';
          setTimeout(function () { btn.textContent = btn.dataset.label || 'In winkelwagen'; }, 3000);
        });
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== knoppen-preorder ===== */
/* Rekent de resterende tijd tot ac_verwacht uit (einde van die dag,
   Nederlandse tijd) en ververst elk uur. Geen seconden: dit is een
   verwachting, geen aftelklok. */
(function () {
function init() {
document.querySelectorAll('[data-ac-po-verwacht-p]:not([data-ac-po-klaar-p])').forEach(function (box) {
box.setAttribute('data-ac-po-klaar-p', '1');
var uit = box.querySelector('[data-ac-po-tekst-p]'), T = {};
if (!uit) { return; }
try { T = JSON.parse(box.nextElementSibling.textContent); } catch (e) { return; }
var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(box.getAttribute('data-ac-po-verwacht-p') || '');
if (!m) return;
var doel = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10), 23, 59, 59).getTime();
var metUren = box.getAttribute('data-ac-po-uren-p') !== 'uit';
function zet() {
var rest = doel - Date.now(), tekst;
if (rest <= 0) { tekst = T.voorbij; }
else {
var uren = Math.floor(rest / 3600000), dagen = Math.floor(uren / 24), h = uren % 24;
if (uren < 1) { tekst = T.vandaag; }
else if (dagen < 1) { tekst = T.uren.replace('{h}', uren); }
else if (metUren && h > 0) { tekst = (dagen === 1 ? T.daguren : T.dagenuren.replace('{d}', dagen)).replace('{h}', h); }
else if (dagen === 1) { tekst = T.dag; }
else { tekst = T.dagen.replace('{d}', dagen); }
}
if (uit.textContent !== tekst) { uit.textContent = tekst; }
}
zet();
setInterval(zet, 60000);
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* De bestelknop legt één exemplaar in de winkelwagen en opent de
   winkelwagen van het thema. Lukt dat niet, dan gaat hij naar /cart, zodat
   er nooit een klik verloren gaat. */
(function () {
function init() {
document.querySelectorAll('[data-ac-po-bestel-p]:not([data-ac-po-klaar-p])').forEach(function (knop) {
knop.setAttribute('data-ac-po-klaar-p', '1');
knop.addEventListener('click', function () {
var id = knop.getAttribute('data-variant-id');
if (!id || knop.disabled) { return; }
knop.classList.add('is-bezig');
knop.disabled = true;
fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: 1 }) })
.then(function (r) { if (!r.ok) { throw new Error('toevoegen mislukt'); } return r.json(); })
.then(function () {
document.dispatchEvent(new CustomEvent('cart:refresh'));
document.dispatchEvent(new CustomEvent('cart:updated'));
var lade = document.querySelector('cart-drawer') || document.querySelector('[data-cart-drawer]') || document.querySelector('.cart-drawer');
if (lade && typeof lade.open === 'function') { lade.open(); } else { window.location.href = '/cart'; }
})
.catch(function () { window.location.href = '/cart/add?id=' + id + '&quantity=1'; })
.finally(function () { knop.classList.remove('is-bezig'); knop.disabled = false; });
});
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* De pre-orderknop scrolt naar het formulier op dezelfde pagina. Staat dat
   er niet, dan doet de knop niets in plaats van naar een lege plek te
   springen. Bij prefers-reduced-motion springt de pagina er direct heen. */
(function () {
function init() {
document.querySelectorAll('[data-ac-po-spring-p]:not([data-ac-po-klaar-p])').forEach(function (knop) {
knop.setAttribute('data-ac-po-klaar-p', '1');
var doelId = knop.getAttribute('data-ac-po-spring-p') || '';
var zacht = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
knop.addEventListener('click', function (e) {
var doel = doelId ? document.querySelector(doelId) : null;
if (!doel) { e.preventDefault(); return; }
e.preventDefault();
doel.scrollIntoView({ behavior: zacht ? 'smooth' : 'auto', block: 'start' });
if (history.replaceState) { history.replaceState(null, '', doelId); }
});
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-atlas-opening ===== */
/* Kopanimatie §4.8 — identiek blok in alle AlienComfort-secties, idempotent. */

/* ===== ac-atlas-beschrijving ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var knop = sec.querySelector('[data-ac-pd-knop-a]');
var paneel = sec.querySelector('[data-ac-pd-paneel-a]');
if(knop && paneel){
knop.addEventListener('click', function(){
var open = paneel.classList.contains('is-open');
paneel.classList.toggle('is-open', !open);
knop.classList.toggle('is-open', !open);
knop.setAttribute('aria-expanded', open ? 'false' : 'true');
});
}
var kop = sec.querySelector('[data-ac-pd-kop-a]');
var binnen = sec.querySelector('.ac-pd-a__in');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-pd-a__kern') || k.classList.contains('ac-pd-a__semi'))){ k.setAttribute('data-accent-a','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent-a')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-pd-a__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-pd-a__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-pd-a]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-atlas-rollerbreedte ===== */
(function () {
  var init = function () {
    document.querySelectorAll('.ac-video-a:not([data-ac-init-a])').forEach(function (root) {
      root.setAttribute('data-ac-init-a', '1');
      var video = root.querySelector('video');
      var bar = root.querySelector('[hidden]');
      var playBtn = root.querySelector('[data-ac-play-a]');
      if (!video || !bar) { return; }
      bar.hidden = false;
      /* De video is en blijft geluidloos, ook als een script of extensie er
         later aan zit. */
      video.muted = true;
      video.volume = 0;
      video.addEventListener('volumechange', function () { if (!video.muted) { video.muted = true; } });
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.autoplay = false;
        video.pause();
      }
      var syncPlay = function () {
        root.classList.toggle('is-paused', video.paused);
        if (playBtn) { playBtn.setAttribute('aria-label', video.paused ? playBtn.dataset.labelPlay : playBtn.dataset.labelPause); }
      };
      if (playBtn) {
        playBtn.addEventListener('click', function () {
          if (video.paused) { video.play(); } else { video.pause(); }
        });
      }
      video.addEventListener('play', syncPlay);
      video.addEventListener('pause', syncPlay);
      syncPlay();
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* Kopanimatie §4.8 — identiek blok in alle AlienComfort-secties, idempotent. */

/* ===== ac-atlas-massagesysteem ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-ms-a]:not([data-ac-ready-a])').forEach(function (root) {
      root.setAttribute('data-ac-ready-a', '1');
      var videos = Array.prototype.slice.call(root.querySelectorAll('[data-ac-video-a]'));
      if (!videos.length) { return; }
      var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (stil) { return; }
      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (v) { v.play().catch(function () {}); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.play().catch(function () {}); } else { e.target.pause(); }
        });
      }, { threshold: 0.25 });
      videos.forEach(function (v) { io.observe(v); });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-technologieen ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-flipdeck]:not([data-ac-ready])').forEach(function (deck) {
      deck.setAttribute('data-ac-ready', '1');
      var cards = Array.prototype.slice.call(deck.querySelectorAll('.ac-benefit'));
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          var open = card.getAttribute('aria-expanded') === 'true';
          /* er staat er altijd maar één open */
          cards.forEach(function (other) { other.setAttribute('aria-expanded', 'false'); });
          card.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
      /* escape sluit de open kaart */
      deck.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') { return; }
        cards.forEach(function (card) { card.setAttribute('aria-expanded', 'false'); });
      });
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* Flush-helper: meet de ruimte van de thema-wrapper en trekt de sectie
   door tot de rand van de pagina. Draait een keer per pagina. */

/* ===== ac-merkbanner ===== */

/* ===== ac-atlas-kosten ===== */
(function () {
    const section = document.getElementById('ac-atlas-cost-compact');
    if (!section) return;

    const range = section.querySelector('[data-ac-range]');
    const yearValue = section.querySelector('[data-ac-years]');
    const yearLabel = section.querySelector('[data-ac-year-label]');
    const cards = section.querySelectorAll('[data-ac-card]');
    const chair = section.querySelector('[data-ac-chair]');
    const chairTotal = section.querySelector('[data-ac-chair-total]');
    const chairPer = section.querySelector('[data-ac-chair-per]');

    const yearSingle = section.dataset.yearSingle || 'jaar';
    const yearPlural = section.dataset.yearPlural || 'jaar';

    function formatEuro(value, decimals) {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(value);
    }

    function updateComparison() {
      const years = Number(range.value);
      const progress = ((years - 1) / 9) * 100;

      range.style.setProperty('--ac-progress', progress + '%');
      yearValue.textContent = years;
      yearLabel.textContent = years === 1 ? yearSingle : yearPlural;

      cards.forEach(function(card) {
        const rate = Number(card.dataset.rate);
        const frequency = Number(card.dataset.frequency);
        const total = rate * frequency * years;
        const target = card.querySelector('[data-ac-total]');
        if (target) target.textContent = formatEuro(total, 0);
      });

      if (chair && chairTotal && chairPer) {
        const price = Number(chair.dataset.price);
        const perMassage = price / (365 * years);

        chairTotal.textContent = formatEuro(price, 2);
        chairPer.textContent = formatEuro(perMassage, 2);
      }
    }

    range.addEventListener('input', updateComparison);
    updateComparison();
  })();

/* ===== ac-atlas-kenmerken ===== */
/* Rijen komen binnen zodra ze in beeld staan. Zonder JavaScript, en bij
   prefers-reduced-motion, staat alles gewoon zichtbaar (§5.6). */
(function () {
  var init = function () {
    document.querySelectorAll('[data-acmt]:not([data-acmt-klaar])').forEach(function (sec) {
      sec.setAttribute('data-acmt-klaar', '1');
      var rijen = Array.prototype.slice.call(sec.querySelectorAll('.acmt__rij'));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      if (!('IntersectionObserver' in window)) { return; }
      sec.classList.add('acmt-js');
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      rijen.forEach(function (r) { io.observe(r); });
      /* Vangnet: staat een rij na anderhalve seconde nog onzichtbaar
         terwijl hij wel in beeld is, dan zetten we hem alsnog aan. */
      setTimeout(function () {
        rijen.forEach(function (r) {
          var b = r.getBoundingClientRect();
          if (b.top < window.innerHeight && b.bottom > 0) { r.classList.add('is-in'); }
        });
      }, 1500);
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-atlas-cijfers ===== */
/* Telanimatie. Per sectie, niet per pagina. Het eindgetal staat ook in de
   HTML, dus zonder JavaScript klopt het cijfer eveneens, en wie beweging
   heeft uitgezet ziet het meteen (§5.6). */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-perf]:not([data-ac-ready])').forEach(function (root) {
      root.setAttribute('data-ac-ready', '1');
      var nodes = root.querySelectorAll('[data-countup]');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      if (!('IntersectionObserver' in window)) { return; }
      var animate = function (el) {
        if (el.dataset.done === '1') { return; }
        el.dataset.done = '1';
        var target = Number(el.dataset.target) || 0;
        var duration = Number(el.dataset.duration) || 1100;
        var start = null;
        var tick = function (now) {
          if (start === null) { start = now; }
          var p = Math.min(1, (now - start) / duration);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased);
          if (p < 1) { requestAnimationFrame(tick); } else { el.textContent = target; }
        };
        el.textContent = '0';
        requestAnimationFrame(tick);
      };
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { animate(entry.target); io.unobserve(entry.target); }
        });
      }, { threshold: 0.4 });
      nodes.forEach(function (n) { io.observe(n); });
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* Kopanimatie §4.8 — identiek blok in alle AlienComfort-secties, idempotent. */

/* ===== ac-atlas-specificaties ===== */
/* Uitklappen per groep. Op desktop staat de knop op display:none en staat
   alles al open; het script hoeft daar niets te doen. */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-specs-a]:not([data-ac-ready-a])').forEach(function (root) {
      root.setAttribute('data-ac-ready-a', '1');
      root.querySelectorAll('[data-ac-more-a]').forEach(function (btn) {
        var card = btn.closest('[data-ac-card-a]');
        var label = btn.querySelector('span');
        btn.addEventListener('click', function () {
          var open = card.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (label) { label.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore; }
        });
      });
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===========================================================================
   AlienComfort | Kopanimatie §4.8 - v6, VOLLEDIG OP ZICHZELF
   Alle klassenamen, keyframes en variabelen in dit blok dragen het voorvoegsel
   "acsp-a". Er staat geen enkele window-variabele in. Een andere sectie op
   dezelfde pagina, oud of nieuw, kan deze kop dus niet meer aanraken en deze
   kop raakt geen andere sectie aan.
   Waarom dat nodig was: alle secties deelden .acsp-a__kop, .acsp-js-a en
   .acsp-in-a. Het blok van de sectie die als eerste op de pagina stond pakte
   daardoor ALLE koppen beet, ook die van nieuwere secties eronder. In de
   theme-editor viel dat niet op, want daar wordt de sectie los herladen en
   wint het nieuwste blok; live won het oudste. Vandaar: niets meer delen.
   =========================================================================== */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STEP = 0.08, ACCENT = 0.22, TAIL = 0.30;
  function wrap(h) {
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
          var s = document.createElement('span');
          s.className = 'acsp-a__w'; s.textContent = p;
          frag.appendChild(s);
        });
        h.replaceChild(frag, n);
      } else if (n.nodeType === 1) { n.classList.add('acsp-a__w'); }
    });
  }
  function build(h, sec) {
    var gespeeld = sec.getAttribute('data-acsp-gespeeld-a') === '1';
    h.innerHTML = h.getAttribute('data-acsp-bron-a');
    wrap(h);
    var regels = [], nu = null, top = null;
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.classList.contains('acsp-a__w')) {
        var t = Math.round(n.offsetTop);
        if (top === null || Math.abs(t - top) > 2) { top = t; nu = []; regels.push(nu); }
        nu.push(n);
      } else if (nu) { nu.push(n); }
    });
    h.innerHTML = '';
    regels.forEach(function (arr, i) {
      var ln = document.createElement('span');
      ln.className = 'acsp-a__regel';
      arr.forEach(function (n) { ln.appendChild(n); });
      h.appendChild(ln);
      if (gespeeld) { ln.style.animation = 'none'; ln.style.opacity = '1'; ln.style.transform = 'none'; ln.style.clipPath = 'none'; return; }
      ln.style.animationDelay = (i * STEP) + 's';
      Array.prototype.forEach.call(
        ln.querySelectorAll('.acsp-a__accent, .acsp-a__semi'),
        function (a) { a.style.transitionDelay = (i * STEP + ACCENT) + 's'; }
      );
    });
    if (!gespeeld) {
      var laatste = (regels.length - 1) * STEP + TAIL;
      Array.prototype.forEach.call(sec.querySelectorAll('.acsp-a__op'), function (el, k) {
        el.style.transitionDelay = (laatste + k * 0.09) + 's';
      });
    }
  }
  /* Thema's en andere secties zetten soms opacity, visibility of
     -webkit-text-fill-color op nul. Daarom hier expliciet en met voorrang. */
  function zichtbaar(h) {
    h.style.setProperty('opacity', '1', 'important');
    h.style.setProperty('visibility', 'visible', 'important');
    h.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    Array.prototype.forEach.call(h.querySelectorAll('.acsp-a__regel'), function (ln) {
      ln.style.setProperty('visibility', 'visible', 'important');
      ln.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    });
  }
  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.acsp-a__kop'), function (h) {
      var sec = h.closest('.acsp-sectie') || h.closest('section') || h.parentElement;
      var box = h.parentElement;
      if (!sec || sec.getAttribute('data-acsp-klaar-a') === '1') return;
      sec.setAttribute('data-acsp-klaar-a', '1');
      sec.classList.add('acsp-js-a');
      h.setAttribute('data-acsp-bron-a', h.innerHTML);
      zichtbaar(h);
      var raf, b = 0;
      function plan() { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { build(h, sec); zichtbaar(h); }); }
      plan();
      if (window.ResizeObserver) {
        new ResizeObserver(function (e) {
          var nb = Math.round(e[0].contentRect.width);
          if (nb !== b) { b = nb; plan(); }
        }).observe(box);
      } else {
        window.addEventListener('resize', function () { setTimeout(plan, 120); });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(plan);
      /* Laatste redmiddel: als een thema of een andere sectie een OUDER van de
         kop op opacity 0 of visibility hidden zet, helpt forceren op de kop
         zelf niet. Daarom lopen we na het spelen de keten naar boven na. */
      function herstel() {
        var el = h;
        while (el && el !== document.body) {
          var cs = getComputedStyle(el);
          if (parseFloat(cs.opacity) === 0) el.style.setProperty('opacity', '1', 'important');
          if (cs.visibility === 'hidden') el.style.setProperty('visibility', 'visible', 'important');
          if (el === sec) break;
          el = el.parentElement;
        }
      }
      function speel() {
        sec.setAttribute('data-acsp-gespeeld-a', '1');
        sec.classList.add('acsp-in-a');
        zichtbaar(h);
        setTimeout(function () { zichtbaar(h); herstel(); }, 400);
      }
      /* Eén zichtbare pixel is genoeg. Met een drempel van 20% blijft de kop
         van een sectie die hoger is dan vijf schermen voor altijd weggeknipt. */
      if (RM.matches || !('IntersectionObserver' in window)) { speel(); return; }
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { speel(); io.disconnect(); }
      }, { threshold: 0 });
      io.observe(sec);
      /* Vangnet: een kop die niet beweegt is vervelend, een kop die
         onzichtbaar blijft is een gemiste verkoop. */
      setTimeout(function () {
        if (sec.getAttribute('data-acsp-gespeeld-a') === '1') return;
        var r = sec.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { speel(); io.disconnect(); }
      }, 1500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
})();

/* Flush-helper. Shopify zet een Custom Liquid-sectie in een container die
   smaller is dan het scherm, met eigen ruimte eromheen. Bij een witte
   sectie zie je dat niet, bij een ruimtezwarte krijgt u stroken
   paginakleur links, rechts, boven en onder. Hoeveel dat is verschilt per
   thema en per instelling, dus dit meet het op en trekt de sectie door tot
   de rand. Draait één keer per pagina. */

/* ===== ac-reviews-atlas ===== */
(function () {
function init() {
document.querySelectorAll('[data-ac-rev-a]:not([data-ac-klaar-a])').forEach(function (root) {
root.setAttribute('data-ac-klaar-a', '1');
var T = JSON.parse(root.querySelector('[data-ac-rev-t-a]').textContent);
var loc = root.getAttribute('data-loc') || 'nl-NL';
var data = {};
try { data = JSON.parse(root.getAttribute('data-ac-rev-data-a') || '{}') || {}; } catch (fout) { data = {}; }
var alles = (data.reviews || []).filter(function (r) { return r && r.body != null; });
var elSamen = root.querySelector('[data-ac-rev-samen-a]');
var elFilters = root.querySelector('[data-ac-rev-filters-a]');
var elPijlen = root.querySelector('[data-ac-rev-pijlen-a]');
var spoor = root.querySelector('[data-ac-rev-spoor-a]');
var licht = root.querySelector('[data-ac-rev-licht-a]');
var lichtBeeld = root.querySelector('[data-ac-rev-lichtbeeld-a]');
var alleenFoto = false;
var STERPAD = 'm12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.9L12 17.8 5.8 21l1.2-6.9-5-4.9 6.9-1z';
function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}
/* §4.2: de hele ster is champagne, gevuld of niet. Vol is een vlak, half
   is links gevuld en rechts contour, leeg is alleen de contourlijn.
   Nooit een grijze of lichtgrijze lege ster: dat maakt er twee kleuren
   van. */
function ster(soort, hoog) {
var maat = ' style="width:' + hoog + 'px;height:' + hoog + 'px"';
var vol = '<svg class="ac-rev-a__ster is-vol" viewBox="0 0 24 24" aria-hidden="true"' + maat + '><path d="' + STERPAD + '"></path></svg>';
var leeg = '<svg class="ac-rev-a__ster is-leeg" viewBox="0 0 24 24" aria-hidden="true"' + maat + '><path d="' + STERPAD + '"></path></svg>';
if (soort === 'vol') { return vol; }
if (soort === 'leeg') { return leeg; }
return '<span class="ac-rev-a__ster-half"' + maat + '>' + leeg + vol + '</span>';
}
function sterren(waarde, hoog) {
var uit = '';
for (var i = 1; i <= 5; i++) {
var v = waarde - i + 1;
uit += ster(v >= 0.75 ? 'vol' : (v >= 0.25 ? 'half' : 'leeg'), hoog);
}
return '<span class="ac-rev-a__sterren" role="img" aria-label="' + (Math.round(waarde * 10) / 10) + ' / 5">' + uit + '</span>';
}
function datum(iso) {
var d = new Date(iso);
if (isNaN(d.getTime())) { return ''; }
return d.toLocaleDateString(loc, { day: 'numeric', month: 'long', year: 'numeric' });
}
function initialen(naam) {
return String(naam || '?').trim().split(/\s+/).slice(0, 2).map(function (w) { return w.charAt(0); }).join('').toUpperCase();
}
/* De optelling van Okendo is leidend. Ontbreekt die, dan rekenen wij hem
   uit de reviews zelf, zodat er altijd iets klopt. */
function optelling() {
var a = data.reviewAggregate || {};
var n = a.ratingAndReviewCount || alles.length;
if (!n) { return null; }
var som = a.ratingAndReviewValuesTotal;
if (som == null) { som = alles.reduce(function (t, r) { return t + (r.rating || 0); }, 0); }
var aanbevolen = a.recommendationCount;
if (aanbevolen == null) { aanbevolen = alles.filter(function (r) { return r.isRecommended; }).length; }
return { n: n, gem: som / n, aanbevolen: aanbevolen };
}
function tekenSamen() {
var o = optelling();
if (!o) { elSamen.innerHTML = '<p class="ac-rev-a__leeg">' + esc(T.leeg) + '</p>'; return; }
var pct = o.n ? Math.round(o.aanbevolen / o.n * 100) : 0;
elSamen.innerHTML =
'<span class="ac-rev-a__cijfer">' + o.gem.toFixed(1).replace('.', ',') + '</span>' +
'<span class="ac-rev-a__cijferbij">' + sterren(o.gem, 17) +
'<span class="ac-rev-a__aantal">' + o.n + ' ' + esc(T.op) +
(o.aanbevolen ? '<b>' + pct + '% ' + esc(T.aanbevolen) + '</b>' : '') + '</span></span>';
}
function tekenFilters() {
var metFoto = alles.filter(function (r) { return r.media && r.media.length; }).length;
if (!metFoto || alles.length < 3) { elFilters.hidden = true; return; }
elFilters.hidden = false;
elFilters.innerHTML =
'<button type="button" class="ac-rev-a__chip' + (alleenFoto ? '' : ' is-aan') + '" data-foto="0">' + esc(T.alle) + ' (' + alles.length + ')</button>' +
'<button type="button" class="ac-rev-a__chip' + (alleenFoto ? ' is-aan' : '') + '" data-foto="1">' + esc(T.metfoto) + ' (' + metFoto + ')</button>';
}
function lijst() {
var uit = alles.slice();
if (alleenFoto) { uit = uit.filter(function (r) { return r.media && r.media.length; }); }
uit.sort(function (a, b) { return new Date(b.dateCreated) - new Date(a.dateCreated); });
return uit;
}
function tekenSpoor() {
var rij = lijst();
/* Bij drie of minder wordt het een rij, anders staat de tweede half leeg. */
spoor.style.gridTemplateRows = rij.length > 3 ? 'repeat(2, minmax(0, 1fr))' : 'minmax(0, 1fr)';
spoor.innerHTML = rij.map(function (r) {
var rv = r.reviewer || {};
var avatar = rv.avatarUrl
? '<span class="ac-rev-a__avatar"><img src="' + esc(rv.avatarUrl) + '" alt="" loading="lazy"></span>'
: '<span class="ac-rev-a__avatar ac-rev-a__avatar--letters">' + esc(initialen(rv.displayName)) + '</span>';
/* De foto is geen bijlage onderaan maar de kop van de kaart. Meer dan
   één foto: de eerste vult de kop, de rest zit onder een telbadge. */
var fotos = (r.media || []).filter(function (m) { return m.thumbnailUrl; });
var kop = '';
if (fotos.length) {
var eerste = fotos[0];
kop = '<button type="button" class="ac-rev-a__beeld" data-groot="' + esc(eerste.largeUrl || eerste.fullSizeUrl) + '">' +
'<img src="' + esc(eerste.largePortraitThumbnailUrl || eerste.largeUrl || eerste.thumbnailUrl) + '" alt="' + esc(eerste.alt || '') + '" loading="lazy">' +
(fotos.length > 1 ? '<span class="ac-rev-a__telbadge">+' + (fotos.length - 1) + '</span>' : '') +
'</button>';
}
var regels = String(r.body || '').split(/\n+/).filter(function (t) { return t.trim(); })
.map(function (t) { return '<span>' + esc(t) + '</span>'; }).join('');
return '<article class="ac-rev-a__kaart' + (fotos.length ? ' ac-rev-a__kaart--beeld' : '') + '">' + kop +
'<div class="ac-rev-a__body">' +
'<div class="ac-rev-a__meta">' + sterren(r.rating || 0, 13) + '<time>' + esc(datum(r.dateCreated)) + '</time></div>' +
(r.title && r.title.trim() ? '<h3 class="ac-rev-a__kaarttitel">' + esc(r.title.trim()) + '</h3>' : '') +
'<div class="ac-rev-a__tekst" data-ac-rev-tekst-a>' + regels + '</div>' +
'<button type="button" class="ac-rev-a__uitklap" data-ac-rev-uit-a hidden>' + esc(T.meerlezen) + '</button>' +
'<footer class="ac-rev-a__voetregel">' + avatar +
'<span class="ac-rev-a__wie"><strong>' + esc(rv.displayName || '') + '</strong>' +
'<em>' + (rv.isVerified ? esc(T.geverifieerd) : (r.helpfulCount ? r.helpfulCount + ' ' + esc(T.nuttig) : '')) + '</em></span></footer>' +
'</div></article>';
}).join('');
/* Alleen een uitklapknop tonen waar de tekst werkelijk niet past. */
spoor.querySelectorAll('[data-ac-rev-tekst-a]').forEach(function (el) {
if (el.scrollHeight > el.clientHeight + 2) { el.nextElementSibling.hidden = false; }
});
setTimeout(pijlen, 60);
}
/* De pijlen verdwijnen als alles al past. Niets is vervelender dan een
   pijl die nergens heen gaat. */
function pijlen() {
elPijlen.hidden = spoor.scrollWidth <= spoor.clientWidth + 4;
}
function schuif(kant) {
var stap = Math.max(240, Math.round(spoor.clientWidth * 0.8));
var zacht = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
spoor.scrollBy({ left: kant * stap, behavior: zacht ? 'smooth' : 'auto' });
}
root.querySelector('[data-ac-rev-links-a]').addEventListener('click', function () { schuif(-1); });
root.querySelector('[data-ac-rev-rechts-a]').addEventListener('click', function () { schuif(1); });
window.addEventListener('resize', function () { clearTimeout(root.__t); root.__t = setTimeout(pijlen, 150); });
/* Slepen met de muis. Op een aanraakscherm doet de browser dit zelf. */
var sleept = false, startX = 0, startL = 0, bewogen = false;
spoor.addEventListener('pointerdown', function (e) {
if (e.pointerType === 'touch') { return; }
sleept = true; bewogen = false; startX = e.clientX; startL = spoor.scrollLeft;
spoor.classList.add('is-sleep');
});
window.addEventListener('pointermove', function (e) {
if (!sleept) { return; }
var d = e.clientX - startX;
if (Math.abs(d) > 3) { bewogen = true; }
spoor.scrollLeft = startL - d;
});
window.addEventListener('pointerup', function () {
if (!sleept) { return; }
sleept = false; spoor.classList.remove('is-sleep');
});
spoor.addEventListener('click', function (e) { if (bewogen) { e.preventDefault(); e.stopPropagation(); } }, true);
elFilters.addEventListener('click', function (e) {
var b = e.target.closest('[data-foto]'); if (!b) { return; }
alleenFoto = b.getAttribute('data-foto') === '1';
spoor.scrollLeft = 0; tekenFilters(); tekenSpoor();
});
spoor.addEventListener('click', function (e) {
var uit = e.target.closest('[data-ac-rev-uit-a]');
if (uit) { uit.previousElementSibling.classList.add('is-open'); uit.hidden = true; setTimeout(pijlen, 60); return; }
var b = e.target.closest('.ac-rev-a__beeld'); if (!b) { return; }
lichtBeeld.src = b.getAttribute('data-groot');
licht.hidden = false;
document.body.style.overflow = 'hidden';
});
function dicht() { licht.hidden = true; lichtBeeld.src = ''; document.body.style.overflow = ''; }
licht.addEventListener('click', dicht);
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !licht.hidden) { dicht(); } });
if (!alles.length) { root.classList.add('ac-rev-a--leeg'); }
tekenSamen(); tekenFilters(); tekenSpoor();
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

(function(){function plak(){document.querySelectorAll('.ac-rev-a').forEach(function(k){var w=k.closest('.shopify-section')||k.parentElement;if(!w)return;w.style.marginBottom='0px';var b=w.nextElementSibling;if(b)b.style.marginTop='0px'})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',plak)}else{plak()}window.addEventListener('load',plak)})();

/* ===========================================================================
   AlienComfort | Kopanimatie §4.8 — v5
   Zet dit blok in ELKE sectie die .ac-cosmos__heading--a of --b gebruikt,
   in plaats van het oude blok. Het is overal identiek.
   WAAROM v5 NODIG WAS
   1. SECTIES BEÏNVLOEDDEN ELKAAR. Het oude blok begon met
      "if (window.__acHeadingInit) { ...; return; }". De sectie die als
      EERSTE op de pagina stond bepaalde daarmee welke versie álle koppen
      op die pagina aanstuurde. Stond er ergens nog een sectie met het
      oude blok, dan won die van elke nieuwere sectie erna. Daarom staat er
      nu een versienummer bij: een nieuwer blok neemt het over van een
      ouder, ongeacht de vololgorde op de pagina.
   2. EEN LANGE SECTIE KREEG ZIJN KOP NOOIT TE ZIEN. De waarnemer wachtte
      tot 20% van de sectie in beeld stond. Bij een sectie die hoger is dan
      vijf schermen kan dat nooit, en dan bleef de kop volledig
      weggeknipt staan. Nu is één zichtbare pixel genoeg.
   3. VANGNET OVER ALLE KOPPEN, ook die van secties die door een ouder
      blok zijn opgebouwd. Dat is nodig omdat een ouder blok zijn eigen
      waarnemer blijft gebruiken, ook nadat een nieuwer blok het overneemt:
      de luisteraars van het oude blok blijven staan en die claimen de
      sectie eerst. Dit blok hangt daarom aan ELKE kop op de pagina een
      eigen waarnemer die al bij één zichtbare pixel afgaat, en zet een kop
      die dan nog steeds weggeknipt is na 1,5 seconde alsnog zichtbaar. Een
      kop die niet beweegt is vervelend; een kop die onzichtbaar blijft is
      een gemiste verkoop.
   4. THEMA-CSS OVERRULEN. Sommige thema's zetten zelf opacity: 0 of
      -webkit-text-fill-color: transparent op h2's. Omdat ons script de kop
      opnieuw opbouwt, verdwijnt de haak van het thema en blijft die nul
      staan. De kop wordt nu expliciet zichtbaar gezet.
   =========================================================================== */

/* Flush-helper: meet de ruimte van de thema-wrapper en trekt de sectie
   door tot de rand van de pagina. Draait één keer per pagina. */

/* ===== ac-vergelijker-atlas ===== */
(function(){
  var sec=document.querySelector('[data-ac-vp-a]:not([data-klaar])');
  if(!sec) return;
  sec.setAttribute('data-klaar','1');
  var LIVE=JSON.parse(sec.querySelector('[data-vp-live]').textContent);
  var D=JSON.parse(sec.querySelector('[data-vp-data]').textContent);
  var T=D.t, S=D.stoelen;
  var ORDE=['pluto','nova','luna','astron','pulsar','atlas','titan'];
  var zelf=sec.getAttribute('data-zelf');
  function esc(x){return String(x==null?'':x).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function niv(id){var v=String(S[id].i).split('|')[0];return v==='*'?5:(parseInt(v,10)||0);}

  /* Buren op de intensiteitsladder: de dichtstbijzijnde zachtere en de
     dichtstbijzijnde stevigere stoel. Zit de stoel aan een uiteinde, dan
     vullen we aan met de volgende uit dezelfde richting, zodat er altijd
     drie kaarten staan. */
  var i0=ORDE.indexOf(zelf);
  var zachter=null, steviger=null;
  for(var i=i0-1;i>=0;i--){ if(niv(ORDE[i])<niv(zelf)){zachter=ORDE[i];break;} }
  for(var j=i0+1;j<ORDE.length;j++){ if(niv(ORDE[j])>niv(zelf)){steviger=ORDE[j];break;} }
  /* Staat de stoel aan een uiteinde van de ladder, dan bestaat één van de
     twee buren niet. We vullen aan met de dichtstbijzijnde andere stoel en
     geven die een neutraal label — "één stap zachter" boven een stoel die
     juist steviger is, zou een leugen zijn. */
  var lZacht = T.zachter, lStevig = T.steviger;
  if(!zachter){
    for(var a=0;a<ORDE.length;a++){ if(ORDE[a]!==zelf && ORDE[a]!==steviger){ zachter=ORDE[a]; break; } }
    lZacht = T.ook;
  }
  if(!steviger){
    for(var b=ORDE.length-1;b>=0;b--){ if(ORDE[b]!==zelf && ORDE[b]!==zachter){ steviger=ORDE[b]; break; } }
    lStevig = T.ook;
  }

  /* Een stoel die u zelf instelt heeft geen vast niveau. Die krijgt geen
     vier vakjes maar een doorlopende balk: van zacht naar fors is bij die
     stoel een schuif, geen stand. */
  function meter(v){
    var d=String(v).split('|'), bl='';
    if(d[0]==='*'){
      return '<span class="ac-vp-a__meter"><span class="ac-vp-a__mblok is-vrij"><i></i><i></i><i></i><i></i></span>'+esc(d[1]||'')+'</span>';
    }
    var n=parseInt(d[0],10)||0;
    for(var k=1;k<=4;k++){bl+='<i'+(k<=n?' class="is-aan"':'')+'></i>';}
    return '<span class="ac-vp-a__meter"><span class="ac-vp-a__mblok">'+bl+'</span>'+esc(d[1]||'')+'</span>';
  }
  function kaart(id,vlag,isZelf){
    var s=S[id]||{}, c=LIVE[id]||{};
    return '<div class="ac-vp-a__kaart'+(isZelf?' ac-vp-a__kaart--zelf':'')+'">'
      +'<span class="ac-vp-a__vlag">'+esc(vlag)+'</span>'
      +'<div class="ac-vp-a__top">'
      +(c.img?'<img class="ac-vp-a__foto" src="'+esc(c.img)+'" alt="" loading="lazy" decoding="async">':'')
      +'<span class="ac-vp-a__wie"><span class="ac-vp-a__naam">'+esc(s.n)+'</span>'
      +'<span class="ac-vp-a__prijs">'+esc(c.prijs||'')+'</span>'
      +'<span class="ac-vp-a__status '+(c.op?'is-op':'is-pre')+'">'+esc(c.op?T.op:T.pre)+'</span></span></div>'
      +'<dl class="ac-vp-a__regels">'
      +'<div><dt>'+esc(T.sys)+'</dt><dd>'+esc(s.sys)+'</dd></div>'
      +'<div><dt>'+esc(T.int)+'</dt><dd>'+meter(s.i)+'</dd></div>'
      +'<div><dt>'+esc(T.diep)+'</dt><dd>'+esc(s.d)+'</dd></div>'
      +'<div><dt>'+esc(T.breed)+'</dt><dd>'+esc(s.b)+'</dd></div>'
      +'<div><dt>'+esc(T.kg)+'</dt><dd'+(s.kg==='—'?' class="is-leeg"':'')+'>'+esc(s.kg)+'</dd></div>'
      +'</dl>'
      +(isZelf||!c.url?'':'<a class="ac-vp-a__link" href="'+esc(c.url)+'">'+esc(s.n)+' &rarr;</a>')
      +'</div>';
  }
  sec.querySelector('[data-vp-rij]').innerHTML =
    kaart(zachter,lZacht,false) + kaart(zelf,T.deze,true) + kaart(steviger,lStevig,false);
  sec.querySelector('[data-vp-knop]').textContent = T.knop;

  /* Op mobiel is de rij een swipe-rij. Begin op de eigen stoel — die staat
     in het midden — zodat de bezoeker ziet waar hij is, en niet op de
     buurstoel. Zonder animatie: dit is de startstand, geen beweging. */
  var rij = sec.querySelector('[data-vp-rij]');
  function startpositie(){
    if(window.innerWidth > 749){ rij.scrollLeft = 0; return; }
    var mid = rij.querySelector('.ac-vp-a__kaart--zelf');
    if(mid){ rij.scrollLeft = mid.offsetLeft - rij.offsetLeft; }
  }
  startpositie();
  var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(startpositie, 150); });
})();

/* Kopanimatie §4.8 — gedeeld blok, idempotent. */

/* ===== ac-faq-atlas ===== */

(function () {
function init() {
document.querySelectorAll('[data-ac-faq-a]').forEach(function (root) {
if (root.dataset.acReady === '1') return;
root.dataset.acReady = '1';
var items = Array.prototype.slice.call(root.querySelectorAll('.ac-faq-a__item'));
items.forEach(function (item) {
item.addEventListener('toggle', function () {
if (!item.open) return;
items.forEach(function (other) {
if (other !== item) other.open = false;
});
});
});
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

/* ===== ac-pluto-opening ===== */
/* ===========================================================================
   AlienComfort | Kopanimatie §4.8 - v6, VOLLEDIG OP ZICHZELF
   Alle klassenamen, keyframes en variabelen in dit blok dragen het voorvoegsel
   "acpi". Er staat geen enkele window-variabele in. Een andere sectie op
   dezelfde pagina, oud of nieuw, kan deze kop dus niet meer aanraken en deze
   kop raakt geen andere sectie aan.
   Waarom dat nodig was: alle secties deelden .ac-cosmos__heading, .ac-js en
   .is-in. Het blok van de sectie die als eerste op de pagina stond pakte
   daardoor ALLE koppen beet, ook die van nieuwere secties eronder. In de
   theme-editor viel dat niet op, want daar wordt de sectie los herladen en
   wint het nieuwste blok; live won het oudste. Vandaar: niets meer delen.
   =========================================================================== */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STEP = 0.08, ACCENT = 0.22, TAIL = 0.30;
  function wrap(h) {
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
          var s = document.createElement('span');
          s.className = 'acpi__w'; s.textContent = p;
          frag.appendChild(s);
        });
        h.replaceChild(frag, n);
      } else if (n.nodeType === 1) { n.classList.add('acpi__w'); }
    });
  }
  function build(h, sec) {
    var gespeeld = sec.getAttribute('data-acpi-gespeeld') === '1';
    h.innerHTML = h.getAttribute('data-acpi-bron');
    wrap(h);
    var regels = [], nu = null, top = null;
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.classList.contains('acpi__w')) {
        var t = Math.round(n.offsetTop);
        if (top === null || Math.abs(t - top) > 2) { top = t; nu = []; regels.push(nu); }
        nu.push(n);
      } else if (nu) { nu.push(n); }
    });
    h.innerHTML = '';
    regels.forEach(function (arr, i) {
      var ln = document.createElement('span');
      ln.className = 'acpi__regel';
      arr.forEach(function (n) { ln.appendChild(n); });
      h.appendChild(ln);
      if (gespeeld) { ln.style.animation = 'none'; ln.style.opacity = '1'; ln.style.transform = 'none'; ln.style.clipPath = 'none'; return; }
      ln.style.animationDelay = (i * STEP) + 's';
      Array.prototype.forEach.call(
        ln.querySelectorAll('.acpi__accent, .acpi__semi'),
        function (a) { a.style.transitionDelay = (i * STEP + ACCENT) + 's'; }
      );
    });
    if (!gespeeld) {
      var laatste = (regels.length - 1) * STEP + TAIL;
      Array.prototype.forEach.call(sec.querySelectorAll('.acpi__op'), function (el, k) {
        el.style.transitionDelay = (laatste + k * 0.09) + 's';
      });
    }
  }
  /* Thema's en andere secties zetten soms opacity, visibility of
     -webkit-text-fill-color op nul. Daarom hier expliciet en met voorrang. */
  function zichtbaar(h) {
    h.style.setProperty('opacity', '1', 'important');
    h.style.setProperty('visibility', 'visible', 'important');
    h.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    Array.prototype.forEach.call(h.querySelectorAll('.acpi__regel'), function (ln) {
      ln.style.setProperty('visibility', 'visible', 'important');
      ln.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    });
  }
  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.acpi__kop'), function (h) {
      var sec = h.closest('.acpi-sectie') || h.closest('section') || h.parentElement;
      var box = h.parentElement;
      if (!sec || sec.getAttribute('data-acpi-klaar') === '1') return;
      sec.setAttribute('data-acpi-klaar', '1');
      sec.classList.add('acpi-js');
      h.setAttribute('data-acpi-bron', h.innerHTML);
      zichtbaar(h);
      var raf, b = 0;
      function plan() { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { build(h, sec); zichtbaar(h); }); }
      plan();
      if (window.ResizeObserver) {
        new ResizeObserver(function (e) {
          var nb = Math.round(e[0].contentRect.width);
          if (nb !== b) { b = nb; plan(); }
        }).observe(box);
      } else {
        window.addEventListener('resize', function () { setTimeout(plan, 120); });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(plan);
      /* Laatste redmiddel: als een thema of een andere sectie een OUDER van de
         kop op opacity 0 of visibility hidden zet, helpt forceren op de kop
         zelf niet. Daarom lopen we na het spelen de keten naar boven na. */
      function herstel() {
        var el = h;
        while (el && el !== document.body) {
          var cs = getComputedStyle(el);
          if (parseFloat(cs.opacity) === 0) el.style.setProperty('opacity', '1', 'important');
          if (cs.visibility === 'hidden') el.style.setProperty('visibility', 'visible', 'important');
          if (el === sec) break;
          el = el.parentElement;
        }
      }
      function speel() {
        sec.setAttribute('data-acpi-gespeeld', '1');
        sec.classList.add('acpi-in');
        zichtbaar(h);
        setTimeout(function () { zichtbaar(h); herstel(); }, 400);
      }
      /* Eén zichtbare pixel is genoeg. Met een drempel van 20% blijft de kop
         van een sectie die hoger is dan vijf schermen voor altijd weggeknipt. */
      if (RM.matches || !('IntersectionObserver' in window)) { speel(); return; }
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { speel(); io.disconnect(); }
      }, { threshold: 0 });
      io.observe(sec);
      /* Vangnet: een kop die niet beweegt is vervelend, een kop die
         onzichtbaar blijft is een gemiste verkoop. */
      setTimeout(function () {
        if (sec.getAttribute('data-acpi-gespeeld') === '1') return;
        var r = sec.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { speel(); io.disconnect(); }
      }, 1500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
})();

/* ===== ac-preorder-mini ===== */
(function(){function plak(){document.querySelectorAll('.ac-pom').forEach(function(k){var w=k.closest('.shopify-section')||k.parentElement;if(!w)return;w.style.marginTop='0px';w.style.marginBottom='0px';var b=w.previousElementSibling;if(b)b.style.marginBottom='0px';var n=w.nextElementSibling;if(n)n.style.marginTop='0px'})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',plak)}else{plak()}window.addEventListener('load',plak)})();

/* Flush-helper: meet de ruimte van de thema-wrapper en trekt de sectie
   door tot de rand van de pagina. Draait één keer per pagina. */

/* ===== ac-pluto-preorder ===== */
/* Vult het verborgen samenvattingsveld, zodat de mail leesbaar binnenkomt
   in plaats van als losse velden. */
(function () {
  function init() {
    document.querySelectorAll('.ac-preorder-p__form').forEach(function (form) {
      if (form.dataset.acReady === '1') return;
      form.dataset.acReady = '1';
      form.addEventListener('submit', function () {
        var summary = form.querySelector('[data-ac-summary-p]');
        if (!summary) return;
        function val(sel) {
          var el = form.querySelector(sel);
          return el && el.value ? el.value.trim() : '-';
        }
        function checked(name) {
          var el = form.querySelector('input[name="' + name + '"]:checked');
          return el ? el.value : '-';
        }
        /* De aankomstmaand hangt aan de gekozen kleur. Wij zetten hem in het
           verborgen veld en in de samenvatting, zodat in de mail staat welke
           maand de klant heeft gezien. */
        var kleurEl = form.querySelector('input[name="contact[Kleur]"]:checked');
        var eta = kleurEl ? (kleurEl.getAttribute('data-ac-eta-p') || '-') : '-';
        var etaVeld = form.querySelector('input[name="contact[Verwachte aankomst]"]');
        if (etaVeld) etaVeld.value = eta;
        summary.value = [
          'PRE-ORDER AANVRAAG, MASSAGESTOEL PLUTO',
          '',
          'Productpagina: ' + val('input[name="contact[Productpagina]"]'),
          'Verwachte aankomst: ' + eta,
          '',
          'VOORDELEN:',
          '- ' + ((form.closest('[data-ac-korting-p]') || {getAttribute:function(){return '';}}).getAttribute('data-ac-korting-p') || '') + ' korting bovenop de getoonde prijs',
          '- Voorrang bij levering en installatie',
          '- 50% bij pre-order, 50% na levering',
          '',
          'GEGEVENS:',
          'Naam: ' + val('#ac-po-name'),
          'E-mail: ' + val('#ac-po-email'),
          'Telefoon: ' + val('#ac-po-phone'),
          'Kleur: ' + checked('contact[Kleur]'),
          'Aankomst bij deze kleur: ' + eta,
          'Levering: ' + val('#ac-po-delivery'),
          '',
          'NOTITIE:',
          val('#ac-po-note'),
          '',
          'Actie: neem contact op om de pre-order af te ronden.'
        ].join('\n');
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* Kopanimatie §4.8 — identiek blok in alle AlienComfort-secties, idempotent. */

/* Flush-helper: Shopify zet een Custom Liquid-sectie in een smallere
   container met eigen ruimte eromheen. Dit meet dat op en trekt de sectie
   door tot de rand. Draait één keer per pagina. */

/* ===== ac-pluto-beschrijving ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var knop = sec.querySelector('[data-ac-pd-knop-p]');
var paneel = sec.querySelector('[data-ac-pd-paneel-p]');
if(knop && paneel){
knop.addEventListener('click', function(){
var open = paneel.classList.contains('is-open');
paneel.classList.toggle('is-open', !open);
knop.classList.toggle('is-open', !open);
knop.setAttribute('aria-expanded', open ? 'false' : 'true');
});
}
var kop = sec.querySelector('[data-ac-pd-kop-p]');
var binnen = sec.querySelector('.ac-pd-p__in');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-pd-p__kern') || k.classList.contains('ac-pd-p__semi'))){ k.setAttribute('data-accent-p','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent-p')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-pd-p__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-pd-p__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-pd-p]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-pluto-fitmeter ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-fit-meter-p]:not([data-ac-ready-p])').forEach(function (section) {
      section.setAttribute('data-ac-ready-p', '1');
      section.querySelectorAll('.ac-meter').forEach(function (meter) {
        meter.style.setProperty('--fill', (meter.getAttribute('data-fill') || 0) + '%');
      });
      if (!('IntersectionObserver' in window)) { section.classList.add('is-visible'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { section.classList.add('is-visible'); io.unobserve(entry.target); }
        });
      }, { threshold: 0.25 });
      io.observe(section);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-pluto-massagesysteem ===== */
/* Video's spelen alleen in beeld en nooit bij verminderde beweging (§5.6);
   dan blijft het posterbeeld staan. Scheelt accu en houdt de pagina licht. */
(function () {
function init() {
document.querySelectorAll('[data-acms]:not([data-acms-video-klaar])').forEach(function (root) {
root.setAttribute('data-acms-video-klaar', '1');
var videos = Array.prototype.slice.call(root.querySelectorAll('[data-acms-video]'));
if (!videos.length) return;
if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
if (!('IntersectionObserver' in window)) { videos.forEach(function (v) { v.play().catch(function () {}); }); return; }
var io = new IntersectionObserver(function (en) {
en.forEach(function (e) { if (e.isIntersecting) { e.target.play().catch(function () {}); } else { e.target.pause(); } });
}, { threshold: 0.25 });
videos.forEach(function (v) { io.observe(v); });
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* ===========================================================================
   AlienComfort | Kopanimatie §4.8 - v6, VOLLEDIG OP ZICHZELF
   Alle klassenamen, keyframes en variabelen in dit blok dragen het voorvoegsel
   "acms". Er staat geen enkele window-variabele in. Een andere sectie op
   dezelfde pagina, oud of nieuw, kan deze kop dus niet meer aanraken en deze
   kop raakt geen andere sectie aan.
   Waarom dat nodig was: alle secties deelden .ac-cosmos__heading, .ac-js en
   .is-in. Het blok van de sectie die als eerste op de pagina stond pakte
   daardoor ALLE koppen beet, ook die van nieuwere secties eronder. In de
   theme-editor viel dat niet op, want daar wordt de sectie los herladen en
   wint het nieuwste blok; live won het oudste. Vandaar: niets meer delen.
   =========================================================================== */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STEP = 0.08, ACCENT = 0.22, TAIL = 0.30;
  function wrap(h) {
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
          var s = document.createElement('span');
          s.className = 'acms__w'; s.textContent = p;
          frag.appendChild(s);
        });
        h.replaceChild(frag, n);
      } else if (n.nodeType === 1) { n.classList.add('acms__w'); }
    });
  }
  function build(h, sec) {
    var gespeeld = sec.getAttribute('data-acms-gespeeld') === '1';
    h.innerHTML = h.getAttribute('data-acms-bron');
    wrap(h);
    var regels = [], nu = null, top = null;
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.classList.contains('acms__w')) {
        var t = Math.round(n.offsetTop);
        if (top === null || Math.abs(t - top) > 2) { top = t; nu = []; regels.push(nu); }
        nu.push(n);
      } else if (nu) { nu.push(n); }
    });
    h.innerHTML = '';
    regels.forEach(function (arr, i) {
      var ln = document.createElement('span');
      ln.className = 'acms__regel';
      arr.forEach(function (n) { ln.appendChild(n); });
      h.appendChild(ln);
      if (gespeeld) { ln.style.animation = 'none'; ln.style.opacity = '1'; ln.style.transform = 'none'; ln.style.clipPath = 'none'; return; }
      ln.style.animationDelay = (i * STEP) + 's';
      Array.prototype.forEach.call(
        ln.querySelectorAll('.acms__accent, .acms__semi'),
        function (a) { a.style.transitionDelay = (i * STEP + ACCENT) + 's'; }
      );
    });
    if (!gespeeld) {
      var laatste = (regels.length - 1) * STEP + TAIL;
      Array.prototype.forEach.call(sec.querySelectorAll('.acms__op'), function (el, k) {
        el.style.transitionDelay = (laatste + k * 0.09) + 's';
      });
    }
  }
  /* Thema's en andere secties zetten soms opacity, visibility of
     -webkit-text-fill-color op nul. Daarom hier expliciet en met voorrang. */
  function zichtbaar(h) {
    h.style.setProperty('opacity', '1', 'important');
    h.style.setProperty('visibility', 'visible', 'important');
    h.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    Array.prototype.forEach.call(h.querySelectorAll('.acms__regel'), function (ln) {
      ln.style.setProperty('visibility', 'visible', 'important');
      ln.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    });
  }
  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.acms__kop'), function (h) {
      var sec = h.closest('.acms-sectie') || h.closest('section') || h.parentElement;
      var box = h.parentElement;
      if (!sec || sec.getAttribute('data-acms-klaar') === '1') return;
      sec.setAttribute('data-acms-klaar', '1');
      sec.classList.add('acms-js');
      h.setAttribute('data-acms-bron', h.innerHTML);
      zichtbaar(h);
      var raf, b = 0;
      function plan() { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { build(h, sec); zichtbaar(h); }); }
      plan();
      if (window.ResizeObserver) {
        new ResizeObserver(function (e) {
          var nb = Math.round(e[0].contentRect.width);
          if (nb !== b) { b = nb; plan(); }
        }).observe(box);
      } else {
        window.addEventListener('resize', function () { setTimeout(plan, 120); });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(plan);
      /* Laatste redmiddel: als een thema of een andere sectie een OUDER van de
         kop op opacity 0 of visibility hidden zet, helpt forceren op de kop
         zelf niet. Daarom lopen we na het spelen de keten naar boven na. */
      function herstel() {
        var el = h;
        while (el && el !== document.body) {
          var cs = getComputedStyle(el);
          if (parseFloat(cs.opacity) === 0) el.style.setProperty('opacity', '1', 'important');
          if (cs.visibility === 'hidden') el.style.setProperty('visibility', 'visible', 'important');
          if (el === sec) break;
          el = el.parentElement;
        }
      }
      function speel() {
        sec.setAttribute('data-acms-gespeeld', '1');
        sec.classList.add('acms-in');
        zichtbaar(h);
        setTimeout(function () { zichtbaar(h); herstel(); }, 400);
      }
      /* Eén zichtbare pixel is genoeg. Met een drempel van 20% blijft de kop
         van een sectie die hoger is dan vijf schermen voor altijd weggeknipt. */
      if (RM.matches || !('IntersectionObserver' in window)) { speel(); return; }
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { speel(); io.disconnect(); }
      }, { threshold: 0 });
      io.observe(sec);
      /* Vangnet: een kop die niet beweegt is vervelend, een kop die
         onzichtbaar blijft is een gemiste verkoop. */
      setTimeout(function () {
        if (sec.getAttribute('data-acms-gespeeld') === '1') return;
        var r = sec.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { speel(); io.disconnect(); }
      }, 1500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
})();

/* ===== ac-pluto-patrijspoort ===== */
/* De video in het raam speelt geluidloos en blijft in een lus draaien. De
   browser krijgt play() meerdere keren aangeboden: zodra de video geladen
   is, zodra het raam in beeld komt, zodra het tabblad weer zichtbaar is,
   na een pauze die de browser zelf inlast en, mocht automatisch afspelen
   geblokkeerd zijn, bij de eerste aanraking, klik of scroll op de pagina.
   Met ac_video_altijd = 'nee' blijft de video op het poster-beeld staan
   voor wie beweging heeft uitgezet (5.6). */
(function () {
/* Stond als Liquid in het script; in een gecachet bestand blijft dat
   letterlijke tekst. Nu leest het script de instelling van de sectie. */
var DEBUG = /acpvdebug/.test(window.location.hash + window.location.search);
function start(video) {
if (video.getAttribute('data-acpv-klaar')) return;
var wrap = video.closest('[data-acpv]');
var ALTIJD = !!(wrap && wrap.getAttribute('data-acpv-altijd') === 'ja');
video.setAttribute('data-acpv-klaar', '1');
var laatste = '';
video.muted = true; video.defaultMuted = true; video.volume = 0; video.loop = true;
video.addEventListener('volumechange', function () { if (!video.muted) { video.muted = true; } });
var minder = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (minder && !ALTIJD) { video.removeAttribute('autoplay'); video.pause(); laatste = 'stil: verminder beweging'; }
var bezig = false, herstart = 0;
function speel() {
if (minder && !ALTIJD) return;
if (bezig || (!video.paused && !video.ended)) return;
bezig = true;
var p = null;
try { p = video.play(); } catch (e) { p = null; laatste = 'play() fout: ' + (e && e.name); }
if (p && typeof p.then === 'function') { p.then(function () { bezig = false; laatste = 'play() ok'; }, function (e) { bezig = false; laatste = 'play() geweigerd: ' + (e && e.name) + ' ' + (e && e.message); }); } else { bezig = false; }
}
['loadedmetadata', 'loadeddata', 'canplay'].forEach(function (ev) { video.addEventListener(ev, speel); });
video.addEventListener('playing', function () { setTimeout(function () { herstart = 0; }, 3000); });
video.addEventListener('ended', function () { try { video.currentTime = 0; } catch (e) {} speel(); });
video.addEventListener('pause', function () { if (!video.ended && document.visibilityState !== 'hidden' && herstart < 12) { herstart++; setTimeout(speel, 250); } });
video.addEventListener('error', function () { laatste = 'laadfout'; });
document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') { speel(); } });
window.addEventListener('pageshow', function () { speel(); });
if ('IntersectionObserver' in window) { new IntersectionObserver(function (items) { items.forEach(function (it) { if (it.isIntersecting) { speel(); } }); }, { threshold: 0.05 }).observe(video); }
var wek = ['touchstart', 'touchend', 'pointerdown', 'mousedown', 'click', 'keydown', 'scroll', 'wheel'];
function wakker() { speel(); if (!video.paused) { wek.forEach(function (ev) { document.removeEventListener(ev, wakker, true); }); } }
wek.forEach(function (ev) { document.addEventListener(ev, wakker, { capture: true, passive: true }); });
if (video.readyState === 0) { try { video.load(); } catch (e) {} }
speel();
if (DEBUG) {
var sec = video.closest('.acpv') || video.parentElement;
var badge = document.createElement('span'); badge.className = 'acpv__debug'; sec.appendChild(badge);
var bron = video.currentSrc || (video.querySelector('source') ? video.querySelector('source').getAttribute('src') : '');
setInterval(function () {
var err = video.error ? ('fout ' + video.error.code + (video.error.message ? ' ' + video.error.message : '')) : 'geen fout';
badge.textContent = (video.paused ? 'GEPAUZEERD' : 'SPEELT') + ' · tijd ' + video.currentTime.toFixed(1) + 's · laadstatus ' + video.readyState + '/4 · net ' + video.networkState + ' · ' + err + ' · verminder beweging ' + (minder ? 'aan' : 'uit') + ' · altijd ' + (ALTIJD ? 'ja' : 'nee') + ' · muted ' + video.muted + ' · ' + (laatste || 'nog geen play()-antwoord') + ' · bron ' + bron.split('/').pop().slice(0, 48) + ' · ' + navigator.userAgent.slice(0, 90);
}, 500);
}
}
function init() { document.querySelectorAll('video.acpv__video').forEach(start); }
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* Flush-helper met een eigen vlag en een eigen klasse: meet de ruimte van
   de thema-wrapper en trekt de sectie door tot de rand van de pagina. */
(function () {
  if (window.__acPvFlush) return;
  window.__acPvFlush = true;
  function apply() {
    document.querySelectorAll('.acpv--flush').forEach(function (sec) {
      var node = sec.parentElement;
      while (node && node !== document.body) {
        var cs = getComputedStyle(node);
        if (parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) ||
            parseFloat(cs.marginTop)  || parseFloat(cs.marginBottom)) {
          node.style.paddingTop = '0px'; node.style.paddingBottom = '0px';
          node.style.marginTop = '0px';  node.style.marginBottom = '0px';
        }
        node = node.parentElement;
      }
      sec.style.marginLeft = ''; sec.style.marginRight = '';
      sec.style.width = 'auto'; sec.style.maxWidth = 'none';
      var rect = sec.getBoundingClientRect();
      var docWidth = document.documentElement.clientWidth;
      var left = rect.left, right = docWidth - rect.right;
      if (left  > 0.5) sec.style.marginLeft  = (-left)  + 'px';
      if (right > 0.5) sec.style.marginRight = (-right) + 'px';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  window.addEventListener('load', apply);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 120); });
})();

/* DE GARANTIE OP TWEE REGELS. De regels staan vast in de HTML en mogen niet
   wikkelen. Dit script meet de breedste regel en verlaagt de lettergrootte
   in stappen tot hij past. Alleen font-size verandert. */
(function () {
function pas(sec) {
var kop = sec.querySelector('.acpv__kop');
if (!kop) return;
var vak = kop.parentElement;
var regels = Array.prototype.slice.call(kop.querySelectorAll('.acpv__regel > span'));
if (!regels.length) return;
kop.style.fontSize = '';
var maat = parseFloat(getComputedStyle(kop).fontSize) || 24;
for (var i = 0; i < 40; i++) {
var ruimte = vak.clientWidth;
var breedst = 0;
regels.forEach(function (s) { if (s.scrollWidth > breedst) breedst = s.scrollWidth; });
if (!ruimte || breedst <= ruimte || maat <= 15) break;
maat = Math.max(15, maat - Math.max(1, Math.round(maat * 0.04)));
kop.style.fontSize = maat + 'px';
}
}
function start() {
document.querySelectorAll('[data-acpv]').forEach(function (sec) {
pas(sec);
if (sec.dataset.acpvFit === '1') return;
sec.dataset.acpvFit = '1';
var vak = sec.querySelector('.acpv__text');
if (window.ResizeObserver && vak) {
var b = 0, tm = null;
new ResizeObserver(function (e) {
var nb = Math.round(e[0].contentRect.width);
if (nb === b || !nb) return;
b = nb;
clearTimeout(tm);
tm = setTimeout(function () { pas(sec); }, 90);
}).observe(vak);
} else {
window.addEventListener('resize', function () { setTimeout(function () { pas(sec); }, 140); });
}
if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { pas(sec); });
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
window.addEventListener('load', start);
document.addEventListener('shopify:section:load', start);
})();

/* ===== ac-pluto-usps ===== */
/* Kopanimatie §4.8 — identiek blok in alle AlienComfort-secties, idempotent.
   Regel voor regel, 80 ms ertussen, accent 220 ms later, de rest 300 ms na
   de laatste regel. ResizeObserver op de inhoudscontainer: een opgeknipte
   kop kan niet meer herwikkelen. */

/* ===== ac-pluto-kenmerken ===== */
/* Rijen komen binnen zodra ze in beeld staan. Zonder JavaScript, en bij
   prefers-reduced-motion, staat alles gewoon zichtbaar (5.6). */
(function () {
  var init = function () {
    document.querySelectorAll('[data-acpk]:not([data-acpk-klaar])').forEach(function (sec) {
      sec.setAttribute('data-acpk-klaar', '1');
      var rijen = Array.prototype.slice.call(sec.querySelectorAll('.acpk__rij'));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      if (!('IntersectionObserver' in window)) { return; }
      sec.classList.add('acpk-js');
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      rijen.forEach(function (r) { io.observe(r); });
      /* Vangnet: staat een rij na anderhalve seconde nog onzichtbaar
         terwijl hij wel in beeld is, dan zetten wij hem alsnog aan. */
      setTimeout(function () {
        rijen.forEach(function (r) {
          var b = r.getBoundingClientRect();
          if (b.top < window.innerHeight && b.bottom > 0) { r.classList.add('is-in'); }
        });
      }, 1500);
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-pluto-banner ===== */
/* Flush-helper: meet op hoeveel ruimte de Shopify-container eromheen zet
   en trekt de sectie tot de schermrand door. Draait één keer per pagina. */

/* ===== ac-pluto-specificaties ===== */
/* Uitklappen per groep. Op desktop staat de knop op display:none en staat
   alles al open; het script hoeft daar niets te doen. */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-specs-p]:not([data-ac-ready-p])').forEach(function (root) {
      root.setAttribute('data-ac-ready-p', '1');
      root.querySelectorAll('[data-ac-more-p]').forEach(function (btn) {
        var card = btn.closest('[data-ac-card-p]');
        var label = btn.querySelector('span');
        btn.addEventListener('click', function () {
          var open = card.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (label) { label.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore; }
        });
      });
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===========================================================================
   AlienComfort | Kopanimatie 4.8 - v6, VOLLEDIG OP ZICHZELF
   Alle klassenamen, keyframes en variabelen in dit blok dragen het
   voorvoegsel "acsp-p". Er staat geen enkele window-variabele in. Een andere
   sectie op dezelfde pagina, oud of nieuw, kan deze kop dus niet aanraken en
   deze kop raakt geen andere sectie aan.
   =========================================================================== */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STEP = 0.08, ACCENT = 0.22, TAIL = 0.30;
  function wrap(h) {
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
          var s = document.createElement('span');
          s.className = 'acsp-p__w'; s.textContent = p;
          frag.appendChild(s);
        });
        h.replaceChild(frag, n);
      } else if (n.nodeType === 1) { n.classList.add('acsp-p__w'); }
    });
  }
  function build(h, sec) {
    var gespeeld = sec.getAttribute('data-acsp-gespeeld-p') === '1';
    h.innerHTML = h.getAttribute('data-acsp-bron-p');
    wrap(h);
    var regels = [], nu = null, top = null;
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.classList.contains('acsp-p__w')) {
        var t = Math.round(n.offsetTop);
        if (top === null || Math.abs(t - top) > 2) { top = t; nu = []; regels.push(nu); }
        nu.push(n);
      } else if (nu) { nu.push(n); }
    });
    h.innerHTML = '';
    regels.forEach(function (arr, i) {
      var ln = document.createElement('span');
      ln.className = 'acsp-p__regel';
      arr.forEach(function (n) { ln.appendChild(n); });
      h.appendChild(ln);
      if (gespeeld) { ln.style.animation = 'none'; ln.style.opacity = '1'; ln.style.transform = 'none'; ln.style.clipPath = 'none'; return; }
      ln.style.animationDelay = (i * STEP) + 's';
      Array.prototype.forEach.call(
        ln.querySelectorAll('.acsp-p__accent, .acsp-p__semi'),
        function (a) { a.style.transitionDelay = (i * STEP + ACCENT) + 's'; }
      );
    });
    if (!gespeeld) {
      var laatste = (regels.length - 1) * STEP + TAIL;
      Array.prototype.forEach.call(sec.querySelectorAll('.acsp-p__op'), function (el, k) {
        el.style.transitionDelay = (laatste + k * 0.09) + 's';
      });
    }
  }
  /* Thema's en andere secties zetten soms opacity, visibility of
     -webkit-text-fill-color op nul. Daarom hier expliciet en met voorrang. */
  function zichtbaar(h) {
    h.style.setProperty('opacity', '1', 'important');
    h.style.setProperty('visibility', 'visible', 'important');
    h.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    Array.prototype.forEach.call(h.querySelectorAll('.acsp-p__regel'), function (ln) {
      ln.style.setProperty('visibility', 'visible', 'important');
      ln.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    });
  }
  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.acsp-p__kop'), function (h) {
      var sec = h.closest('.acsp-sectie') || h.closest('section') || h.parentElement;
      var box = h.parentElement;
      if (!sec || sec.getAttribute('data-acsp-klaar-p') === '1') return;
      sec.setAttribute('data-acsp-klaar-p', '1');
      sec.classList.add('acsp-js');
      h.setAttribute('data-acsp-bron-p', h.innerHTML);
      zichtbaar(h);
      var raf, b = 0;
      function plan() { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { build(h, sec); zichtbaar(h); }); }
      plan();
      if (window.ResizeObserver) {
        new ResizeObserver(function (e) {
          var nb = Math.round(e[0].contentRect.width);
          if (nb !== b) { b = nb; plan(); }
        }).observe(box);
      } else {
        window.addEventListener('resize', function () { setTimeout(plan, 120); });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(plan);
      function herstel() {
        var el = h;
        while (el && el !== document.body) {
          var cs = getComputedStyle(el);
          if (parseFloat(cs.opacity) === 0) el.style.setProperty('opacity', '1', 'important');
          if (cs.visibility === 'hidden') el.style.setProperty('visibility', 'visible', 'important');
          if (el === sec) break;
          el = el.parentElement;
        }
      }
      function speel() {
        sec.setAttribute('data-acsp-gespeeld-p', '1');
        sec.classList.add('acsp-in');
        zichtbaar(h);
        setTimeout(function () { zichtbaar(h); herstel(); }, 400);
      }
      /* Eén zichtbare pixel is genoeg. Met een drempel van 20 procent blijft
         de kop van een sectie die hoger is dan vijf schermen weggeknipt. */
      if (RM.matches || !('IntersectionObserver' in window)) { speel(); return; }
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { speel(); io.disconnect(); }
      }, { threshold: 0 });
      io.observe(sec);
      setTimeout(function () {
        if (sec.getAttribute('data-acsp-gespeeld-p') === '1') return;
        var r = sec.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { speel(); io.disconnect(); }
      }, 1500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
})();

/* Flush-helper met een eigen vlag en een eigen klasse. Shopify zet een
   Custom Liquid-sectie in een container die smaller is dan het scherm, met
   eigen ruimte eromheen. Bij een witte sectie ziet u dat niet, bij een
   ruimtezwarte krijgt u stroken paginakleur links, rechts, boven en onder.
   Hoeveel dat is verschilt per thema, dus dit meet het op en trekt de
   sectie door tot de rand. */
(function () {
  if (window.__acSpecsFlush) return;
  window.__acSpecsFlush = true;
  function apply() {
    document.querySelectorAll('.ac-specs-p--flush').forEach(function (sec) {
      var node = sec.parentElement;
      while (node && node !== document.body) {
        var cs = getComputedStyle(node);
        if (parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) ||
            parseFloat(cs.marginTop)  || parseFloat(cs.marginBottom)) {
          node.style.paddingTop = '0px'; node.style.paddingBottom = '0px';
          node.style.marginTop = '0px';  node.style.marginBottom = '0px';
        }
        node = node.parentElement;
      }
      sec.style.marginLeft = ''; sec.style.marginRight = '';
      sec.style.width = 'auto'; sec.style.maxWidth = 'none';
      var rect = sec.getBoundingClientRect();
      var docWidth = document.documentElement.clientWidth;
      var left = rect.left, right = docWidth - rect.right;
      if (left  > 0.5) sec.style.marginLeft  = (-left)  + 'px';
      if (right > 0.5) sec.style.marginRight = (-right) + 'px';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  window.addEventListener('load', apply);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 120); });
})();

/* ===== ac-reviews-pluto ===== */
(function () {
function init() {
document.querySelectorAll('[data-ac-rev-p]:not([data-ac-klaar-p])').forEach(function (root) {
root.setAttribute('data-ac-klaar-p', '1');
var T = JSON.parse(root.querySelector('[data-ac-rev-t-p]').textContent);
var loc = root.getAttribute('data-loc') || 'nl-NL';
var data = {};
try { data = JSON.parse(root.getAttribute('data-ac-rev-data-p') || '{}') || {}; } catch (fout) { data = {}; }
var alles = (data.reviews || []).filter(function (r) { return r && r.body != null; });
var elSamen = root.querySelector('[data-ac-rev-samen-p]');
var elFilters = root.querySelector('[data-ac-rev-filters-p]');
var elPijlen = root.querySelector('[data-ac-rev-pijlen-p]');
var spoor = root.querySelector('[data-ac-rev-spoor-p]');
var licht = root.querySelector('[data-ac-rev-licht-p]');
var lichtBeeld = root.querySelector('[data-ac-rev-lichtbeeld-p]');
var alleenFoto = false;
var STERPAD = 'm12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.9L12 17.8 5.8 21l1.2-6.9-5-4.9 6.9-1z';
function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}
/* §4.2: de hele ster is champagne, gevuld of niet. Vol is een vlak, half
   is links gevuld en rechts contour, leeg is alleen de contourlijn.
   Nooit een grijze of lichtgrijze lege ster: dat maakt er twee kleuren
   van. */
function ster(soort, hoog) {
var maat = ' style="width:' + hoog + 'px;height:' + hoog + 'px"';
var vol = '<svg class="ac-rev-p__ster is-vol" viewBox="0 0 24 24" aria-hidden="true"' + maat + '><path d="' + STERPAD + '"></path></svg>';
var leeg = '<svg class="ac-rev-p__ster is-leeg" viewBox="0 0 24 24" aria-hidden="true"' + maat + '><path d="' + STERPAD + '"></path></svg>';
if (soort === 'vol') { return vol; }
if (soort === 'leeg') { return leeg; }
return '<span class="ac-rev-p__ster-half"' + maat + '>' + leeg + vol + '</span>';
}
function sterren(waarde, hoog) {
var uit = '';
for (var i = 1; i <= 5; i++) {
var v = waarde - i + 1;
uit += ster(v >= 0.75 ? 'vol' : (v >= 0.25 ? 'half' : 'leeg'), hoog);
}
return '<span class="ac-rev-p__sterren" role="img" aria-label="' + (Math.round(waarde * 10) / 10) + ' / 5">' + uit + '</span>';
}
function datum(iso) {
var d = new Date(iso);
if (isNaN(d.getTime())) { return ''; }
return d.toLocaleDateString(loc, { day: 'numeric', month: 'long', year: 'numeric' });
}
function initialen(naam) {
return String(naam || '?').trim().split(/\s+/).slice(0, 2).map(function (w) { return w.charAt(0); }).join('').toUpperCase();
}
/* De optelling van Okendo is leidend. Ontbreekt die, dan rekenen wij hem
   uit de reviews zelf, zodat er altijd iets klopt. */
function optelling() {
var a = data.reviewAggregate || {};
var n = a.ratingAndReviewCount || alles.length;
if (!n) { return null; }
var som = a.ratingAndReviewValuesTotal;
if (som == null) { som = alles.reduce(function (t, r) { return t + (r.rating || 0); }, 0); }
var aanbevolen = a.recommendationCount;
if (aanbevolen == null) { aanbevolen = alles.filter(function (r) { return r.isRecommended; }).length; }
return { n: n, gem: som / n, aanbevolen: aanbevolen };
}
function tekenSamen() {
var o = optelling();
if (!o) { elSamen.innerHTML = '<p class="ac-rev-p__leeg">' + esc(T.leeg) + '</p>'; return; }
var pct = o.n ? Math.round(o.aanbevolen / o.n * 100) : 0;
elSamen.innerHTML =
'<span class="ac-rev-p__cijfer">' + o.gem.toFixed(1).replace('.', ',') + '</span>' +
'<span class="ac-rev-p__cijferbij">' + sterren(o.gem, 17) +
'<span class="ac-rev-p__aantal">' + o.n + ' ' + esc(T.op) +
(o.aanbevolen ? '<b>' + pct + '% ' + esc(T.aanbevolen) + '</b>' : '') + '</span></span>';
}
function tekenFilters() {
var metFoto = alles.filter(function (r) { return r.media && r.media.length; }).length;
if (!metFoto || alles.length < 3) { elFilters.hidden = true; return; }
elFilters.hidden = false;
elFilters.innerHTML =
'<button type="button" class="ac-rev-p__chip' + (alleenFoto ? '' : ' is-aan') + '" data-foto="0">' + esc(T.alle) + ' (' + alles.length + ')</button>' +
'<button type="button" class="ac-rev-p__chip' + (alleenFoto ? ' is-aan' : '') + '" data-foto="1">' + esc(T.metfoto) + ' (' + metFoto + ')</button>';
}
function lijst() {
var uit = alles.slice();
if (alleenFoto) { uit = uit.filter(function (r) { return r.media && r.media.length; }); }
uit.sort(function (a, b) { return new Date(b.dateCreated) - new Date(a.dateCreated); });
return uit;
}
function tekenSpoor() {
var rij = lijst();
/* Bij drie of minder wordt het een rij, anders staat de tweede half leeg. */
spoor.style.gridTemplateRows = rij.length > 3 ? 'repeat(2, minmax(0, 1fr))' : 'minmax(0, 1fr)';
spoor.innerHTML = rij.map(function (r) {
var rv = r.reviewer || {};
var avatar = rv.avatarUrl
? '<span class="ac-rev-p__avatar"><img src="' + esc(rv.avatarUrl) + '" alt="" loading="lazy"></span>'
: '<span class="ac-rev-p__avatar ac-rev-p__avatar--letters">' + esc(initialen(rv.displayName)) + '</span>';
/* De foto is geen bijlage onderaan maar de kop van de kaart. Meer dan
   één foto: de eerste vult de kop, de rest zit onder een telbadge. */
var fotos = (r.media || []).filter(function (m) { return m.thumbnailUrl; });
var kop = '';
if (fotos.length) {
var eerste = fotos[0];
kop = '<button type="button" class="ac-rev-p__beeld" data-groot="' + esc(eerste.largeUrl || eerste.fullSizeUrl) + '">' +
'<img src="' + esc(eerste.largePortraitThumbnailUrl || eerste.largeUrl || eerste.thumbnailUrl) + '" alt="' + esc(eerste.alt || '') + '" loading="lazy">' +
(fotos.length > 1 ? '<span class="ac-rev-p__telbadge">+' + (fotos.length - 1) + '</span>' : '') +
'</button>';
}
var regels = String(r.body || '').split(/\n+/).filter(function (t) { return t.trim(); })
.map(function (t) { return '<span>' + esc(t) + '</span>'; }).join('');
return '<article class="ac-rev-p__kaart' + (fotos.length ? ' ac-rev-p__kaart--beeld' : '') + '">' + kop +
'<div class="ac-rev-p__body">' +
'<div class="ac-rev-p__meta">' + sterren(r.rating || 0, 13) + '<time>' + esc(datum(r.dateCreated)) + '</time></div>' +
(r.title && r.title.trim() ? '<h3 class="ac-rev-p__kaarttitel">' + esc(r.title.trim()) + '</h3>' : '') +
'<div class="ac-rev-p__tekst" data-ac-rev-tekst-p>' + regels + '</div>' +
'<button type="button" class="ac-rev-p__uitklap" data-ac-rev-uit-p hidden>' + esc(T.meerlezen) + '</button>' +
'<footer class="ac-rev-p__voetregel">' + avatar +
'<span class="ac-rev-p__wie"><strong>' + esc(rv.displayName || '') + '</strong>' +
'<em>' + (rv.isVerified ? esc(T.geverifieerd) : (r.helpfulCount ? r.helpfulCount + ' ' + esc(T.nuttig) : '')) + '</em></span></footer>' +
'</div></article>';
}).join('');
/* Alleen een uitklapknop tonen waar de tekst werkelijk niet past. */
spoor.querySelectorAll('[data-ac-rev-tekst-p]').forEach(function (el) {
if (el.scrollHeight > el.clientHeight + 2) { el.nextElementSibling.hidden = false; }
});
setTimeout(pijlen, 60);
}
/* De pijlen verdwijnen als alles al past. Niets is vervelender dan een
   pijl die nergens heen gaat. */
function pijlen() {
elPijlen.hidden = spoor.scrollWidth <= spoor.clientWidth + 4;
}
function schuif(kant) {
var stap = Math.max(240, Math.round(spoor.clientWidth * 0.8));
var zacht = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
spoor.scrollBy({ left: kant * stap, behavior: zacht ? 'smooth' : 'auto' });
}
root.querySelector('[data-ac-rev-links-p]').addEventListener('click', function () { schuif(-1); });
root.querySelector('[data-ac-rev-rechts-p]').addEventListener('click', function () { schuif(1); });
window.addEventListener('resize', function () { clearTimeout(root.__t); root.__t = setTimeout(pijlen, 150); });
/* Slepen met de muis. Op een aanraakscherm doet de browser dit zelf. */
var sleept = false, startX = 0, startL = 0, bewogen = false;
spoor.addEventListener('pointerdown', function (e) {
if (e.pointerType === 'touch') { return; }
sleept = true; bewogen = false; startX = e.clientX; startL = spoor.scrollLeft;
spoor.classList.add('is-sleep');
});
window.addEventListener('pointermove', function (e) {
if (!sleept) { return; }
var d = e.clientX - startX;
if (Math.abs(d) > 3) { bewogen = true; }
spoor.scrollLeft = startL - d;
});
window.addEventListener('pointerup', function () {
if (!sleept) { return; }
sleept = false; spoor.classList.remove('is-sleep');
});
spoor.addEventListener('click', function (e) { if (bewogen) { e.preventDefault(); e.stopPropagation(); } }, true);
elFilters.addEventListener('click', function (e) {
var b = e.target.closest('[data-foto]'); if (!b) { return; }
alleenFoto = b.getAttribute('data-foto') === '1';
spoor.scrollLeft = 0; tekenFilters(); tekenSpoor();
});
spoor.addEventListener('click', function (e) {
var uit = e.target.closest('[data-ac-rev-uit-p]');
if (uit) { uit.previousElementSibling.classList.add('is-open'); uit.hidden = true; setTimeout(pijlen, 60); return; }
var b = e.target.closest('.ac-rev-p__beeld'); if (!b) { return; }
lichtBeeld.src = b.getAttribute('data-groot');
licht.hidden = false;
document.body.style.overflow = 'hidden';
});
function dicht() { licht.hidden = true; lichtBeeld.src = ''; document.body.style.overflow = ''; }
licht.addEventListener('click', dicht);
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !licht.hidden) { dicht(); } });
if (!alles.length) { root.classList.add('ac-rev-p--leeg'); }
tekenSamen(); tekenFilters(); tekenSpoor();
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* Kopanimatie §4.8 — identiek blok in alle AlienComfort-secties, idempotent. */

/* Flush-helper: meet de ruimte van de thema-wrapper en trekt de sectie
   door tot de rand van de pagina. Draait één keer per pagina. */

/* ===== ac-vergelijker-pluto ===== */
(function(){
  var sec=document.querySelector('[data-ac-vp-p]:not([data-klaar])');
  if(!sec) return;
  sec.setAttribute('data-klaar','1');
  var LIVE=JSON.parse(sec.querySelector('[data-vp-live]').textContent);
  var D=JSON.parse(sec.querySelector('[data-vp-data]').textContent);
  var T=D.t, S=D.stoelen;
  var ORDE=['pluto','nova','luna','astron','pulsar','atlas','titan'];
  var zelf=sec.getAttribute('data-zelf');
  function esc(x){return String(x==null?'':x).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function niv(id){return parseInt(String(S[id].i).split('|')[0],10)||0;}
  /* Buren op de intensiteitsladder: het dichtstbijzijnde zachtere en het
     dichtstbijzijnde stevigere model. */
  var i0=ORDE.indexOf(zelf);
  var zachter=null, steviger=null;
  for(var i=i0-1;i>=0;i--){ if(niv(ORDE[i])<niv(zelf)){zachter=ORDE[i];break;} }
  for(var j=i0+1;j<ORDE.length;j++){ if(niv(ORDE[j])>niv(zelf)){steviger=ORDE[j];break;} }
  /* Staat het model aan een uiteinde van de ladder, dan bestaat één van de
     twee buren niet. Wij vullen aan met het dichtstbijzijnde andere model
     en geven dat een neutraal label: "één stap zachter" boven een model dat
     juist steviger is, zou onjuist zijn. */
  var lZacht = T.zachter, lStevig = T.steviger;
  if(!zachter){
    for(var a=0;a<ORDE.length;a++){ if(ORDE[a]!==zelf && ORDE[a]!==steviger){ zachter=ORDE[a]; break; } }
    lZacht = T.ook;
  }
  if(!steviger){
    for(var b=ORDE.length-1;b>=0;b--){ if(ORDE[b]!==zelf && ORDE[b]!==zachter){ steviger=ORDE[b]; break; } }
    lStevig = T.ook;
  }
  /* De middelste kaart leest prijs, voorraad en foto uit het product van
     deze pagina, zodat de grijze LUNA ook echt de grijze laat zien. */
  function live(id,isZelf){
    if(isZelf && LIVE.zelf && LIVE.zelf.url){ return LIVE.zelf; }
    return LIVE[id]||{};
  }
  function meter(v){
    var d=String(v).split('|'), n=parseInt(d[0],10)||0, bl='';
    for(var k=1;k<=4;k++){bl+='<i'+(k<=n?' class="is-aan"':'')+'></i>';}
    return '<span class="ac-vp-p__meter"><span class="ac-vp-p__mblok">'+bl+'</span>'+esc(d[1]||'')+'</span>';
  }
  function kaart(id,vlag,isZelf){
    var s=S[id]||{}, c=live(id,isZelf);
    return '<div class="ac-vp-p__kaart'+(isZelf?' ac-vp-p__kaart--zelf':'')+'">'
      +'<span class="ac-vp-p__vlag">'+esc(vlag)+'</span>'
      +'<div class="ac-vp-p__top">'
      +(c.img?'<img class="ac-vp-p__foto" src="'+esc(c.img)+'" alt="" loading="lazy" decoding="async">':'')
      +'<span class="ac-vp-p__wie"><span class="ac-vp-p__naam">'+esc(s.n)+'</span>'
      +'<span class="ac-vp-p__prijs">'+esc(c.prijs||'')+'</span>'
      +'<span class="ac-vp-p__status '+(c.op?'is-op':'is-pre')+'">'+esc(c.op?T.op:T.pre)+'</span></span></div>'
      +'<dl class="ac-vp-p__regels">'
      +'<div><dt>'+esc(T.sys)+'</dt><dd>'+esc(s.sys)+'</dd></div>'
      +'<div><dt>'+esc(T.int)+'</dt><dd>'+meter(s.i)+'</dd></div>'
      +'<div><dt>'+esc(T.diep)+'</dt><dd>'+esc(s.d)+'</dd></div>'
      +'<div><dt>'+esc(T.breed)+'</dt><dd>'+esc(s.b)+'</dd></div>'
      +'<div><dt>'+esc(T.kg)+'</dt><dd>'+esc(s.kg)+'</dd></div>'
      +'</dl>'
      +(isZelf||!c.url?'':'<a class="ac-vp-p__link" href="'+esc(c.url)+'">'+esc(s.n)+' &rarr;</a>')
      +'</div>';
  }
  sec.querySelector('[data-vp-rij]').innerHTML =
    kaart(zachter,lZacht,false) + kaart(zelf,T.deze,true) + kaart(steviger,lStevig,false);
  sec.querySelector('[data-vp-knop]').textContent = T.knop;
  /* Op mobiel is de rij een swipe-rij. Begin op het eigen model, dat in het
     midden staat, zodat de bezoeker ziet waar hij is. Zonder animatie: dit
     is de startstand en geen beweging. */
  var rij = sec.querySelector('[data-vp-rij]');
  function startpositie(){
    if(window.innerWidth > 749){ rij.scrollLeft = 0; return; }
    var mid = rij.querySelector('.ac-vp-p__kaart--zelf');
    if(mid){ rij.scrollLeft = mid.offsetLeft - rij.offsetLeft; }
  }
  startpositie();
  var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(startpositie, 150); });
})();

/* Kopanimatie 4.8, gedeeld blok, idempotent. */

/* ===== ac-faq-pluto ===== */
(function () {
if (window.__acFaqFlush) return;
window.__acFaqFlush = true;
function apply() {
document.querySelectorAll('.ac-faq-p--flush').forEach(function (sec) {
var node = sec.parentElement;
while (node && node !== document.body) {
var cs = getComputedStyle(node);
if (parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) ||
parseFloat(cs.marginTop)  || parseFloat(cs.marginBottom)) {
node.style.paddingTop    = '0px';
node.style.paddingBottom = '0px';
node.style.marginTop     = '0px';
node.style.marginBottom  = '0px';
}
node = node.parentElement;
}
sec.style.marginLeft  = '';
sec.style.marginRight = '';
sec.style.width       = 'auto';
sec.style.maxWidth    = 'none';
var rect = sec.getBoundingClientRect();
var docWidth = document.documentElement.clientWidth;
var left  = rect.left;
var right = docWidth - rect.right;
if (left  > 0.5) sec.style.marginLeft  = (-left)  + 'px';
if (right > 0.5) sec.style.marginRight = (-right) + 'px';
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', apply);
} else {
apply();
}
window.addEventListener('load', apply);
var t;
window.addEventListener('resize', function () {
clearTimeout(t);
t = setTimeout(apply, 120);
});
})();

(function () {
function init() {
document.querySelectorAll('[data-ac-faq-p]').forEach(function (root) {
if (root.dataset.acReady === '1') return;
root.dataset.acReady = '1';
var items = Array.prototype.slice.call(root.querySelectorAll('.ac-faq-p__item'));
items.forEach(function (item) {
item.addEventListener('toggle', function () {
if (!item.open) return;
items.forEach(function (other) {
if (other !== item) other.open = false;
});
});
});
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

/* ===== ac-modellen-pluto ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-xs-p]:not([data-ac-ready-p])').forEach(function (root) {
      root.setAttribute('data-ac-ready-p', '1');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ac-tab-p]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ac-panel-p]'));
      if (!tabs.length) { return; }
      var select = function (key) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-ac-tab-p') === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          if (p.getAttribute('data-ac-panel-p') === key) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
      };
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t.getAttribute('data-ac-tab-p')); });
        t.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = (i + 1) % tabs.length; }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = (i - 1 + tabs.length) % tabs.length; }
          if (next === null) { return; }
          e.preventDefault();
          select(tabs[next].getAttribute('data-ac-tab-p'));
          tabs[next].focus();
        });
      });
      /* Productpagina's alvast ophalen zodra een link wordt aangeraakt,
         zodat de doorklik direct voelt. Elke url maar één keer. */
      var geladen = {};
      root.querySelectorAll('.ac-xs-p__main, .ac-xs-p__var').forEach(function (link) {
        var laad = function () {
          if (!link.href || geladen[link.href]) { return; }
          geladen[link.href] = true;
          var l = document.createElement('link');
          l.rel = 'prefetch';
          l.href = link.href;
          document.head.appendChild(l);
        };
        link.addEventListener('mouseenter', laad);
        link.addEventListener('touchstart', laad, { passive: true });
      });
      /* Over een kleurvariant bewegen wisselt alvast de grote foto van
         het model. Klikken gaat naar de pagina van die kleur. */
      root.querySelectorAll('.ac-xs-p__card').forEach(function (card) {
        var groot = card.querySelector('.ac-xs-p__imgwrap img');
        if (!groot) { return; }
        card.querySelectorAll('.ac-xs-p__var[data-ac-img-p]').forEach(function (v) {
          v.addEventListener('mouseenter', function () {
            var bron = v.getAttribute('data-ac-img-p');
            if (!bron || groot.src === bron) { return; }
            groot.src = bron;
            groot.removeAttribute('srcset');
          });
        });
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-pdp-knoppen-pluto ===== */
/* Rekent de resterende tijd tot ac_verwacht uit (einde van die dag,
   Nederlandse tijd) en ververst elk uur. Geen seconden: dit is een
   verwachting, geen aftelklok. */
(function () {
function init() {
document.querySelectorAll('[data-ac-po-verwacht-pl]:not([data-ac-po-klaar-pl])').forEach(function (box) {
box.setAttribute('data-ac-po-klaar-pl', '1');
var uit = box.querySelector('[data-ac-po-tekst-pl]'), T = {};
if (!uit) { return; }
try { T = JSON.parse(box.nextElementSibling.textContent); } catch (e) { return; }
var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(box.getAttribute('data-ac-po-verwacht-pl') || '');
if (!m) return;
var doel = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10), 23, 59, 59).getTime();
var metUren = box.getAttribute('data-ac-po-uren-pl') !== 'uit';
function zet() {
var rest = doel - Date.now(), tekst;
if (rest <= 0) { tekst = T.voorbij; }
else {
var uren = Math.floor(rest / 3600000), dagen = Math.floor(uren / 24), h = uren % 24;
if (uren < 1) { tekst = T.vandaag; }
else if (dagen < 1) { tekst = T.uren.replace('{h}', uren); }
else if (metUren && h > 0) { tekst = (dagen === 1 ? T.daguren : T.dagenuren.replace('{d}', dagen)).replace('{h}', h); }
else if (dagen === 1) { tekst = T.dag; }
else { tekst = T.dagen.replace('{d}', dagen); }
}
if (uit.textContent !== tekst) { uit.textContent = tekst; }
}
zet();
setInterval(zet, 60000);
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* De bestelknop legt één exemplaar in de winkelwagen en opent de
   winkelwagen van het thema. Lukt dat niet, dan gaat hij naar /cart, zodat
   er nooit een klik verloren gaat. */
(function () {
function init() {
document.querySelectorAll('[data-ac-po-bestel-pl]:not([data-ac-po-klaar-pl])').forEach(function (knop) {
knop.setAttribute('data-ac-po-klaar-pl', '1');
knop.addEventListener('click', function () {
var id = knop.getAttribute('data-variant-id');
if (!id || knop.disabled) { return; }
knop.classList.add('is-bezig');
knop.disabled = true;
fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: 1 }) })
.then(function (r) { if (!r.ok) { throw new Error('toevoegen mislukt'); } return r.json(); })
.then(function () {
document.dispatchEvent(new CustomEvent('cart:refresh'));
document.dispatchEvent(new CustomEvent('cart:updated'));
var lade = document.querySelector('cart-drawer') || document.querySelector('[data-cart-drawer]') || document.querySelector('.cart-drawer');
if (lade && typeof lade.open === 'function') { lade.open(); } else { window.location.href = '/cart'; }
})
.catch(function () { window.location.href = '/cart/add?id=' + id + '&quantity=1'; })
.finally(function () { knop.classList.remove('is-bezig'); knop.disabled = false; });
});
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* De pre-orderknop scrolt naar het formulier op dezelfde pagina. Staat dat
   er niet, dan doet de knop niets in plaats van naar een lege plek te
   springen. Bij prefers-reduced-motion springt de pagina er direct heen. */
(function () {
function init() {
document.querySelectorAll('[data-ac-po-spring-pl]:not([data-ac-po-klaar-pl])').forEach(function (knop) {
knop.setAttribute('data-ac-po-klaar-pl', '1');
var doelId = knop.getAttribute('data-ac-po-spring-pl') || '';
var zacht = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
knop.addEventListener('click', function (e) {
var doel = doelId ? document.querySelector(doelId) : null;
if (!doel) { e.preventDefault(); return; }
e.preventDefault();
doel.scrollIntoView({ behavior: zacht ? 'smooth' : 'auto', block: 'start' });
if (history.replaceState) { history.replaceState(null, '', doelId); }
});
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-pdp-voorraad-pluto ===== */
document.addEventListener('DOMContentLoaded', function () {
    const deliveryBlocks = document.querySelectorAll('[data-ac-live-delivery-p]');
    if (!deliveryBlocks.length) return;

    function isWeekend(date) {
      const day = date.getDay();
      return day === 0 || day === 6;
    }

    function addBusinessDays(date, daysToAdd) {
      const result = new Date(date);
      let addedDays = 0;

      while (addedDays < daysToAdd) {
        result.setDate(result.getDate() + 1);

        if (!isWeekend(result)) {
          addedDays++;
        }
      }

      return result;
    }

    function getDeliveryDate() {
      const now = new Date();
      const hour = now.getHours();
      const day = now.getDay();

      const isSaturday = day === 6;
      const isSunday = day === 0;
      const isAfterCutoff = hour >= 17;

      if (isSaturday) {
        const monday = new Date(now);
        monday.setDate(now.getDate() + 2);
        return addBusinessDays(monday, 1);
      }

      if (isSunday) {
        const monday = new Date(now);
        monday.setDate(now.getDate() + 1);
        return addBusinessDays(monday, 1);
      }

      if (isAfterCutoff) {
        return addBusinessDays(now, 2);
      }

      return addBusinessDays(now, 1);
    }

    function getLocale(lang) {
      if (lang === 'de') return 'de-DE';
      if (lang === 'en') return 'en-GB';
      if (lang === 'fr') return 'fr-FR';
      return 'nl-NL';
    }

    function formatDeliveryDate(date, lang) {
      const locale = getLocale(lang);

      return new Intl.DateTimeFormat(locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long'
      }).format(date);
    }

    deliveryBlocks.forEach(function (block) {
      const lang = block.getAttribute('data-ac-lang-p') || 'nl';
      const dateTarget = block.querySelector('[data-ac-delivery-date-p]');
      if (!dateTarget) return;

      const deliveryDate = getDeliveryDate();
      dateTarget.textContent = formatDeliveryDate(deliveryDate, lang);
    });
  });

/* ===== ac-pdp-levering-pluto ===== */
(function () {
  var init = function () {
    document.querySelectorAll('.ac-lev:not([data-ac-ready-pl])').forEach(function (item) {
      item.setAttribute('data-ac-ready-pl', '1');
      var body = item.querySelector('.ac-lev__body');
      var kop = item.querySelector('.ac-lev__kop');
      if (!body || !kop) { return; }
      var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      body.style.gridTemplateRows = item.open ? '1fr' : '0fr';
      if (!stil) { body.style.transition = 'grid-template-rows 0.3s cubic-bezier(0.22, 1, 0.36, 1)'; }
      kop.addEventListener('click', function (e) {
        if (stil) { return; }
        e.preventDefault();
        if (item.open) {
          body.style.gridTemplateRows = '0fr';
          var dicht = function () { item.open = false; body.removeEventListener('transitionend', dicht); };
          body.addEventListener('transitionend', dicht);
        } else {
          item.open = true;
          requestAnimationFrame(function () { body.style.gridTemplateRows = '1fr'; });
        }
      });
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-pdp-knoppen-astron ===== */
document.addEventListener('DOMContentLoaded', function () {
  const preorderButtons = document.querySelectorAll('[data-ac-preorder-scroll]');

  preorderButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();

      const target =
        document.querySelector('#ac-preorder-section') ||
        document.querySelector('#preorder-section') ||
        document.querySelector('#pre-order-section') ||
        document.querySelector('#preorder') ||
        document.querySelector('[data-ac-preorder-section]');

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        window.scrollBy({
          top: Math.round(window.innerHeight * 0.85),
          behavior: 'smooth'
        });
      }
    });
  });
});

/* ===== ac-astron-opening ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var kop = sec.querySelector('[data-ac-nv-kop]');
var binnen = sec.querySelector('.ac-nv__in');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-nv__kern') || k.classList.contains('ac-nv__semi'))){ k.setAttribute('data-accent','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-nv__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-nv__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-nv]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-astron-preorder ===== */
(function(){if(window.__acPoFlush)return;window.__acPoFlush=true;function a(){document.querySelectorAll('.ac-po--flush').forEach(function(s){var n=s.parentElement;while(n&&n!==document.body){var c=getComputedStyle(n);if(parseFloat(c.paddingTop)||parseFloat(c.paddingBottom)||parseFloat(c.marginTop)||parseFloat(c.marginBottom)){n.style.paddingTop='0px';n.style.paddingBottom='0px';n.style.marginTop='0px';n.style.marginBottom='0px'}n=n.parentElement}s.style.marginLeft='';s.style.marginRight='';s.style.width='auto';s.style.maxWidth='none';var r=s.getBoundingClientRect(),w=document.documentElement.clientWidth,l=r.left,q=w-r.right;if(l>0.5)s.style.marginLeft=-l+'px';if(q>0.5)s.style.marginRight=-q+'px'})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',a)}else{a()}window.addEventListener('load',a);var t;window.addEventListener('resize',function(){clearTimeout(t);t=setTimeout(a,120)})})();

(function () {
function init() {
document.querySelectorAll('.ac-po__form').forEach(function (form) {
if (form.dataset.acReady === '1') return;
form.dataset.acReady = '1';
form.addEventListener('submit', function () {
var summary = form.querySelector('[data-ac-summary-s]');
if (!summary) return;
function val(sel) { var el = form.querySelector(sel); return el && el.value ? el.value.trim() : '-'; }
function checked(name) { var el = form.querySelector('input[name="' + name + '"]:checked'); return el ? el.value : '-'; }
/* Beide kleuren komen nu in dezelfde maand binnen, maar de maand blijft
   aan de kleur hangen. Gaan ze later weer uit elkaar lopen, dan hoeft
   alleen data-ac-eta-s per kleur te veranderen. */
var kleurEl = form.querySelector('input[name="contact[Kleur]"]:checked');
/* De maand stond als Liquid in dit script; in een gecachet bestand blijft dat
   letterlijke tekst. Nu leest het script hem van de sectie. */
var secS = form.closest('[data-ac-eta-basis]');
var etaBasis = secS ? (secS.getAttribute('data-ac-eta-basis') || '') : '';
var eta = (kleurEl && kleurEl.getAttribute('data-ac-eta-s')) || etaBasis;
var etaVeld = form.querySelector('input[name="contact[Verwachte aankomst]"]');
if (etaVeld) etaVeld.value = eta;
summary.value = [
'PRE-ORDER AANVRAAG, MASSAGESTOEL ASTRON',
'',
'Productpagina: ' + val('input[name="contact[Productpagina]"]'),
'Verwachte aankomst: ' + eta,
'',
'VOORDELEN:',
'- ' + ((secS && secS.getAttribute('data-ac-korting-s')) || '') + ' korting bovenop de getoonde prijs',
'- Voorrang bij levering en installatie',
'- 50% bij pre-order, 50% na levering',
'',
'GEGEVENS:',
'Naam: ' + val('#ac-po-name'),
'E-mail: ' + val('#ac-po-email'),
'Telefoon: ' + val('#ac-po-phone'),
'Kleur: ' + checked('contact[Kleur]'),
'Levering: ' + val('#ac-po-delivery'),
'',
'NOTITIE:',
val('#ac-po-note'),
'',
'Actie: neem contact op om de pre-order af te ronden.'
].join('\n');
});
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* ===== ac-astron-beschrijving ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var knop = sec.querySelector('[data-ac-pd-knop-s]');
var paneel = sec.querySelector('[data-ac-pd-paneel-s]');
if(knop && paneel){
knop.addEventListener('click', function(){
var open = paneel.classList.contains('is-open');
paneel.classList.toggle('is-open', !open);
knop.classList.toggle('is-open', !open);
knop.setAttribute('aria-expanded', open ? 'false' : 'true');
});
}
var kop = sec.querySelector('[data-ac-pd-kop-s]');
var binnen = sec.querySelector('.ac-pd-s__in');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-pd-s__kern') || k.classList.contains('ac-pd-s__semi'))){ k.setAttribute('data-accent-s','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent-s')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-pd-s__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-pd-s__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-pd-s]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-astron-fitmeter ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-fit-meter-s]:not([data-ac-ready-s])').forEach(function (section) {
      section.setAttribute('data-ac-ready-s', '1');
      section.querySelectorAll('.ac-meter-s').forEach(function (meter) {
        meter.style.setProperty('--fill', (meter.getAttribute('data-fill') || 0) + '%');
      });
      if (!('IntersectionObserver' in window)) { section.classList.add('is-visible'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { section.classList.add('is-visible'); io.unobserve(entry.target); }
        });
      }, { threshold: 0.25 });
      io.observe(section);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-astron-kosten ===== */
(function () {
    const section = document.getElementById('ac-astron-cost-compact');
    if (!section) return;

    const range = section.querySelector('[data-ac-range-s]');
    const yearValue = section.querySelector('[data-ac-years-s]');
    const yearLabel = section.querySelector('[data-ac-year-label-s]');
    const cards = section.querySelectorAll('[data-ac-card-s]');
    const chair = section.querySelector('[data-ac-chair-s]');
    const chairTotal = section.querySelector('[data-ac-chair-total-s]');
    const chairPer = section.querySelector('[data-ac-chair-per-s]');

    const yearSingle = section.dataset.yearSingle || 'jaar';
    const yearPlural = section.dataset.yearPlural || 'jaar';

    function formatEuro(value, decimals) {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(value);
    }

    function updateComparison() {
      const years = Number(range.value);
      const progress = ((years - 1) / 9) * 100;

      range.style.setProperty('--ac-progress', progress + '%');
      yearValue.textContent = years;
      yearLabel.textContent = years === 1 ? yearSingle : yearPlural;

      cards.forEach(function(card) {
        const rate = Number(card.dataset.rate);
        const frequency = Number(card.dataset.frequency);
        const total = rate * frequency * years;
        const target = card.querySelector('[data-ac-total-s]');
        if (target) target.textContent = formatEuro(total, 0);
      });

      if (chair && chairTotal && chairPer) {
        const price = Number(chair.dataset.price);
        const perMassage = price / (365 * years);

        chairTotal.textContent = formatEuro(price, 0);
        chairPer.textContent = formatEuro(perMassage, 2);
      }
    }

    range.addEventListener('input', updateComparison);
    updateComparison();
  })();

/* ===== ac-astron-usps ===== */
(function(){function plak(){document.querySelectorAll('.ac-usp-s').forEach(function(k){var w=k.closest('.shopify-section')||k.parentElement;if(!w)return;w.style.marginTop='0px';w.style.marginBottom='0px';var a=w.previousElementSibling,b=w.nextElementSibling;if(a)a.style.marginBottom='0px';if(b)b.style.marginTop='0px'})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',plak)}else{plak()}window.addEventListener('load',plak)})();

/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var kop = sec.querySelector('[data-ac-usp-kop-s]');
var binnen = sec.querySelector('.ac-usp-s__in');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-usp-s__kern') || k.classList.contains('ac-usp-s__semi'))){ k.setAttribute('data-accent-s','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent-s')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-usp-s__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-usp-s__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-usp-s]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-astron-kenmerken ===== */
/* Rijen komen binnen zodra ze in beeld staan. Zonder JavaScript, en bij
   prefers-reduced-motion, staat alles gewoon zichtbaar (§5.6). */
(function () {
  var init = function () {
    document.querySelectorAll('[data-acmt-s]:not([data-acmt-klaar-s])').forEach(function (sec) {
      sec.setAttribute('data-acmt-klaar-s', '1');
      var rijen = Array.prototype.slice.call(sec.querySelectorAll('.acmt-s__rij'));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      if (!('IntersectionObserver' in window)) { return; }
      sec.classList.add('acmt-js');
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      rijen.forEach(function (r) { io.observe(r); });
      /* Vangnet: staat een rij na anderhalve seconde nog onzichtbaar
         terwijl hij wel in beeld is, dan zetten we hem alsnog aan. */
      setTimeout(function () {
        rijen.forEach(function (r) {
          var b = r.getBoundingClientRect();
          if (b.top < window.innerHeight && b.bottom > 0) { r.classList.add('is-in'); }
        });
      }, 1500);
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-astron-massagesysteem ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-ms-sl]:not([data-ac-ready-sl])').forEach(function (root) {
      root.setAttribute('data-ac-ready-sl', '1');
      var videos = Array.prototype.slice.call(root.querySelectorAll('[data-ac-video-sl]'));
      if (!videos.length) { return; }
      var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* §5.6: bij verminderde beweging spelen de video's niet;
         het posterbeeld blijft staan. */
      if (stil) { return; }
      /* Spelen alleen in beeld; daarbuiten pauzeren ze. Scheelt accu
         en de pagina blijft licht. */
      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (v) { v.play().catch(function () {}); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.play().catch(function () {}); } else { e.target.pause(); }
        });
      }, { threshold: 0.25 });
      videos.forEach(function (v) { io.observe(v); });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-astron-specificaties ===== */
/* Uitklappen per groep. Op desktop staat de knop op display:none en staat
   alles al open; het script hoeft daar niets te doen. */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-specs-sll]:not([data-ac-ready-sll])').forEach(function (root) {
      root.setAttribute('data-ac-ready-sll', '1');
      root.querySelectorAll('[data-ac-more-sll]').forEach(function (btn) {
        var card = btn.closest('[data-ac-card-sll]');
        var label = btn.querySelector('span');
        btn.addEventListener('click', function () {
          var open = card.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (label) { label.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore; }
        });
      });
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===========================================================================
   AlienComfort | Kopanimatie §4.8 - v6, VOLLEDIG OP ZICHZELF
   Alle klassenamen, keyframes en variabelen in dit blok dragen het voorvoegsel
   "acsp-sll". Er staat geen enkele window-variabele in. Een andere sectie op
   dezelfde pagina, oud of nieuw, kan deze kop dus niet meer aanraken en deze
   kop raakt geen andere sectie aan.
   Waarom dat nodig was: alle secties deelden .acsp-sll__kop, .acsp-js en
   .acsp-in. Het blok van de sectie die als eerste op de pagina stond pakte
   daardoor ALLE koppen beet, ook die van nieuwere secties eronder. In de
   theme-editor viel dat niet op, want daar wordt de sectie los herladen en
   wint het nieuwste blok; live won het oudste. Vandaar: niets meer delen.
   =========================================================================== */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STEP = 0.08, ACCENT = 0.22, TAIL = 0.30;
  function wrap(h) {
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
          var s = document.createElement('span');
          s.className = 'acsp-sll__w'; s.textContent = p;
          frag.appendChild(s);
        });
        h.replaceChild(frag, n);
      } else if (n.nodeType === 1) { n.classList.add('acsp-sll__w'); }
    });
  }
  function build(h, sec) {
    var gespeeld = sec.getAttribute('data-acsp-gespeeld-sll') === '1';
    h.innerHTML = h.getAttribute('data-acsp-bron-sll');
    wrap(h);
    var regels = [], nu = null, top = null;
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.classList.contains('acsp-sll__w')) {
        var t = Math.round(n.offsetTop);
        if (top === null || Math.abs(t - top) > 2) { top = t; nu = []; regels.push(nu); }
        nu.push(n);
      } else if (nu) { nu.push(n); }
    });
    h.innerHTML = '';
    regels.forEach(function (arr, i) {
      var ln = document.createElement('span');
      ln.className = 'acsp-sll__regel';
      arr.forEach(function (n) { ln.appendChild(n); });
      h.appendChild(ln);
      if (gespeeld) { ln.style.animation = 'none'; ln.style.opacity = '1'; ln.style.transform = 'none'; ln.style.clipPath = 'none'; return; }
      ln.style.animationDelay = (i * STEP) + 's';
      Array.prototype.forEach.call(
        ln.querySelectorAll('.acsp-sll__accent, .acsp-sll__semi'),
        function (a) { a.style.transitionDelay = (i * STEP + ACCENT) + 's'; }
      );
    });
    if (!gespeeld) {
      var laatste = (regels.length - 1) * STEP + TAIL;
      Array.prototype.forEach.call(sec.querySelectorAll('.acsp-sll__op'), function (el, k) {
        el.style.transitionDelay = (laatste + k * 0.09) + 's';
      });
    }
  }
  /* Thema's en andere secties zetten soms opacity, visibility of
     -webkit-text-fill-color op nul. Daarom hier expliciet en met voorrang. */
  function zichtbaar(h) {
    h.style.setProperty('opacity', '1', 'important');
    h.style.setProperty('visibility', 'visible', 'important');
    h.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    Array.prototype.forEach.call(h.querySelectorAll('.acsp-sll__regel'), function (ln) {
      ln.style.setProperty('visibility', 'visible', 'important');
      ln.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    });
  }
  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.acsp-sll__kop'), function (h) {
      var sec = h.closest('.acsp-sectie') || h.closest('section') || h.parentElement;
      var box = h.parentElement;
      if (!sec || sec.getAttribute('data-acsp-klaar-sll') === '1') return;
      sec.setAttribute('data-acsp-klaar-sll', '1');
      sec.classList.add('acsp-js');
      h.setAttribute('data-acsp-bron-sll', h.innerHTML);
      zichtbaar(h);
      var raf, b = 0;
      function plan() { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { build(h, sec); zichtbaar(h); }); }
      plan();
      if (window.ResizeObserver) {
        new ResizeObserver(function (e) {
          var nb = Math.round(e[0].contentRect.width);
          if (nb !== b) { b = nb; plan(); }
        }).observe(box);
      } else {
        window.addEventListener('resize', function () { setTimeout(plan, 120); });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(plan);
      /* Laatste redmiddel: als een thema of een andere sectie een OUDER van de
         kop op opacity 0 of visibility hidden zet, helpt forceren op de kop
         zelf niet. Daarom lopen we na het spelen de keten naar boven na. */
      function herstel() {
        var el = h;
        while (el && el !== document.body) {
          var cs = getComputedStyle(el);
          if (parseFloat(cs.opacity) === 0) el.style.setProperty('opacity', '1', 'important');
          if (cs.visibility === 'hidden') el.style.setProperty('visibility', 'visible', 'important');
          if (el === sec) break;
          el = el.parentElement;
        }
      }
      function speel() {
        sec.setAttribute('data-acsp-gespeeld-sll', '1');
        sec.classList.add('acsp-in');
        zichtbaar(h);
        setTimeout(function () { zichtbaar(h); herstel(); }, 400);
      }
      /* Eén zichtbare pixel is genoeg. Met een drempel van 20% blijft de kop
         van een sectie die hoger is dan vijf schermen voor altijd weggeknipt. */
      if (RM.matches || !('IntersectionObserver' in window)) { speel(); return; }
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { speel(); io.disconnect(); }
      }, { threshold: 0 });
      io.observe(sec);
      /* Vangnet: een kop die niet beweegt is vervelend, een kop die
         onzichtbaar blijft is een gemiste verkoop. */
      setTimeout(function () {
        if (sec.getAttribute('data-acsp-gespeeld-sll') === '1') return;
        var r = sec.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { speel(); io.disconnect(); }
      }, 1500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
})();

/* Flush-helper. Shopify zet een Custom Liquid-sectie in een container die
   smaller is dan het scherm, met eigen ruimte eromheen. Bij een witte
   sectie zie je dat niet, bij een ruimtezwarte krijgt u stroken
   paginakleur links, rechts, boven en onder. Hoeveel dat is verschilt per
   thema en per instelling, dus dit meet het op en trekt de sectie door tot
   de rand. Draait één keer per pagina. */

/* ===== ac-vergelijker-astron ===== */
(function(){
  var sec=document.querySelector('[data-ac-vp-s]:not([data-klaar])');
  if(!sec) return;
  sec.setAttribute('data-klaar','1');
  var LIVE=JSON.parse(sec.querySelector('[data-vp-live]').textContent);
  var D=JSON.parse(sec.querySelector('[data-vp-data]').textContent);
  var T=D.t, S=D.stoelen;
  var ORDE=['pluto','nova','luna','astron','pulsar','atlas','titan'];
  var zelf=sec.getAttribute('data-zelf');
  function esc(x){return String(x==null?'':x).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function niv(id){var v=String(S[id].i).split('|')[0];return v==='*'?5:(parseInt(v,10)||0);}

  /* Buren op de intensiteitsladder: de dichtstbijzijnde zachtere en de
     dichtstbijzijnde stevigere stoel. Zit de stoel aan een uiteinde, dan
     vullen we aan met de volgende uit dezelfde richting, zodat er altijd
     drie kaarten staan. */
  var i0=ORDE.indexOf(zelf);
  var zachter=null, steviger=null;
  for(var i=i0-1;i>=0;i--){ if(niv(ORDE[i])<niv(zelf)){zachter=ORDE[i];break;} }
  for(var j=i0+1;j<ORDE.length;j++){ if(niv(ORDE[j])>niv(zelf)){steviger=ORDE[j];break;} }
  /* Staat de stoel aan een uiteinde van de ladder, dan bestaat één van de
     twee buren niet. We vullen aan met de dichtstbijzijnde andere stoel en
     geven die een neutraal label — "één stap zachter" boven een stoel die
     juist steviger is, zou een leugen zijn. */
  var lZacht = T.zachter, lStevig = T.steviger;
  if(!zachter){
    for(var a=0;a<ORDE.length;a++){ if(ORDE[a]!==zelf && ORDE[a]!==steviger){ zachter=ORDE[a]; break; } }
    lZacht = T.ook;
  }
  if(!steviger){
    for(var b=ORDE.length-1;b>=0;b--){ if(ORDE[b]!==zelf && ORDE[b]!==zachter){ steviger=ORDE[b]; break; } }
    lStevig = T.ook;
  }

  /* Een stoel die u zelf instelt heeft geen vast niveau. Die krijgt geen
     vier vakjes maar een doorlopende balk: van zacht naar fors is bij die
     stoel een schuif, geen stand. */
  function meter(v){
    var d=String(v).split('|'), bl='';
    if(d[0]==='*'){
      return '<span class="ac-vp-s__meter"><span class="ac-vp-s__mblok is-vrij"><i></i><i></i><i></i><i></i></span>'+esc(d[1]||'')+'</span>';
    }
    var n=parseInt(d[0],10)||0;
    for(var k=1;k<=4;k++){bl+='<i'+(k<=n?' class="is-aan"':'')+'></i>';}
    return '<span class="ac-vp-s__meter"><span class="ac-vp-s__mblok">'+bl+'</span>'+esc(d[1]||'')+'</span>';
  }
  function kaart(id,vlag,isZelf){
    var s=S[id]||{}, c=LIVE[id]||{};
    return '<div class="ac-vp-s__kaart'+(isZelf?' ac-vp-s__kaart--zelf':'')+'">'
      +'<span class="ac-vp-s__vlag">'+esc(vlag)+'</span>'
      +'<div class="ac-vp-s__top">'
      +(c.img?'<img class="ac-vp-s__foto" src="'+esc(c.img)+'" alt="" loading="lazy" decoding="async">':'')
      +'<span class="ac-vp-s__wie"><span class="ac-vp-s__naam">'+esc(s.n)+'</span>'
      +'<span class="ac-vp-s__prijs">'+esc(c.prijs||'')+'</span>'
      +'<span class="ac-vp-s__status '+(c.op?'is-op':'is-pre')+'">'+esc(c.op?T.op:T.pre)+'</span></span></div>'
      +'<dl class="ac-vp-s__regels">'
      +'<div><dt>'+esc(T.sys)+'</dt><dd>'+esc(s.sys)+'</dd></div>'
      +'<div><dt>'+esc(T.int)+'</dt><dd>'+meter(s.i)+'</dd></div>'
      +'<div><dt>'+esc(T.diep)+'</dt><dd>'+esc(s.d)+'</dd></div>'
      +'<div><dt>'+esc(T.breed)+'</dt><dd>'+esc(s.b)+'</dd></div>'
      +'<div><dt>'+esc(T.kg)+'</dt><dd'+(s.kg==='—'?' class="is-leeg"':'')+'>'+esc(s.kg)+'</dd></div>'
      +'</dl>'
      +(isZelf||!c.url?'':'<a class="ac-vp-s__link" href="'+esc(c.url)+'">'+esc(s.n)+' &rarr;</a>')
      +'</div>';
  }
  sec.querySelector('[data-vp-rij]').innerHTML =
    kaart(zachter,lZacht,false) + kaart(zelf,T.deze,true) + kaart(steviger,lStevig,false);
  sec.querySelector('[data-vp-knop]').textContent = T.knop;

  /* Op mobiel is de rij een swipe-rij. Begin op de eigen stoel — die staat
     in het midden — zodat de bezoeker ziet waar hij is, en niet op de
     buurstoel. Zonder animatie: dit is de startstand, geen beweging. */
  var rij = sec.querySelector('[data-vp-rij]');
  function startpositie(){
    if(window.innerWidth > 749){ rij.scrollLeft = 0; return; }
    var mid = rij.querySelector('.ac-vp-s__kaart--zelf');
    if(mid){ rij.scrollLeft = mid.offsetLeft - rij.offsetLeft; }
  }
  startpositie();
  var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(startpositie, 150); });
})();

/* Kopanimatie §4.8 — gedeeld blok, idempotent. */

/* ===== ac-faq-astron ===== */

(function () {
function init() {
document.querySelectorAll('[data-ac-faq-s]').forEach(function (root) {
if (root.dataset.acReady === '1') return;
root.dataset.acReady = '1';
var items = Array.prototype.slice.call(root.querySelectorAll('.ac-faq-s__item'));
items.forEach(function (item) {
item.addEventListener('toggle', function () {
if (!item.open) return;
items.forEach(function (other) {
if (other !== item) other.open = false;
});
});
});
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

/* ===== ac-pdp-knoppen-veruna ===== */
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('[data-ac-add-chair-v]');
  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      const variantId = button.getAttribute('data-variant-id');
      if (!variantId) {
        console.warn('Geen variant-ID gevonden voor deze productpagina.');
        return;
      }
      button.classList.add('is-loading');
      button.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Product kon niet worden toegevoegd.');
        }
        return response.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        const cartDrawer =
          document.querySelector('cart-drawer') ||
          document.querySelector('[data-cart-drawer]') ||
          document.querySelector('.cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (error) {
        console.error(error);
        window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.disabled = false;
      });
    });
  });
});

/* ===== ac-veruna-quote ===== */
/* De sectie komt binnen zodra hij in beeld staat. Zonder JavaScript,
   zonder IntersectionObserver en bij prefers-reduced-motion wordt de
   klasse acsq-js niet gezet en staat alles gewoon zichtbaar (5.6). */
(function () {
  var init = function () {
    document.querySelectorAll('[data-acsq]:not([data-acsq-klaar])').forEach(function (sec) {
      sec.setAttribute('data-acsq-klaar', '1');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      if (!('IntersectionObserver' in window)) { return; }
      sec.classList.add('acsq-js');
      var speel = function () { sec.classList.add('is-in'); };
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { speel(); io.disconnect(); }
      }, { threshold: 0 });
      io.observe(sec);
      /* Vangnet: staat de sectie na anderhalve seconde wel in beeld maar
         is er niets gebeurd, dan zetten wij hem alsnog aan. */
      setTimeout(function () {
        var r = sec.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { speel(); }
      }, 1500);
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-veruna-beschrijving ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var knop = sec.querySelector('[data-ac-pd-knop-v]');
var paneel = sec.querySelector('[data-ac-pd-paneel-v]');
if(knop && paneel){
knop.addEventListener('click', function(){
var open = paneel.classList.contains('is-open');
paneel.classList.toggle('is-open', !open);
knop.classList.toggle('is-open', !open);
knop.setAttribute('aria-expanded', open ? 'false' : 'true');
});
}
var kop = sec.querySelector('[data-ac-pd-kop-v]');
var binnen = sec.querySelector('.ac-pd-v__in');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-pd-v__kern') || k.classList.contains('ac-pd-v__semi'))){ k.setAttribute('data-accent-v','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent-v')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-pd-v__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-pd-v__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-pd-v]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* Flush-helper met een eigen vlag en een eigen klasse. Meet de ruimte die
   het thema om de sectie zet en trekt de sectie precies tot de rand door,
   zonder 100vw en dus zonder horizontale scrollbalk. */
(function () {
  if (window.__acPdFlush) return;
  window.__acPdFlush = true;
  function apply() {
    document.querySelectorAll('.ac-pd-v--flush').forEach(function (sec) {
      var node = sec.parentElement;
      while (node && node !== document.body) {
        var cs = getComputedStyle(node);
        if (parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) ||
            parseFloat(cs.marginTop)  || parseFloat(cs.marginBottom)) {
          node.style.paddingTop = '0px'; node.style.paddingBottom = '0px';
          node.style.marginTop = '0px';  node.style.marginBottom = '0px';
        }
        node = node.parentElement;
      }
      sec.style.marginLeft = ''; sec.style.marginRight = '';
      sec.style.width = 'auto'; sec.style.maxWidth = 'none';
      var rect = sec.getBoundingClientRect();
      var docWidth = document.documentElement.clientWidth;
      var left = rect.left, right = docWidth - rect.right;
      if (left  > 0.5) sec.style.marginLeft  = (-left)  + 'px';
      if (right > 0.5) sec.style.marginRight = (-right) + 'px';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  window.addEventListener('load', apply);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 120); });
})();

/* ===== ac-veruna-opening ===== */

(function () {
function init() {
var items = document.querySelectorAll('[data-ac-reveal-v]:not([data-ac-seen-v])');
if (!items.length) return;
var still = !('IntersectionObserver' in window)
|| (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
if (still) {
items.forEach(function (el) {
el.setAttribute('data-ac-seen-v', '');
el.classList.add('is-in');
});
return;
}
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) {
if (!entry.isIntersecting) return;
entry.target.classList.add('is-in');
io.unobserve(entry.target);
});
}, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
items.forEach(function (el) {
el.setAttribute('data-ac-seen-v', '');
io.observe(el);
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

/* ===== ac-veruna-usps ===== */
(function () {
  const section = document.querySelector('[data-ac-usp-metrics-v3]');
  if (!section) return;

  const rings = section.querySelectorAll('.ac-ring-v3');
  const r = 48;
  const C = 2 * Math.PI * r;

  rings.forEach(ring => {
    const progress = ring.querySelector('.ac-ring-v3__progress');
    progress.style.strokeDasharray = C;
    progress.style.strokeDashoffset = C;

    const pct = Number(ring.dataset.pct || 0);
    const txt = ring.querySelector('.ac-ring-v3__text');
    if (txt) txt.textContent = pct + '%';
  });

  function animate() {
    if (section.dataset.animated) return;
    section.dataset.animated = '1';

    rings.forEach((ring, i) => {
      const pct = Number(ring.dataset.pct || 0);
      const progress = ring.querySelector('.ac-ring-v3__progress');
      const target = C * (1 - pct / 100);

      setTimeout(() => {
        progress.animate(
          [{ strokeDashoffset: C }, { strokeDashoffset: target }],
          { duration: 850, easing: 'ease-out', fill: 'forwards' }
        );
      }, i * 110);
    });
  }

  new IntersectionObserver(entries => {
    if (entries[0].isIntersecting) animate();
  }, { threshold: 0.25 }).observe(section);
})();

/* ===== ac-veruna-kenmerken ===== */
/* Rijen komen binnen zodra ze in beeld staan, en de video speelt alleen
   terwijl hij in beeld is. Zonder JavaScript en bij prefers-reduced-motion
   staat alles gewoon zichtbaar en speelt de video niet vanzelf (5.6). */
(function () {
  var init = function () {
    document.querySelectorAll('[data-acvk]:not([data-acvk-klaar])').forEach(function (sec) {
      sec.setAttribute('data-acvk-klaar', '1');
      var rustig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var video = sec.querySelector('[data-acvk-video]');
      if (video) {
        if (rustig) {
          /* Geen automatische beweging: de bezoeker krijgt de bediening en
             kiest zelf. De poster staat er al. */
          video.setAttribute('controls', '');
        } else if ('IntersectionObserver' in window) {
          var vio = new IntersectionObserver(function (en) {
            en.forEach(function (e) {
              if (e.isIntersecting) { var p = video.play(); if (p && p.catch) { p.catch(function () { video.setAttribute('controls', ''); }); } }
              else { video.pause(); }
            });
          }, { threshold: 0.25 });
          vio.observe(video);
        } else {
          video.setAttribute('controls', '');
        }
      }
      var rijen = Array.prototype.slice.call(sec.querySelectorAll('.acvk__rij'));
      if (rustig) { return; }
      if (!('IntersectionObserver' in window)) { return; }
      sec.classList.add('acvk-js');
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      rijen.forEach(function (r) { io.observe(r); });
      /* Vangnet: staat een rij na anderhalve seconde nog onzichtbaar
         terwijl hij wel in beeld is, dan zetten wij hem alsnog aan. */
      setTimeout(function () {
        rijen.forEach(function (r) {
          var b = r.getBoundingClientRect();
          if (b.top < window.innerHeight && b.bottom > 0) { r.classList.add('is-in'); }
        });
      }, 1500);
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-veruna-massagesysteem ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-ms-v]:not([data-ac-ready-v])').forEach(function (root) {
      root.setAttribute('data-ac-ready-v', '1');
      var videos = Array.prototype.slice.call(root.querySelectorAll('[data-ac-video-v]'));
      if (!videos.length) { return; }
      var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* §5.6: bij verminderde beweging spelen de video's niet;
         het posterbeeld blijft staan. */
      if (stil) { return; }
      /* Spelen alleen in beeld; daarbuiten pauzeren ze. Scheelt accu
         en de pagina blijft licht. */
      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (v) { v.play().catch(function () {}); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.play().catch(function () {}); } else { e.target.pause(); }
        });
      }, { threshold: 0.25 });
      videos.forEach(function (v) { io.observe(v); });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-veruna-specificaties ===== */
/* Uitklappen per groep. Op desktop staat de knop op display:none en staat
   alles al open; het script hoeft daar niets te doen. */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-specs-vl]:not([data-ac-ready-vl])').forEach(function (root) {
      root.setAttribute('data-ac-ready-vl', '1');
      root.querySelectorAll('[data-ac-more-vl]').forEach(function (btn) {
        var card = btn.closest('[data-ac-card-vl]');
        var label = btn.querySelector('span');
        btn.addEventListener('click', function () {
          var open = card.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (label) { label.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore; }
        });
      });
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===========================================================================
   AlienComfort | Kopanimatie 4.8 - v6, VOLLEDIG OP ZICHZELF
   Alle klassenamen, keyframes en variabelen in dit blok dragen het
   voorvoegsel "acsp-vl". Er staat geen enkele window-variabele in. Een andere
   sectie op dezelfde pagina, oud of nieuw, kan deze kop dus niet aanraken en
   deze kop raakt geen andere sectie aan.
   =========================================================================== */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STEP = 0.08, ACCENT = 0.22, TAIL = 0.30;
  function wrap(h) {
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
          var s = document.createElement('span');
          s.className = 'acsp-vl__w'; s.textContent = p;
          frag.appendChild(s);
        });
        h.replaceChild(frag, n);
      } else if (n.nodeType === 1) { n.classList.add('acsp-vl__w'); }
    });
  }
  function build(h, sec) {
    var gespeeld = sec.getAttribute('data-acsp-gespeeld-vl') === '1';
    h.innerHTML = h.getAttribute('data-acsp-bron-vl');
    wrap(h);
    var regels = [], nu = null, top = null;
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.classList.contains('acsp-vl__w')) {
        var t = Math.round(n.offsetTop);
        if (top === null || Math.abs(t - top) > 2) { top = t; nu = []; regels.push(nu); }
        nu.push(n);
      } else if (nu) { nu.push(n); }
    });
    h.innerHTML = '';
    regels.forEach(function (arr, i) {
      var ln = document.createElement('span');
      ln.className = 'acsp-vl__regel';
      arr.forEach(function (n) { ln.appendChild(n); });
      h.appendChild(ln);
      if (gespeeld) { ln.style.animation = 'none'; ln.style.opacity = '1'; ln.style.transform = 'none'; ln.style.clipPath = 'none'; return; }
      ln.style.animationDelay = (i * STEP) + 's';
      Array.prototype.forEach.call(
        ln.querySelectorAll('.acsp-vl__accent, .acsp-vl__semi'),
        function (a) { a.style.transitionDelay = (i * STEP + ACCENT) + 's'; }
      );
    });
    if (!gespeeld) {
      var laatste = (regels.length - 1) * STEP + TAIL;
      Array.prototype.forEach.call(sec.querySelectorAll('.acsp-vl__op'), function (el, k) {
        el.style.transitionDelay = (laatste + k * 0.09) + 's';
      });
    }
  }
  /* Thema's en andere secties zetten soms opacity, visibility of
     -webkit-text-fill-color op nul. Daarom hier expliciet en met voorrang. */
  function zichtbaar(h) {
    h.style.setProperty('opacity', '1', 'important');
    h.style.setProperty('visibility', 'visible', 'important');
    h.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    Array.prototype.forEach.call(h.querySelectorAll('.acsp-vl__regel'), function (ln) {
      ln.style.setProperty('visibility', 'visible', 'important');
      ln.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    });
  }
  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.acsp-vl__kop'), function (h) {
      var sec = h.closest('.acsp-sectie') || h.closest('section') || h.parentElement;
      var box = h.parentElement;
      if (!sec || sec.getAttribute('data-acsp-klaar-vl') === '1') return;
      sec.setAttribute('data-acsp-klaar-vl', '1');
      sec.classList.add('acsp-js');
      h.setAttribute('data-acsp-bron-vl', h.innerHTML);
      zichtbaar(h);
      var raf, b = 0;
      function plan() { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { build(h, sec); zichtbaar(h); }); }
      plan();
      if (window.ResizeObserver) {
        new ResizeObserver(function (e) {
          var nb = Math.round(e[0].contentRect.width);
          if (nb !== b) { b = nb; plan(); }
        }).observe(box);
      } else {
        window.addEventListener('resize', function () { setTimeout(plan, 120); });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(plan);
      function herstel() {
        var el = h;
        while (el && el !== document.body) {
          var cs = getComputedStyle(el);
          if (parseFloat(cs.opacity) === 0) el.style.setProperty('opacity', '1', 'important');
          if (cs.visibility === 'hidden') el.style.setProperty('visibility', 'visible', 'important');
          if (el === sec) break;
          el = el.parentElement;
        }
      }
      function speel() {
        sec.setAttribute('data-acsp-gespeeld-vl', '1');
        sec.classList.add('acsp-in');
        zichtbaar(h);
        setTimeout(function () { zichtbaar(h); herstel(); }, 400);
      }
      /* Eén zichtbare pixel is genoeg. Met een drempel van 20 procent blijft
         de kop van een sectie die hoger is dan vijf schermen weggeknipt. */
      if (RM.matches || !('IntersectionObserver' in window)) { speel(); return; }
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { speel(); io.disconnect(); }
      }, { threshold: 0 });
      io.observe(sec);
      setTimeout(function () {
        if (sec.getAttribute('data-acsp-gespeeld-vl') === '1') return;
        var r = sec.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { speel(); io.disconnect(); }
      }, 1500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
})();

/* Flush-helper met een eigen vlag en een eigen klasse. Shopify zet een
   Custom Liquid-sectie in een container die smaller is dan het scherm, met
   eigen ruimte eromheen. Bij een witte sectie ziet u dat niet, bij een
   ruimtezwarte krijgt u stroken paginakleur links, rechts, boven en onder.
   Hoeveel dat is verschilt per thema, dus dit meet het op en trekt de
   sectie door tot de rand. */
(function () {
  if (window.__acSpecsFlush_v) return;
  window.__acSpecsFlush_v = true;
  function apply() {
    document.querySelectorAll('.ac-specs-vl--flush').forEach(function (sec) {
      var node = sec.parentElement;
      while (node && node !== document.body) {
        var cs = getComputedStyle(node);
        if (parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) ||
            parseFloat(cs.marginTop)  || parseFloat(cs.marginBottom)) {
          node.style.paddingTop = '0px'; node.style.paddingBottom = '0px';
          node.style.marginTop = '0px';  node.style.marginBottom = '0px';
        }
        node = node.parentElement;
      }
      sec.style.marginLeft = ''; sec.style.marginRight = '';
      sec.style.width = 'auto'; sec.style.maxWidth = 'none';
      var rect = sec.getBoundingClientRect();
      var docWidth = document.documentElement.clientWidth;
      var left = rect.left, right = docWidth - rect.right;
      if (left  > 0.5) sec.style.marginLeft  = (-left)  + 'px';
      if (right > 0.5) sec.style.marginRight = (-right) + 'px';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  window.addEventListener('load', apply);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 120); });
})();

/* ===== ac-faq-veruna ===== */
(function () {
if (window.__acFaqFlush_v) return;
window.__acFaqFlush_v = true;
function apply() {
document.querySelectorAll('.ac-faq-v--flush').forEach(function (sec) {
var node = sec.parentElement;
while (node && node !== document.body) {
var cs = getComputedStyle(node);
if (parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) ||
parseFloat(cs.marginTop)  || parseFloat(cs.marginBottom)) {
node.style.paddingTop    = '0px';
node.style.paddingBottom = '0px';
node.style.marginTop     = '0px';
node.style.marginBottom  = '0px';
}
node = node.parentElement;
}
sec.style.marginLeft  = '';
sec.style.marginRight = '';
sec.style.width       = 'auto';
sec.style.maxWidth    = 'none';
var rect = sec.getBoundingClientRect();
var docWidth = document.documentElement.clientWidth;
var left  = rect.left;
var right = docWidth - rect.right;
if (left  > 0.5) sec.style.marginLeft  = (-left)  + 'px';
if (right > 0.5) sec.style.marginRight = (-right) + 'px';
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', apply);
} else {
apply();
}
window.addEventListener('load', apply);
var t;
window.addEventListener('resize', function () {
clearTimeout(t);
t = setTimeout(apply, 120);
});
})();

(function () {
function init() {
document.querySelectorAll('[data-ac-faq-v]').forEach(function (root) {
if (root.dataset.acReady === '1') return;
root.dataset.acReady = '1';
var items = Array.prototype.slice.call(root.querySelectorAll('.ac-faq-v__item'));
items.forEach(function (item) {
item.addEventListener('toggle', function () {
if (!item.open) return;
items.forEach(function (other) {
if (other !== item) other.open = false;
});
});
});
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

/* ===== ac-pdp-knoppen-nova ===== */
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('[data-ac-add-chair-n]');

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      const variantId = button.getAttribute('data-variant-id');

      if (!variantId) {
        console.warn('Geen variant-ID gevonden voor deze productpagina.');
        return;
      }

      button.classList.add('is-loading');
      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        })
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Product kon niet worden toegevoegd.');
        }
        return response.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));

        const cartDrawer =
          document.querySelector('cart-drawer') ||
          document.querySelector('[data-cart-drawer]') ||
          document.querySelector('.cart-drawer');

        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (error) {
        console.error(error);
        window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.disabled = false;
      });
    });
  });
});

/* ===== ac-nova-opening ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var kop = sec.querySelector('[data-ac-nv-kop-n]');
var binnen = sec.querySelector('.ac-nv-n__in');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-nv-n__kern') || k.classList.contains('ac-nv-n__semi'))){ k.setAttribute('data-accent-n','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent-n')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-nv-n__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-nv-n__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-nv-n]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-nova-beschrijving ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var knop = sec.querySelector('[data-ac-pd-knop-n]');
var paneel = sec.querySelector('[data-ac-pd-paneel-n]');
if(knop && paneel){
knop.addEventListener('click', function(){
var open = paneel.classList.contains('is-open');
paneel.classList.toggle('is-open', !open);
knop.classList.toggle('is-open', !open);
knop.setAttribute('aria-expanded', open ? 'false' : 'true');
});
}
var kop = sec.querySelector('[data-ac-pd-kop-n]');
var binnen = sec.querySelector('.ac-pd-n__in');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-pd-n__kern') || k.classList.contains('ac-pd-n__semi'))){ k.setAttribute('data-accent-n','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent-n')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-pd-n__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-pd-n__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-pd-n]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-nova-fitmeter ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-fit-meter-n]:not([data-ac-ready-n])').forEach(function (section) {
      section.setAttribute('data-ac-ready-n', '1');
      section.querySelectorAll('.ac-meter-n').forEach(function (meter) {
        meter.style.setProperty('--fill', (meter.getAttribute('data-fill') || 0) + '%');
      });
      if (!('IntersectionObserver' in window)) { section.classList.add('is-visible'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { section.classList.add('is-visible'); io.unobserve(entry.target); }
        });
      }, { threshold: 0.25 });
      io.observe(section);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-nova-usps ===== */
/* Flush-helper: meet de ruimte van de thema-wrapper en trekt de sectie door
   tot de rand van de pagina. Draait een keer per pagina. */

(function () {
function init() {
var items = document.querySelectorAll('[data-ac-reveal-n]:not([data-ac-seen-n])');
if (!items.length) return;
var still = !('IntersectionObserver' in window)
|| (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
if (still) {
items.forEach(function (el) { el.setAttribute('data-ac-seen-n', ''); el.classList.add('is-in'); });
return;
}
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) {
if (!entry.isIntersecting) return;
entry.target.classList.add('is-in');
io.unobserve(entry.target);
});
}, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
items.forEach(function (el) { el.setAttribute('data-ac-seen-n', ''); io.observe(el); });
/* Terugval: gaat de waarnemer niet af, dan staan de kaarten er alsnog. */
setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 1600);
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-nova-banner ===== */
/* Flush-helper: meet de ruimte van de thema-wrapper en trekt de sectie
   door tot de rand van de pagina. Draait één keer per pagina. */

/* ===== ac-nova-metrics ===== */
/* Flush-helper: trekt de sectie door tot de rand van de pagina. */

(function () {
function init() {
var rings = document.querySelectorAll('.ac-metrics-n__ring[data-ac-ring-n]:not([data-ac-armed-n])');
if (!rings.length) return;
var still = !('IntersectionObserver' in window)
|| (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
if (still) return;
function telOp(ring) {
var num = ring.querySelector('[data-ac-num-n]');
if (!num) return;
var doel = parseInt(num.textContent, 10);
if (!doel) return;
var start = null, duur = 900;
var wacht = parseInt(ring.style.getPropertyValue('--ac-delay'), 10) || 0;
num.textContent = '0';
setTimeout(function () {
function stap(t) {
if (start === null) start = t;
var p = Math.min((t - start) / duur, 1);
var e = 1 - Math.pow(1 - p, 3);
num.textContent = Math.round(doel * e);
if (p < 1) requestAnimationFrame(stap);
}
requestAnimationFrame(stap);
}, wacht);
}
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (entry) {
if (!entry.isIntersecting) return;
entry.target.classList.add('is-in');
telOp(entry.target);
io.unobserve(entry.target);
});
}, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
rings.forEach(function (el) { el.setAttribute('data-ac-armed-n', ''); io.observe(el); });
/* Terugval: gaat de waarnemer niet af, dan lopen de ringen alsnog vol. */
setTimeout(function () {
rings.forEach(function (el) { if (!el.classList.contains('is-in')) { el.classList.add('is-in'); telOp(el); } });
}, 1800);
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-nova-specificaties ===== */
/* Uitklappen per groep. Op desktop staat de knop op display:none en staat
   alles al open; het script hoeft daar niets te doen. */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-specs-nl]:not([data-ac-ready-nl])').forEach(function (root) {
      root.setAttribute('data-ac-ready-nl', '1');
      root.querySelectorAll('[data-ac-more-nl]').forEach(function (btn) {
        var card = btn.closest('[data-ac-card-nl]');
        var label = btn.querySelector('span');
        btn.addEventListener('click', function () {
          var open = card.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (label) { label.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore; }
        });
      });
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===========================================================================
   AlienComfort | Kopanimatie §4.8 - v6, VOLLEDIG OP ZICHZELF
   Alle klassenamen, keyframes en variabelen in dit blok dragen het voorvoegsel
   "acsp-nl". Er staat geen enkele window-variabele in. Een andere sectie op
   dezelfde pagina, oud of nieuw, kan deze kop dus niet meer aanraken en deze
   kop raakt geen andere sectie aan.
   Waarom dat nodig was: alle secties deelden .acsp-nl__kop, .acsp-js en
   .acsp-in. Het blok van de sectie die als eerste op de pagina stond pakte
   daardoor ALLE koppen beet, ook die van nieuwere secties eronder. In de
   theme-editor viel dat niet op, want daar wordt de sectie los herladen en
   wint het nieuwste blok; live won het oudste. Vandaar: niets meer delen.
   =========================================================================== */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STEP = 0.08, ACCENT = 0.22, TAIL = 0.30;
  function wrap(h) {
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
          var s = document.createElement('span');
          s.className = 'acsp-nl__w'; s.textContent = p;
          frag.appendChild(s);
        });
        h.replaceChild(frag, n);
      } else if (n.nodeType === 1) { n.classList.add('acsp-nl__w'); }
    });
  }
  function build(h, sec) {
    var gespeeld = sec.getAttribute('data-acsp-gespeeld-nl') === '1';
    h.innerHTML = h.getAttribute('data-acsp-bron-nl');
    wrap(h);
    var regels = [], nu = null, top = null;
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.classList.contains('acsp-nl__w')) {
        var t = Math.round(n.offsetTop);
        if (top === null || Math.abs(t - top) > 2) { top = t; nu = []; regels.push(nu); }
        nu.push(n);
      } else if (nu) { nu.push(n); }
    });
    h.innerHTML = '';
    regels.forEach(function (arr, i) {
      var ln = document.createElement('span');
      ln.className = 'acsp-nl__regel';
      arr.forEach(function (n) { ln.appendChild(n); });
      h.appendChild(ln);
      if (gespeeld) { ln.style.animation = 'none'; ln.style.opacity = '1'; ln.style.transform = 'none'; ln.style.clipPath = 'none'; return; }
      ln.style.animationDelay = (i * STEP) + 's';
      Array.prototype.forEach.call(
        ln.querySelectorAll('.acsp-nl__accent, .acsp-nl__semi'),
        function (a) { a.style.transitionDelay = (i * STEP + ACCENT) + 's'; }
      );
    });
    if (!gespeeld) {
      var laatste = (regels.length - 1) * STEP + TAIL;
      Array.prototype.forEach.call(sec.querySelectorAll('.acsp-nl__op'), function (el, k) {
        el.style.transitionDelay = (laatste + k * 0.09) + 's';
      });
    }
  }
  /* Thema's en andere secties zetten soms opacity, visibility of
     -webkit-text-fill-color op nul. Daarom hier expliciet en met voorrang. */
  function zichtbaar(h) {
    h.style.setProperty('opacity', '1', 'important');
    h.style.setProperty('visibility', 'visible', 'important');
    h.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    Array.prototype.forEach.call(h.querySelectorAll('.acsp-nl__regel'), function (ln) {
      ln.style.setProperty('visibility', 'visible', 'important');
      ln.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    });
  }
  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.acsp-nl__kop'), function (h) {
      var sec = h.closest('.acsp-sectie') || h.closest('section') || h.parentElement;
      var box = h.parentElement;
      if (!sec || sec.getAttribute('data-acsp-klaar-nl') === '1') return;
      sec.setAttribute('data-acsp-klaar-nl', '1');
      sec.classList.add('acsp-js');
      h.setAttribute('data-acsp-bron-nl', h.innerHTML);
      zichtbaar(h);
      var raf, b = 0;
      function plan() { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { build(h, sec); zichtbaar(h); }); }
      plan();
      if (window.ResizeObserver) {
        new ResizeObserver(function (e) {
          var nb = Math.round(e[0].contentRect.width);
          if (nb !== b) { b = nb; plan(); }
        }).observe(box);
      } else {
        window.addEventListener('resize', function () { setTimeout(plan, 120); });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(plan);
      /* Laatste redmiddel: als een thema of een andere sectie een OUDER van de
         kop op opacity 0 of visibility hidden zet, helpt forceren op de kop
         zelf niet. Daarom lopen we na het spelen de keten naar boven na. */
      function herstel() {
        var el = h;
        while (el && el !== document.body) {
          var cs = getComputedStyle(el);
          if (parseFloat(cs.opacity) === 0) el.style.setProperty('opacity', '1', 'important');
          if (cs.visibility === 'hidden') el.style.setProperty('visibility', 'visible', 'important');
          if (el === sec) break;
          el = el.parentElement;
        }
      }
      function speel() {
        sec.setAttribute('data-acsp-gespeeld-nl', '1');
        sec.classList.add('acsp-in');
        zichtbaar(h);
        setTimeout(function () { zichtbaar(h); herstel(); }, 400);
      }
      /* Eén zichtbare pixel is genoeg. Met een drempel van 20% blijft de kop
         van een sectie die hoger is dan vijf schermen voor altijd weggeknipt. */
      if (RM.matches || !('IntersectionObserver' in window)) { speel(); return; }
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { speel(); io.disconnect(); }
      }, { threshold: 0 });
      io.observe(sec);
      /* Vangnet: een kop die niet beweegt is vervelend, een kop die
         onzichtbaar blijft is een gemiste verkoop. */
      setTimeout(function () {
        if (sec.getAttribute('data-acsp-gespeeld-nl') === '1') return;
        var r = sec.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { speel(); io.disconnect(); }
      }, 1500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
})();

/* Flush-helper. Shopify zet een Custom Liquid-sectie in een container die
   smaller is dan het scherm, met eigen ruimte eromheen. Bij een witte
   sectie zie je dat niet, bij een ruimtezwarte krijgt u stroken
   paginakleur links, rechts, boven en onder. Hoeveel dat is verschilt per
   thema en per instelling, dus dit meet het op en trekt de sectie door tot
   de rand. Draait één keer per pagina. */

/* ===== ac-vergelijker-nova ===== */
(function(){
  var sec=document.querySelector('[data-ac-vp-n]:not([data-klaar])');
  if(!sec) return;
  sec.setAttribute('data-klaar','1');
  var LIVE=JSON.parse(sec.querySelector('[data-vp-live]').textContent);
  var D=JSON.parse(sec.querySelector('[data-vp-data]').textContent);
  var T=D.t, S=D.stoelen;
  var ORDE=['pluto','nova','luna','astron','pulsar','atlas','titan'];
  var zelf=sec.getAttribute('data-zelf');
  function esc(x){return String(x==null?'':x).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function niv(id){return parseInt(String(S[id].i).split('|')[0],10)||0;}

  /* Buren op de intensiteitsladder: de dichtstbijzijnde zachtere en de
     dichtstbijzijnde stevigere stoel. Zit de stoel aan een uiteinde, dan
     vullen we aan met de volgende uit dezelfde richting, zodat er altijd
     drie kaarten staan. */
  var i0=ORDE.indexOf(zelf);
  var zachter=null, steviger=null;
  for(var i=i0-1;i>=0;i--){ if(niv(ORDE[i])<niv(zelf)){zachter=ORDE[i];break;} }
  for(var j=i0+1;j<ORDE.length;j++){ if(niv(ORDE[j])>niv(zelf)){steviger=ORDE[j];break;} }
  /* Staat de stoel aan een uiteinde van de ladder, dan bestaat één van de
     twee buren niet. We vullen aan met de dichtstbijzijnde andere stoel en
     geven die een neutraal label — "één stap zachter" boven een stoel die
     juist steviger is, zou een leugen zijn. */
  var lZacht = T.zachter, lStevig = T.steviger;
  if(!zachter){
    for(var a=0;a<ORDE.length;a++){ if(ORDE[a]!==zelf && ORDE[a]!==steviger){ zachter=ORDE[a]; break; } }
    lZacht = T.ook;
  }
  if(!steviger){
    for(var b=ORDE.length-1;b>=0;b--){ if(ORDE[b]!==zelf && ORDE[b]!==zachter){ steviger=ORDE[b]; break; } }
    lStevig = T.ook;
  }

  function meter(v){
    var d=String(v).split('|'), n=parseInt(d[0],10)||0, bl='';
    for(var k=1;k<=4;k++){bl+='<i'+(k<=n?' class="is-aan"':'')+'></i>';}
    return '<span class="ac-vp-n__meter"><span class="ac-vp-n__mblok">'+bl+'</span>'+esc(d[1]||'')+'</span>';
  }
  function kaart(id,vlag,isZelf){
    var s=S[id]||{}, c=LIVE[id]||{};
    return '<div class="ac-vp-n__kaart'+(isZelf?' ac-vp-n__kaart--zelf':'')+'">'
      +'<span class="ac-vp-n__vlag">'+esc(vlag)+'</span>'
      +'<div class="ac-vp-n__top">'
      +(c.img?'<img class="ac-vp-n__foto" src="'+esc(c.img)+'" alt="" loading="lazy" decoding="async">':'')
      +'<span class="ac-vp-n__wie"><span class="ac-vp-n__naam">'+esc(s.n)+'</span>'
      +'<span class="ac-vp-n__prijs">'+esc(c.prijs||'')+'</span>'
      +'<span class="ac-vp-n__status '+(c.op?'is-op':'is-pre')+'">'+esc(c.op?T.op:T.pre)+'</span></span></div>'
      +'<dl class="ac-vp-n__regels">'
      +'<div><dt>'+esc(T.sys)+'</dt><dd>'+esc(s.sys)+'</dd></div>'
      +'<div><dt>'+esc(T.int)+'</dt><dd>'+meter(s.i)+'</dd></div>'
      +'<div><dt>'+esc(T.diep)+'</dt><dd>'+esc(s.d)+'</dd></div>'
      +'<div><dt>'+esc(T.breed)+'</dt><dd>'+esc(s.b)+'</dd></div>'
      +'<div><dt>'+esc(T.kg)+'</dt><dd'+(s.kg==='—'?' class="is-leeg"':'')+'>'+esc(s.kg)+'</dd></div>'
      +'</dl>'
      +(isZelf||!c.url?'':'<a class="ac-vp-n__link" href="'+esc(c.url)+'">'+esc(s.n)+' &rarr;</a>')
      +'</div>';
  }
  sec.querySelector('[data-vp-rij]').innerHTML =
    kaart(zachter,lZacht,false) + kaart(zelf,T.deze,true) + kaart(steviger,lStevig,false);
  sec.querySelector('[data-vp-knop]').textContent = T.knop;

  /* Op mobiel is de rij een swipe-rij. Begin op de eigen stoel — die staat
     in het midden — zodat de bezoeker ziet waar hij is, en niet op de
     buurstoel. Zonder animatie: dit is de startstand, geen beweging. */
  var rij = sec.querySelector('[data-vp-rij]');
  function startpositie(){
    if(window.innerWidth > 749){ rij.scrollLeft = 0; return; }
    var mid = rij.querySelector('.ac-vp-n__kaart--zelf');
    if(mid){ rij.scrollLeft = mid.offsetLeft - rij.offsetLeft; }
  }
  startpositie();
  var t; window.addEventListener('resize', function(){ clearTimeout(t); t = setTimeout(startpositie, 150); });
})();

/* Kopanimatie §4.8 — gedeeld blok, idempotent. */

/* ===== ac-faq-nova ===== */

(function () {
function init() {
document.querySelectorAll('[data-ac-faq-n]').forEach(function (root) {
if (root.dataset.acReady === '1') return;
root.dataset.acReady = '1';
var items = Array.prototype.slice.call(root.querySelectorAll('.ac-faq-n__item'));
items.forEach(function (item) {
item.addEventListener('toggle', function () {
if (!item.open) return;
items.forEach(function (other) {
if (other !== item) other.open = false;
});
});
});
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

/* ===== ac-modellen-nova ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-xs-nll]:not([data-ac-ready-nll])').forEach(function (root) {
      root.setAttribute('data-ac-ready-nll', '1');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ac-tab-nll]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ac-panel-nll]'));
      if (!tabs.length) { return; }
      var select = function (key) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-ac-tab-nll') === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          if (p.getAttribute('data-ac-panel-nll') === key) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
      };
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t.getAttribute('data-ac-tab-nll')); });
        t.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = (i + 1) % tabs.length; }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = (i - 1 + tabs.length) % tabs.length; }
          if (next === null) { return; }
          e.preventDefault();
          select(tabs[next].getAttribute('data-ac-tab-nll'));
          tabs[next].focus();
        });
      });
      /* Productpagina's alvast ophalen zodra een link wordt aangeraakt;
         de doorklik voelt daardoor direct. Elke URL maar een keer. */
      var geladen = {};
      root.querySelectorAll('.ac-xs-nll__main, .ac-xs-nll__var').forEach(function (link) {
        var laad = function () {
          if (!link.href || geladen[link.href]) { return; }
          geladen[link.href] = true;
          var l = document.createElement('link');
          l.rel = 'prefetch';
          l.href = link.href;
          document.head.appendChild(l);
        };
        link.addEventListener('mouseenter', laad);
        link.addEventListener('touchstart', laad, { passive: true });
      });
      /* Over een kleurvariant bewegen wisselt alvast de grote foto van
         het model. Klikken gaat naar de pagina van die kleur. */
      root.querySelectorAll('.ac-xs-nll__card').forEach(function (card) {
        var groot = card.querySelector('.ac-xs-nll__imgwrap img');
        if (!groot) { return; }
        card.querySelectorAll('.ac-xs-nll__var[data-ac-img-nll]').forEach(function (v) {
          v.addEventListener('mouseenter', function () {
            var bron = v.getAttribute('data-ac-img-nll');
            if (!bron || groot.src === bron) { return; }
            groot.src = bron;
            groot.removeAttribute('srcset');
          });
        });
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-pulsar-beschrijving ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var knop = sec.querySelector('[data-ac-pd-knop-b]');
var paneel = sec.querySelector('[data-ac-pd-paneel-b]');
if(knop && paneel){
knop.addEventListener('click', function(){
var open = paneel.classList.contains('is-open');
paneel.classList.toggle('is-open', !open);
knop.classList.toggle('is-open', !open);
knop.setAttribute('aria-expanded', open ? 'false' : 'true');
});
}
var kop = sec.querySelector('[data-ac-pd-kop-b]');
var binnen = sec.querySelector('.ac-pd-b__in');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-pd-b__kern') || k.classList.contains('ac-pd-b__semi'))){ k.setAttribute('data-accent-b','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent-b')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-pd-b__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-pd-b__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-pd-b]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-pulsar-massagesysteem ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-ms-b]:not([data-ac-ready-b])').forEach(function (root) {
      root.setAttribute('data-ac-ready-b', '1');
      var videos = Array.prototype.slice.call(root.querySelectorAll('[data-ac-video-b]'));
      if (!videos.length) { return; }
      var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (stil) { return; }
      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (v) { v.play().catch(function () {}); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.play().catch(function () {}); } else { e.target.pause(); }
        });
      }, { threshold: 0.25 });
      videos.forEach(function (v) { io.observe(v); });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-pulsar-fitmeter ===== */
(function(){
function start(){
document.querySelectorAll('[data-acfm]:not([data-acfm-klaar])').forEach(function(sec){
sec.setAttribute('data-acfm-klaar','1');
Array.prototype.forEach.call(sec.querySelectorAll('[data-acfm-vul]'), function(balk){
var v = Number(balk.getAttribute('data-acfm-vul')) || 0;
if(v < 0){ v = 0; } if(v > 100){ v = 100; }
balk.style.setProperty('--acfm-vul', v + '%');
});
if(!('IntersectionObserver' in window)){ sec.classList.add('is-in'); return; }
/* Drempel 0: één zichtbare pixel is genoeg. Met een hogere drempel loopt
   een lange sectie op een klein scherm nooit vol (bouwafspraak 11). */
var io = new IntersectionObserver(function(en){ if(en[0].isIntersecting){ sec.classList.add('is-in'); io.disconnect(); } }, { threshold: 0 });
io.observe(sec);
setTimeout(function(){ if(!sec.classList.contains('is-in')){ var r = sec.getBoundingClientRect(); if(r.top < window.innerHeight && r.bottom > 0){ sec.classList.add('is-in'); io.disconnect(); } } }, 1500);
});
}
if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', start); } else { start(); }
document.addEventListener('shopify:section:load', start);
window.addEventListener('load', start);
})();

(function(){function plak(){document.querySelectorAll('.acfm').forEach(function(k){var w=k.closest('.shopify-section')||k.parentElement;if(!w)return;w.style.marginTop='0px';w.style.marginBottom='0px';var b=w.previousElementSibling;if(b)b.style.marginBottom='0px';var n=w.nextElementSibling;if(n)n.style.marginTop='0px'})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',plak)}else{plak()}window.addEventListener('load',plak)})();

/* Flush-helper: meet de ruimte van de thema-wrapper en trekt de sectie
   door tot de rand van de pagina. Draait één keer per pagina. */

/* ===== ac-pulsar-kenmerken ===== */
/* Rijen komen binnen zodra ze in beeld staan. Zonder JavaScript, en bij
   prefers-reduced-motion, staat alles gewoon zichtbaar (§5.6). */
(function () {
  var init = function () {
    document.querySelectorAll('[data-acmt-b]:not([data-acmt-klaar-b])').forEach(function (sec) {
      sec.setAttribute('data-acmt-klaar-b', '1');
      var rijen = Array.prototype.slice.call(sec.querySelectorAll('.acmt-b__rij'));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      if (!('IntersectionObserver' in window)) { return; }
      sec.classList.add('acmt-js-b');
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      rijen.forEach(function (r) { io.observe(r); });
      /* Vangnet: staat een rij na anderhalve seconde nog onzichtbaar
         terwijl hij wel in beeld is, dan zetten we hem alsnog aan. */
      setTimeout(function () {
        rijen.forEach(function (r) {
          var b = r.getBoundingClientRect();
          if (b.top < window.innerHeight && b.bottom > 0) { r.classList.add('is-in'); }
        });
      }, 1500);
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-pulsar-specificaties ===== */
/* Uitklappen per groep. Op desktop staat de knop op display:none en staat
   alles al open; het script hoeft daar niets te doen. */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-specs-bl]:not([data-ac-ready-bl])').forEach(function (root) {
      root.setAttribute('data-ac-ready-bl', '1');
      root.querySelectorAll('[data-ac-more-bl]').forEach(function (btn) {
        var card = btn.closest('[data-ac-card-bl]');
        var label = btn.querySelector('span');
        btn.addEventListener('click', function () {
          var open = card.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (label) { label.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore; }
        });
      });
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===========================================================================
   AlienComfort | Kopanimatie §4.8 - v6, VOLLEDIG OP ZICHZELF
   Alle klassenamen, keyframes en variabelen in dit blok dragen het voorvoegsel
   "acsp-bl". Er staat geen enkele window-variabele in. Een andere sectie op
   dezelfde pagina, oud of nieuw, kan deze kop dus niet meer aanraken en deze
   kop raakt geen andere sectie aan.
   Waarom dat nodig was: alle secties deelden .acsp-bl__kop, .acsp-js-bl en
   .acsp-in-bl. Het blok van de sectie die als eerste op de pagina stond pakte
   daardoor ALLE koppen beet, ook die van nieuwere secties eronder. In de
   theme-editor viel dat niet op, want daar wordt de sectie los herladen en
   wint het nieuwste blok; live won het oudste. Vandaar: niets meer delen.
   =========================================================================== */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STEP = 0.08, ACCENT = 0.22, TAIL = 0.30;
  function wrap(h) {
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
          var s = document.createElement('span');
          s.className = 'acsp-bl__w'; s.textContent = p;
          frag.appendChild(s);
        });
        h.replaceChild(frag, n);
      } else if (n.nodeType === 1) { n.classList.add('acsp-bl__w'); }
    });
  }
  function build(h, sec) {
    var gespeeld = sec.getAttribute('data-acsp-gespeeld-bl') === '1';
    h.innerHTML = h.getAttribute('data-acsp-bron-bl');
    wrap(h);
    var regels = [], nu = null, top = null;
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.classList.contains('acsp-bl__w')) {
        var t = Math.round(n.offsetTop);
        if (top === null || Math.abs(t - top) > 2) { top = t; nu = []; regels.push(nu); }
        nu.push(n);
      } else if (nu) { nu.push(n); }
    });
    h.innerHTML = '';
    regels.forEach(function (arr, i) {
      var ln = document.createElement('span');
      ln.className = 'acsp-bl__regel';
      arr.forEach(function (n) { ln.appendChild(n); });
      h.appendChild(ln);
      if (gespeeld) { ln.style.animation = 'none'; ln.style.opacity = '1'; ln.style.transform = 'none'; ln.style.clipPath = 'none'; return; }
      ln.style.animationDelay = (i * STEP) + 's';
      Array.prototype.forEach.call(
        ln.querySelectorAll('.acsp-bl__accent, .acsp-bl__semi'),
        function (a) { a.style.transitionDelay = (i * STEP + ACCENT) + 's'; }
      );
    });
    if (!gespeeld) {
      var laatste = (regels.length - 1) * STEP + TAIL;
      Array.prototype.forEach.call(sec.querySelectorAll('.acsp-bl__op'), function (el, k) {
        el.style.transitionDelay = (laatste + k * 0.09) + 's';
      });
    }
  }
  /* Thema's en andere secties zetten soms opacity, visibility of
     -webkit-text-fill-color op nul. Daarom hier expliciet en met voorrang. */
  function zichtbaar(h) {
    h.style.setProperty('opacity', '1', 'important');
    h.style.setProperty('visibility', 'visible', 'important');
    h.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    Array.prototype.forEach.call(h.querySelectorAll('.acsp-bl__regel'), function (ln) {
      ln.style.setProperty('visibility', 'visible', 'important');
      ln.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    });
  }
  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.acsp-bl__kop'), function (h) {
      var sec = h.closest('.acsp-sectie') || h.closest('section') || h.parentElement;
      var box = h.parentElement;
      if (!sec || sec.getAttribute('data-acsp-klaar-bl') === '1') return;
      sec.setAttribute('data-acsp-klaar-bl', '1');
      sec.classList.add('acsp-js-bl');
      h.setAttribute('data-acsp-bron-bl', h.innerHTML);
      zichtbaar(h);
      var raf, b = 0;
      function plan() { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { build(h, sec); zichtbaar(h); }); }
      plan();
      if (window.ResizeObserver) {
        new ResizeObserver(function (e) {
          var nb = Math.round(e[0].contentRect.width);
          if (nb !== b) { b = nb; plan(); }
        }).observe(box);
      } else {
        window.addEventListener('resize', function () { setTimeout(plan, 120); });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(plan);
      /* Laatste redmiddel: als een thema of een andere sectie een OUDER van de
         kop op opacity 0 of visibility hidden zet, helpt forceren op de kop
         zelf niet. Daarom lopen we na het spelen de keten naar boven na. */
      function herstel() {
        var el = h;
        while (el && el !== document.body) {
          var cs = getComputedStyle(el);
          if (parseFloat(cs.opacity) === 0) el.style.setProperty('opacity', '1', 'important');
          if (cs.visibility === 'hidden') el.style.setProperty('visibility', 'visible', 'important');
          if (el === sec) break;
          el = el.parentElement;
        }
      }
      function speel() {
        sec.setAttribute('data-acsp-gespeeld-bl', '1');
        sec.classList.add('acsp-in-bl');
        zichtbaar(h);
        setTimeout(function () { zichtbaar(h); herstel(); }, 400);
      }
      /* Eén zichtbare pixel is genoeg. Met een drempel van 20% blijft de kop
         van een sectie die hoger is dan vijf schermen voor altijd weggeknipt. */
      if (RM.matches || !('IntersectionObserver' in window)) { speel(); return; }
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { speel(); io.disconnect(); }
      }, { threshold: 0 });
      io.observe(sec);
      /* Vangnet: een kop die niet beweegt is vervelend, een kop die
         onzichtbaar blijft is een gemiste verkoop. */
      setTimeout(function () {
        if (sec.getAttribute('data-acsp-gespeeld-bl') === '1') return;
        var r = sec.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { speel(); io.disconnect(); }
      }, 1500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
})();

/* Flush-helper. Shopify zet een Custom Liquid-sectie in een container die
   smaller is dan het scherm, met eigen ruimte eromheen. Bij een witte
   sectie zie je dat niet, bij een ruimtezwarte krijgt u stroken
   paginakleur links, rechts, boven en onder. Hoeveel dat is verschilt per
   thema en per instelling, dus dit meet het op en trekt de sectie door tot
   de rand. Draait één keer per pagina. */

/* ===== ac-faq-pulsar ===== */

(function () {
function init() {
document.querySelectorAll('[data-ac-faq-b]').forEach(function (root) {
if (root.dataset.acReady === '1') return;
root.dataset.acReady = '1';
var items = Array.prototype.slice.call(root.querySelectorAll('.ac-faq-b__item'));
items.forEach(function (item) {
item.addEventListener('toggle', function () {
if (!item.open) return;
items.forEach(function (other) {
if (other !== item) other.open = false;
});
});
});
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

/* ===== ac-luna-statement ===== */
/* De sectie komt binnen zodra hij in beeld staat. Zonder JavaScript,
   zonder IntersectionObserver en bij prefers-reduced-motion wordt de
   klasse acsq-js-u niet gezet en staat alles gewoon zichtbaar (§5.6). */
(function () {
  var init = function () {
    document.querySelectorAll('[data-acsq-u]:not([data-acsq-klaar-u])').forEach(function (sec) {
      sec.setAttribute('data-acsq-klaar-u', '1');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      if (!('IntersectionObserver' in window)) { return; }
      sec.classList.add('acsq-js-u');
      var speel = function () { sec.classList.add('is-in'); };
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { speel(); io.disconnect(); }
      }, { threshold: 0 });
      io.observe(sec);
      /* Vangnet: staat de sectie na anderhalve seconde wel in beeld maar
         is er niets gebeurd, dan zetten wij hem alsnog aan. */
      setTimeout(function () {
        var r = sec.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { speel(); }
      }, 1500);
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-luna-beschrijving ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var knop = sec.querySelector('[data-ac-pd-knop-u]');
var paneel = sec.querySelector('[data-ac-pd-paneel-u]');
if(knop && paneel){
knop.addEventListener('click', function(){
var open = paneel.classList.contains('is-open');
paneel.classList.toggle('is-open', !open);
knop.classList.toggle('is-open', !open);
knop.setAttribute('aria-expanded', open ? 'false' : 'true');
});
}
var kop = sec.querySelector('[data-ac-pd-kop-u]');
var binnen = sec.querySelector('.ac-pd-u__in');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-pd-u__kern') || k.classList.contains('ac-pd-u__semi'))){ k.setAttribute('data-accent-u','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent-u')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-pd-u__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-pd-u__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
/* Vangnet: komt "speelt" niet, dan blijven kop en tekst op opacity 0. */
setTimeout(function(){ sec.classList.add('speelt'); }, 1500);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-pd-u]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* Flush-helper met een EIGEN vlagnaam. Shopify zet een Custom Liquid-sectie
   in een container die smaller is dan het scherm, met eigen ruimte
   eromheen. Deze helper meet dat op en trekt de sectie tot de rand door.
   Vroeger deed width:100vw dat, maar die rekent met de schermbreedte
   inclusief de verticale scrollbalk en geeft dus een horizontale
   scrollbalk. Deelt deze helper zijn vlagnaam met een andere sectie, dan
   claimt de bovenste sectie de vlag en blijft deze staan; vandaar een
   eigen naam en een eigen selector. */
(function () {
  if (window.__acAcpdFlush) return;
  window.__acAcpdFlush = true;
  function apply() {
    document.querySelectorAll('.ac-pd-u--flush').forEach(function (sec) {
      var node = sec.parentElement;
      while (node && node !== document.body) {
        var cs = getComputedStyle(node);
        if (parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) ||
            parseFloat(cs.marginTop)  || parseFloat(cs.marginBottom)) {
          node.style.paddingTop = '0px'; node.style.paddingBottom = '0px';
          node.style.marginTop = '0px';  node.style.marginBottom = '0px';
        }
        node = node.parentElement;
      }
      sec.style.marginLeft = ''; sec.style.marginRight = '';
      sec.style.width = 'auto'; sec.style.maxWidth = 'none';
      var rect = sec.getBoundingClientRect();
      var docWidth = document.documentElement.clientWidth;
      var left = rect.left, right = docWidth - rect.right;
      if (left  > 0.5) sec.style.marginLeft  = (-left)  + 'px';
      if (right > 0.5) sec.style.marginRight = (-right) + 'px';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  window.addEventListener('load', apply);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 120); });
})();

/* ===== ac-luna-usps ===== */
(function () {
/* DE GARANTIE OP TWEE REGELS. De regels staan vast in de HTML en mogen niet
   wikkelen. Dit script meet de breedste regel en verlaagt de lettergrootte
   in stappen tot hij in de kolom past. Alleen font-size verandert, dus de
   kop kan nooit op een ander aantal regels uitkomen dan de twee die er
   staan, en ook nooit buiten beeld vallen. */
function pas(sec) {
var kop = sec.querySelector('.acu__kop');
if (!kop) return;
var vak = kop.parentElement;
var regels = Array.prototype.slice.call(kop.querySelectorAll('.acu__regel > span'));
if (!regels.length) return;
kop.style.fontSize = '';
var maat = parseFloat(getComputedStyle(kop).fontSize) || 26;
for (var i = 0; i < 40; i++) {
var ruimte = vak.clientWidth;
var breedst = 0;
regels.forEach(function (s) { if (s.scrollWidth > breedst) breedst = s.scrollWidth; });
if (!ruimte || breedst <= ruimte || maat <= 15) break;
maat = Math.max(15, maat - Math.max(1, Math.round(maat * 0.04)));
kop.style.fontSize = maat + 'px';
}
}
function start() {
document.querySelectorAll('[data-acu]').forEach(function (sec) {
pas(sec);
if (sec.dataset.acuKlaar === '1') { return; }
sec.dataset.acuKlaar = '1';
var vak = sec.querySelector('.acu__inner');
if (window.ResizeObserver && vak) {
var b = 0, tm = null;
new ResizeObserver(function (e) {
var nb = Math.round(e[0].contentRect.width);
if (nb === b || !nb) return;
b = nb;
clearTimeout(tm);
tm = setTimeout(function () { pas(sec); }, 90);
}).observe(vak);
} else {
window.addEventListener('resize', function () { setTimeout(function () { pas(sec); }, 140); });
}
if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { pas(sec); });
/* De kaarten komen op met drempel 0 en een terugval na 1,6 seconde
   (bouwafspraak 11). */
var items = Array.prototype.slice.call(sec.querySelectorAll('[data-acu-item]'));
if (!items.length) return;
var stil = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || !('IntersectionObserver' in window);
if (stil) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
var io = new IntersectionObserver(function (en) {
en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
}, { threshold: 0 });
items.forEach(function (el, i) { el.style.transitionDelay = (i * 60) + 'ms'; io.observe(el); });
setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 1600);
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
window.addEventListener('load', start);
document.addEventListener('shopify:section:load', start);
})();

/* ===== ac-luna-massagesysteem ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-ms-u]:not([data-ac-ready-u])').forEach(function (root) {
      root.setAttribute('data-ac-ready-u', '1');
      var videos = Array.prototype.slice.call(root.querySelectorAll('[data-ac-video-u]'));
      if (!videos.length) { return; }
      var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (stil) { return; }
      if (!('IntersectionObserver' in window)) {
        videos.forEach(function (v) { v.play().catch(function () {}); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.play().catch(function () {}); } else { e.target.pause(); }
        });
      }, { threshold: 0.25 });
      videos.forEach(function (v) { io.observe(v); });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-luna-kenmerken ===== */
/* Rijen komen binnen zodra ze in beeld staan. Zonder JavaScript, en bij
   prefers-reduced-motion, staat alles gewoon zichtbaar (5.6). */
(function () {
  var init = function () {
    document.querySelectorAll('[data-aclk]:not([data-aclk-klaar])').forEach(function (sec) {
      sec.setAttribute('data-aclk-klaar', '1');
      var rijen = Array.prototype.slice.call(sec.querySelectorAll('.aclk__rij'));
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
      if (!('IntersectionObserver' in window)) { return; }
      sec.classList.add('aclk-js');
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12 });
      rijen.forEach(function (r) { io.observe(r); });
      /* Vangnet: staat een rij na anderhalve seconde nog onzichtbaar
         terwijl hij wel in beeld is, dan zetten wij hem alsnog aan. */
      setTimeout(function () {
        rijen.forEach(function (r) {
          var b = r.getBoundingClientRect();
          if (b.top < window.innerHeight && b.bottom > 0) { r.classList.add('is-in'); }
        });
      }, 1500);
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-luna-specificaties ===== */
/* Uitklappen per groep. Op desktop staat de knop op display:none en staat
   alles al open; het script hoeft daar niets te doen. */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-specs-ul]:not([data-ac-ready-ul])').forEach(function (root) {
      root.setAttribute('data-ac-ready-ul', '1');
      root.querySelectorAll('[data-ac-more-ul]').forEach(function (btn) {
        var card = btn.closest('[data-ac-card-ul]');
        var label = btn.querySelector('span');
        btn.addEventListener('click', function () {
          var open = card.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (label) { label.textContent = open ? btn.dataset.labelLess : btn.dataset.labelMore; }
        });
      });
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* ===========================================================================
   AlienComfort | Kopanimatie §4.8 - v6, VOLLEDIG OP ZICHZELF
   Alle klassenamen, keyframes en variabelen in dit blok dragen het voorvoegsel
   "acsp-ul". Er staat geen enkele window-variabele in. Een andere sectie op
   dezelfde pagina, oud of nieuw, kan deze kop dus niet meer aanraken en deze
   kop raakt geen andere sectie aan.
   Waarom dat nodig was: alle secties deelden .acsp-ul__kop, .acsp-js-ul en
   .acsp-in-ul. Het blok van de sectie die als eerste op de pagina stond pakte
   daardoor ALLE koppen beet, ook die van nieuwere secties eronder. In de
   theme-editor viel dat niet op, want daar wordt de sectie los herladen en
   wint het nieuwste blok; live won het oudste. Vandaar: niets meer delen.
   =========================================================================== */
(function () {
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STEP = 0.08, ACCENT = 0.22, TAIL = 0.30;
  function wrap(h) {
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (p) {
          if (!p) return;
          if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
          var s = document.createElement('span');
          s.className = 'acsp-ul__w'; s.textContent = p;
          frag.appendChild(s);
        });
        h.replaceChild(frag, n);
      } else if (n.nodeType === 1) { n.classList.add('acsp-ul__w'); }
    });
  }
  function build(h, sec) {
    var gespeeld = sec.getAttribute('data-acsp-gespeeld-ul') === '1';
    h.innerHTML = h.getAttribute('data-acsp-bron-ul');
    wrap(h);
    var regels = [], nu = null, top = null;
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType === 1 && n.classList.contains('acsp-ul__w')) {
        var t = Math.round(n.offsetTop);
        if (top === null || Math.abs(t - top) > 2) { top = t; nu = []; regels.push(nu); }
        nu.push(n);
      } else if (nu) { nu.push(n); }
    });
    h.innerHTML = '';
    regels.forEach(function (arr, i) {
      var ln = document.createElement('span');
      ln.className = 'acsp-ul__regel';
      arr.forEach(function (n) { ln.appendChild(n); });
      h.appendChild(ln);
      if (gespeeld) { ln.style.animation = 'none'; ln.style.opacity = '1'; ln.style.transform = 'none'; ln.style.clipPath = 'none'; return; }
      ln.style.animationDelay = (i * STEP) + 's';
      Array.prototype.forEach.call(
        ln.querySelectorAll('.acsp-ul__accent, .acsp-ul__semi'),
        function (a) { a.style.transitionDelay = (i * STEP + ACCENT) + 's'; }
      );
    });
    if (!gespeeld) {
      var laatste = (regels.length - 1) * STEP + TAIL;
      Array.prototype.forEach.call(sec.querySelectorAll('.acsp-ul__op'), function (el, k) {
        el.style.transitionDelay = (laatste + k * 0.09) + 's';
      });
    }
  }
  /* Thema's en andere secties zetten soms opacity, visibility of
     -webkit-text-fill-color op nul. Daarom hier expliciet en met voorrang. */
  function zichtbaar(h) {
    h.style.setProperty('opacity', '1', 'important');
    h.style.setProperty('visibility', 'visible', 'important');
    h.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    Array.prototype.forEach.call(h.querySelectorAll('.acsp-ul__regel'), function (ln) {
      ln.style.setProperty('visibility', 'visible', 'important');
      ln.style.setProperty('-webkit-text-fill-color', 'currentColor', 'important');
    });
  }
  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.acsp-ul__kop'), function (h) {
      var sec = h.closest('.acsp-sectie') || h.closest('section') || h.parentElement;
      var box = h.parentElement;
      if (!sec || sec.getAttribute('data-acsp-klaar-ul') === '1') return;
      sec.setAttribute('data-acsp-klaar-ul', '1');
      sec.classList.add('acsp-js-ul');
      h.setAttribute('data-acsp-bron-ul', h.innerHTML);
      zichtbaar(h);
      var raf, b = 0;
      function plan() { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { build(h, sec); zichtbaar(h); }); }
      plan();
      if (window.ResizeObserver) {
        new ResizeObserver(function (e) {
          var nb = Math.round(e[0].contentRect.width);
          if (nb !== b) { b = nb; plan(); }
        }).observe(box);
      } else {
        window.addEventListener('resize', function () { setTimeout(plan, 120); });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(plan);
      /* Laatste redmiddel: als een thema of een andere sectie een OUDER van de
         kop op opacity 0 of visibility hidden zet, helpt forceren op de kop
         zelf niet. Daarom lopen we na het spelen de keten naar boven na. */
      function herstel() {
        var el = h;
        while (el && el !== document.body) {
          var cs = getComputedStyle(el);
          if (parseFloat(cs.opacity) === 0) el.style.setProperty('opacity', '1', 'important');
          if (cs.visibility === 'hidden') el.style.setProperty('visibility', 'visible', 'important');
          if (el === sec) break;
          el = el.parentElement;
        }
      }
      function speel() {
        sec.setAttribute('data-acsp-gespeeld-ul', '1');
        sec.classList.add('acsp-in-ul');
        zichtbaar(h);
        setTimeout(function () { zichtbaar(h); herstel(); }, 400);
      }
      /* Eén zichtbare pixel is genoeg. Met een drempel van 20% blijft de kop
         van een sectie die hoger is dan vijf schermen voor altijd weggeknipt. */
      if (RM.matches || !('IntersectionObserver' in window)) { speel(); return; }
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { speel(); io.disconnect(); }
      }, { threshold: 0 });
      io.observe(sec);
      /* Vangnet: een kop die niet beweegt is vervelend, een kop die
         onzichtbaar blijft is een gemiste verkoop. */
      setTimeout(function () {
        if (sec.getAttribute('data-acsp-gespeeld-ul') === '1') return;
        var r = sec.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { speel(); io.disconnect(); }
      }, 1500);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
})();

/* Flush-helper. Shopify zet een Custom Liquid-sectie in een container die
   smaller is dan het scherm, met eigen ruimte eromheen. Bij een witte
   sectie zie je dat niet, bij een ruimtezwarte krijgt u stroken
   paginakleur links, rechts, boven en onder. Hoeveel dat is verschilt per
   thema en per instelling, dus dit meet het op en trekt de sectie door tot
   de rand. Draait één keer per pagina. */

/* ===== ac-faq-luna ===== */
(function () {
if (window.__acFaqFlush_u) return;
window.__acFaqFlush_u = true;
function apply() {
document.querySelectorAll('.ac-faq-u--flush').forEach(function (sec) {
var node = sec.parentElement;
while (node && node !== document.body) {
var cs = getComputedStyle(node);
if (parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) ||
parseFloat(cs.marginTop)  || parseFloat(cs.marginBottom)) {
node.style.paddingTop    = '0px';
node.style.paddingBottom = '0px';
node.style.marginTop     = '0px';
node.style.marginBottom  = '0px';
}
node = node.parentElement;
}
sec.style.marginLeft  = '';
sec.style.marginRight = '';
sec.style.width       = 'auto';
sec.style.maxWidth    = 'none';
var rect = sec.getBoundingClientRect();
var docWidth = document.documentElement.clientWidth;
var left  = rect.left;
var right = docWidth - rect.right;
if (left  > 0.5) sec.style.marginLeft  = (-left)  + 'px';
if (right > 0.5) sec.style.marginRight = (-right) + 'px';
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', apply);
} else {
apply();
}
window.addEventListener('load', apply);
var t;
window.addEventListener('resize', function () {
clearTimeout(t);
t = setTimeout(apply, 120);
});
})();

(function () {
function init() {
document.querySelectorAll('[data-ac-faq-u]').forEach(function (root) {
if (root.dataset.acReady === '1') return;
root.dataset.acReady = '1';
var items = Array.prototype.slice.call(root.querySelectorAll('.ac-faq-u__item'));
items.forEach(function (item) {
item.addEventListener('toggle', function () {
if (!item.open) return;
items.forEach(function (other) {
if (other !== item) other.open = false;
});
});
});
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

/* ===== ac-home-match ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = '<span class="ac-mt__regel"><i style="animation-delay:0s">' + el.dataset.bron + '</i></span>';
return 1;
}
function bouw(){
var kop = sec.querySelector('[data-ac-mt-kop]');
if(kop) knip(kop);
var basis = 0.14;
Array.prototype.slice.call(sec.querySelectorAll('[data-ac-mt-na]')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.06).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.18 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
var tm = null, breed = window.innerWidth;
window.addEventListener('resize', function(){ if(window.innerWidth === breed) return; clearTimeout(tm); tm = setTimeout(function(){ breed = window.innerWidth; bouw(); }, 280); });
}
function init(){ document.querySelectorAll('[data-ac-mt]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-home-lichaam ===== */
(function () {
function init() {
document.querySelectorAll('[data-ac-lich-h]:not([data-ac-klaar-h])').forEach(function (root) {
root.setAttribute('data-ac-klaar-h', '1');
var kopEl = root.querySelector('[data-ac-lich-tekst-h]');
function knip() {
if (!kopEl.dataset.origineel) { kopEl.dataset.origineel = kopEl.innerHTML; }
kopEl.innerHTML = '<span class="ac-lich__regel"><i style="animation-delay:0s">' + kopEl.dataset.origineel + '</i></span>';
var na = root.querySelector('.ac-lich__na');
if (na) { na.style.animationDelay = '0.14s'; }
}
var punten = root.querySelectorAll('[data-ac-lich-punt-h]');
var kaarten = root.querySelectorAll('[data-ac-lich-kaart-h]');
function kies(n) {
punten.forEach(function (p) { p.classList.toggle('is-aan', p.getAttribute('data-ac-lich-punt-h') === String(n)); });
kaarten.forEach(function (k) { k.classList.toggle('is-aan', k.getAttribute('data-ac-lich-kaart-h') === String(n)); });
}
punten.forEach(function (p) {
p.addEventListener('click', function () { kies(p.getAttribute('data-ac-lich-punt-h')); });
});
knip();
if (document.fonts && document.fonts.ready) { document.fonts.ready.then(knip); }
var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(knip, 200); });
if (!('IntersectionObserver' in window)) { root.classList.add('is-zicht'); return; }
var kijker = new IntersectionObserver(function (rijen) {
rijen.forEach(function (r) {
if (r.isIntersecting) { r.target.classList.add('is-zicht'); kijker.unobserve(r.target); }
});
}, { threshold: 0.2 });
kijker.observe(root);
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-home-brochure ===== */
(function () {

  /*
   * Zorgt ervoor dat de kop altijd exact
   * op twee regels blijft staan.
   */

  function pas(sec) {

    var kop =
      sec.querySelector('.acbr__kop');

    if (!kop) return;

    var vak =
      kop.parentElement;

    var regels =
      Array.prototype.slice.call(
        kop.querySelectorAll(
          '.acbr__regel > span'
        )
      );

    if (!regels.length) return;

    kop.style.fontSize = '';

    var maat =
      parseFloat(
        getComputedStyle(kop).fontSize
      ) || 28;

    for (
      var i = 0;
      i < 40;
      i++
    ) {

      var ruimte =
        vak.clientWidth;

      var breedst = 0;

      regels.forEach(
        function (s) {

          if (
            s.scrollWidth > breedst
          ) {

            breedst =
              s.scrollWidth;

          }

        }
      );

      if (
        !ruimte ||
        breedst <= ruimte ||
        maat <= 14
      ) {

        break;

      }

      maat =
        Math.max(
          14,
          maat -
          Math.max(
            1,
            Math.round(
              maat * .04
            )
          )
        );

      kop.style.fontSize =
        maat + 'px';

    }

  }

  function start() {

    document
      .querySelectorAll(
        '[data-acbr]'
      )
      .forEach(
        function (sec) {

          pas(sec);

          if (
            sec.dataset.acbrKlaar === '1'
          ) {

            return;

          }

          sec.dataset.acbrKlaar =
            '1';

          var vak =
            sec.querySelector(
              '.acbr__tekst'
            );

          if (
            window.ResizeObserver &&
            vak
          ) {

            var b = 0;
            var tm = null;

            new ResizeObserver(
              function (e) {

                var nb =
                  Math.round(
                    e[0].contentRect.width
                  );

                if (
                  nb === b ||
                  !nb
                ) {

                  return;

                }

                b = nb;

                clearTimeout(tm);

                tm =
                  setTimeout(
                    function () {

                      pas(sec);

                    },
                    90
                  );

              }
            ).observe(vak);

          } else {

            window.addEventListener(
              'resize',
              function () {

                setTimeout(
                  function () {

                    pas(sec);

                  },
                  140
                );

              }
            );

          }

          if (
            document.fonts &&
            document.fonts.ready
          ) {

            document.fonts.ready.then(
              function () {

                pas(sec);

              }
            );

          }

        }
      );

  }

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      start
    );

  } else {

    start();

  }

  window.addEventListener(
    'load',
    start
  );

  document.addEventListener(
    'shopify:section:load',
    start
  );

})();

(function () {

  /*
   * DOWNLOAD FUNCTIE
   *
   * De Shopify CDN staat op een ander domein.
   * Daarom vertrouwen we niet uitsluitend op
   * het HTML download-attribuut.
   *
   * We halen de PDF op als Blob en genereren
   * vervolgens een tijdelijke downloadlink.
   */

  function initDownloads() {

    var knoppen =
      document.querySelectorAll(
        '[data-acbr-download]:not([data-download-ready])'
      );

    knoppen.forEach(
      function (knop) {

        knop.setAttribute(
          'data-download-ready',
          'true'
        );

        knop.addEventListener(
          'click',
          function (event) {

            /*
             * Normale klik overnemen.
             * Ctrl/Cmd/Shift klik blijft
             * standaard browsergedrag.
             */

            if (
              event.metaKey ||
              event.ctrlKey ||
              event.shiftKey ||
              event.altKey
            ) {

              return;

            }

            event.preventDefault();

            var url =
              knop.getAttribute(
                'href'
              );

            var bestandsnaam =
              knop.getAttribute(
                'data-naam'
              ) ||
              'AlienComfort_product_Brochure_2026_5.pdf';

            var label =
              knop.querySelector(
                '[data-acbr-label]'
              );

            var origineelLabel =
              label
                ? label.textContent
                : '';

            var bezigLabel =
              knop.getAttribute(
                'data-bezig'
              ) ||
              origineelLabel;

            /*
             * Knop tijdelijk in laadstatus.
             */

            knop.classList.add(
              'is-bezig'
            );

            knop.setAttribute(
              'aria-busy',
              'true'
            );

            if (label) {

              label.textContent =
                bezigLabel;

            }

            /*
             * PDF ophalen.
             */

            fetch(
              url,
              {
                method:'GET',
                mode:'cors',
                cache:'no-store'
              }
            )

            .then(
              function (response) {

                if (!response.ok) {

                  throw new Error(
                    'PDF download mislukt: ' +
                    response.status
                  );

                }

                return response.blob();

              }
            )

            .then(
              function (blob) {

                /*
                 * Extra controle dat we
                 * daadwerkelijk data hebben.
                 */

                if (
                  !blob ||
                  blob.size === 0
                ) {

                  throw new Error(
                    'Lege PDF ontvangen'
                  );

                }

                var blobUrl =
                  window.URL.createObjectURL(
                    blob
                  );

                var downloadLink =
                  document.createElement(
                    'a'
                  );

                downloadLink.href =
                  blobUrl;

                downloadLink.download =
                  bestandsnaam;

                downloadLink.style.display =
                  'none';

                document.body.appendChild(
                  downloadLink
                );

                downloadLink.click();

                document.body.removeChild(
                  downloadLink
                );

                /*
                 * Tijdelijke Blob URL weer
                 * opruimen.
                 */

                setTimeout(
                  function () {

                    window.URL.revokeObjectURL(
                      blobUrl
                    );

                  },
                  5000
                );

              }
            )

            .catch(
              function () {

                /*
                 * Fallback:
                 * mocht fetch door een browser
                 * of CDN worden geblokkeerd,
                 * dan alsnog de juiste PDF openen.
                 */

                var fallback =
                  document.createElement(
                    'a'
                  );

                fallback.href =
                  url;

                fallback.target =
                  '_blank';

                fallback.rel =
                  'noopener';

                fallback.style.display =
                  'none';

                document.body.appendChild(
                  fallback
                );

                fallback.click();

                document.body.removeChild(
                  fallback
                );

              }
            )

            .finally(
              function () {

                setTimeout(
                  function () {

                    knop.classList.remove(
                      'is-bezig'
                    );

                    knop.removeAttribute(
                      'aria-busy'
                    );

                    if (label) {

                      label.textContent =
                        origineelLabel;

                    }

                  },
                  500
                );

              }
            );

          }
        );

      }
    );

  }

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initDownloads
    );

  } else {

    initDownloads();

  }

  document.addEventListener(
    'shopify:section:load',
    initDownloads
  );

})();

/* ===== ac-home-bekendvan ===== */
(function () {
/* Garantie op twee regels: nowrap plus deze fitter, die de lettergrootte
   verlaagt tot de breedste regel in de kolom past (bouwafspraak 14). */
function pas(sec) {
var kop = sec.querySelector('.ac-bv__kop');
if (!kop) return;
var vak = kop.parentElement;
var regels = Array.prototype.slice.call(kop.querySelectorAll('.ac-bv__regel > span'));
if (!regels.length) return;
kop.style.fontSize = '';
var maat = parseFloat(getComputedStyle(kop).fontSize) || 28;
for (var i = 0; i < 40; i++) {
var ruimte = vak.clientWidth, breedst = 0;
regels.forEach(function (s) { if (s.scrollWidth > breedst) breedst = s.scrollWidth; });
if (!ruimte || breedst <= ruimte || maat <= 14) break;
maat = Math.max(14, maat - Math.max(1, Math.round(maat * 0.04)));
kop.style.fontSize = maat + 'px';
}
}
function start() {
document.querySelectorAll('[data-ac-bv]').forEach(function (sec) {
pas(sec);
if (sec.dataset.acBvKlaar === '1') return;
sec.dataset.acBvKlaar = '1';
var vak = sec.querySelector('.ac-bv__kopblok');
if (window.ResizeObserver && vak) {
var b = 0, tm = null;
new ResizeObserver(function (e) {
var nb = Math.round(e[0].contentRect.width);
if (nb === b || !nb) return;
b = nb; clearTimeout(tm);
tm = setTimeout(function () { pas(sec); }, 90);
}).observe(vak);
} else {
window.addEventListener('resize', function () { setTimeout(function () { pas(sec); }, 140); });
}
if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { pas(sec); });
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
window.addEventListener('load', start);
document.addEventListener('shopify:section:load', start);
})();

(function(){function plak(){document.querySelectorAll('.ac-bv').forEach(function(k){var w=k.closest('.shopify-section')||k.parentElement;if(!w)return;w.style.marginTop='0px';w.style.marginBottom='0px';var a=w.previousElementSibling,b=w.nextElementSibling;if(a)a.style.marginBottom='0px';if(b)b.style.marginTop='0px'})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',plak)}else{plak()}window.addEventListener('load',plak)})();

/* ===== ac-home-modellen ===== */
(function(){
var sec = document.querySelector('.ac-models');
if(!sec || sec.dataset.acKopKlaar) return;
sec.dataset.acKopKlaar = '1';
var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function bouw(){
var kop = sec.querySelector('[data-ac-mod-kop]');
if(kop && kop.dataset.bron !== undefined){ kop.innerHTML = kop.dataset.bron; }
if(kop && !kop.dataset.bron){ kop.dataset.bron = kop.innerHTML; }
var basis = 0.18;
Array.prototype.slice.call(sec.querySelectorAll('.ac-mod__na')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.08).toFixed(2) + 's'; });
}
function carrousel(){
var track = sec.querySelector('[data-ac-mod-track]');
if(!track || track.dataset.acLus) return;
var origineel = Array.prototype.slice.call(track.children);
var n = origineel.length;
if(n < 2) return;
track.dataset.acLus = '1';
function maakSet(){
return origineel.map(function(k){
var c = k.cloneNode(true);
c.setAttribute('aria-hidden', 'true');
c.setAttribute('data-ac-kloon', '1');
Array.prototype.slice.call(c.querySelectorAll('a, button')).forEach(function(el){ el.setAttribute('tabindex', '-1'); });
return c;
});
}
maakSet().forEach(function(c){ track.insertBefore(c, origineel[0]); });
maakSet().forEach(function(c){ track.appendChild(c); });
var kaarten = Array.prototype.slice.call(track.children);
var krimp = 0.11, midden = [], stapPx = 1, thuis = 0, stride = 1, vorigeTop = null;
function lees(){
var k = parseFloat(getComputedStyle(sec).getPropertyValue('--ac-krimp'));
krimp = (k > 0 && k < 0.4) ? k : 0.11;
midden = kaarten.map(function(el){ return el.offsetLeft + el.offsetWidth / 2; });
stapPx = kaarten.length > 1 ? (kaarten[1].offsetLeft - kaarten[0].offsetLeft) : kaarten[0].offsetWidth;
if(stapPx < 1) stapPx = 1;
stride = stapPx * n;
thuis = midden[n] - track.clientWidth / 2;
}
function verdeel(){
var mid = track.scrollLeft + track.clientWidth / 2;
var top = null, kortste = Infinity;
for(var i = 0; i < kaarten.length; i++){
var d = Math.abs(midden[i] - mid) / stapPx;
if(d < kortste){ kortste = d; top = kaarten[i]; }
var a = d > 3 ? 3 : d;
kaarten[i].style.transform = 'scale(' + (1 - a * krimp).toFixed(4) + ')';
kaarten[i].style.zIndex = String(100 - Math.round(a * 12));
}
if(top !== vorigeTop){
if(vorigeTop) vorigeTop.classList.remove('is-actief');
if(top) top.classList.add('is-actief');
vorigeTop = top;
}
}
function zonderSnap(fn){
var was = track.style.scrollSnapType;
track.style.scrollSnapType = 'none';
fn();
requestAnimationFrame(function(){ track.style.scrollSnapType = was || ''; });
}
function naarThuis(){ zonderSnap(function(){ track.scrollLeft = thuis; }); verdeel(); }
lees();
naarThuis();
window.addEventListener('load', function(){ lees(); if(Math.abs(track.scrollLeft - thuis) > stride * 0.6) naarThuis(); verdeel(); });
var wacht = false, bezig = false, bezigTimer = null;
track.addEventListener('scroll', function(){
if(!wacht){
wacht = true;
requestAnimationFrame(function(){ wacht = false; verdeel(); });
}
if(bezig) return;
var v = track.scrollLeft - thuis;
if(v < -stride * 0.5){ zonderSnap(function(){ track.scrollLeft += stride; }); }
else if(v > stride * 0.5){ zonderSnap(function(){ track.scrollLeft -= stride; }); }
}, { passive: true });
function schuifNaar(doel){
var v = doel - thuis;
if(v < -stride * 0.5 || v > stride * 0.5){
var sprong = v < 0 ? stride : -stride;
zonderSnap(function(){ track.scrollLeft += sprong; });
doel += sprong;
}
bezig = true;
clearTimeout(bezigTimer);
bezigTimer = setTimeout(function(){ bezig = false; }, rustig ? 30 : 560);
track.scrollTo({ left: doel, behavior: rustig ? 'auto' : 'smooth' });
}
function stap(r){ schuifNaar(track.scrollLeft + r * stapPx); }
var terug = sec.querySelector('[data-ac-mod-vorige]');
var verder = sec.querySelector('[data-ac-mod-volgende]');
if(terug) terug.addEventListener('click', function(){ stap(-1); });
if(verder) verder.addEventListener('click', function(){ stap(1); });
var sleep = null, klemTimer = null;
track.addEventListener('dragstart', function(e){ e.preventDefault(); });
track.addEventListener('pointerdown', function(e){
if(e.pointerType !== 'mouse' || e.button !== 0) return;
sleep = { x: e.clientX, s: track.scrollLeft, ging: false };
clearTimeout(klemTimer);
track.classList.add('is-sleep');
});
window.addEventListener('pointermove', function(e){
if(!sleep) return;
var dx = e.clientX - sleep.x;
if(Math.abs(dx) > 6) sleep.ging = true;
track.scrollLeft = sleep.s - dx;
});
window.addEventListener('pointerup', function(){
if(!sleep) return;
var ging = sleep.ging;
sleep = null;
if(ging){
var vang = function(ev){ ev.preventDefault(); ev.stopPropagation(); };
track.addEventListener('click', vang, true);
setTimeout(function(){ track.removeEventListener('click', vang, true); }, 80);
schuifNaar(thuis + Math.round((track.scrollLeft - thuis) / stapPx) * stapPx);
klemTimer = setTimeout(function(){ track.classList.remove('is-sleep'); }, rustig ? 20 : 420);
} else {
track.classList.remove('is-sleep');
}
});
var meetTimer = null;
function hermeet(){
clearTimeout(meetTimer);
meetTimer = setTimeout(function(){
var v = Math.round((track.scrollLeft - thuis) / stapPx);
lees();
zonderSnap(function(){ track.scrollLeft = thuis + v * stapPx; });
verdeel();
}, 140);
}
if(window.ResizeObserver){ new ResizeObserver(hermeet).observe(track); }
else { window.addEventListener('resize', hermeet); }
if(document.fonts && document.fonts.ready){ document.fonts.ready.then(function(){ lees(); verdeel(); }); }
}
function start(){
bouw();
carrousel();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.1 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
var tm = null, breed = window.innerWidth;
window.addEventListener('resize', function(){ if(window.innerWidth === breed) return; clearTimeout(tm); tm = setTimeout(function(){ breed = window.innerWidth; bouw(); }, 160); });
})();

/* ===== ac-home-kosten ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var budget = sec.querySelector('[data-ac-kv-budget]');
var jaren = sec.querySelector('[data-ac-kv-jaren]');
var budgetUit = sec.querySelector('[data-ac-kv-budget-uit]');
var jarenUit = sec.querySelector('[data-ac-kv-jaren-uit]');
var jaarLabel = sec.querySelector('[data-ac-kv-jaarlabel]');
var rijen = Array.prototype.slice.call(sec.querySelectorAll('[data-ac-kv-rij]'));
var stoelUit = sec.querySelector('[data-ac-kv-stoel]');
var perDag = sec.querySelector('[data-ac-kv-perdag]');
var taal = sec.getAttribute('data-taal') || 'nl';
var jaar1 = sec.getAttribute('data-jaar1') || 'jaar';
var jaarN = sec.getAttribute('data-jaarn') || 'jaar';
function euro(v, d){
try { return new Intl.NumberFormat(taal, { style: 'currency', currency: 'EUR', minimumFractionDigits: d, maximumFractionDigits: d }).format(v); }
catch(e){ return '€' + v.toFixed(d); }
}
function vulling(el){
var min = Number(el.min), max = Number(el.max);
el.style.setProperty('--pct', (((Number(el.value) - min) / (max - min)) * 100) + '%');
}
function ververs(){
if(!budget || !jaren) return;
var b = Number(budget.value), j = Number(jaren.value);
vulling(budget); vulling(jaren);
if(budgetUit) budgetUit.textContent = euro(b, 0);
if(jarenUit) jarenUit.textContent = j;
if(jaarLabel) jaarLabel.textContent = j === 1 ? jaar1 : jaarN;
rijen.forEach(function(r){
var t = r.querySelector('[data-ac-kv-totaal]');
if(t) t.textContent = euro(Number(r.getAttribute('data-tarief')) * Number(r.getAttribute('data-keer')) * j, 0);
});
if(stoelUit) stoelUit.textContent = euro(b, 0);
if(perDag) perDag.textContent = euro(b / (365 * j), 2);
}
if(budget) budget.addEventListener('input', ververs);
if(jaren) jaren.addEventListener('input', ververs);
ververs();
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = '<span class="ac-kv__regel"><i style="animation-delay:0s">' + el.dataset.bron + '</i></span>';
return 1;
}
function bouw(){
var kop = sec.querySelector('[data-ac-kv-kop]');
if(kop) knip(kop);
var basis = 0.14;
Array.prototype.slice.call(sec.querySelectorAll('[data-ac-kv-na]')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.055).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
var tm = null, breed = window.innerWidth;
window.addEventListener('resize', function(){ if(window.innerWidth === breed) return; clearTimeout(tm); tm = setTimeout(function(){ breed = window.innerWidth; bouw(); }, 280); });
}
function init(){ document.querySelectorAll('[data-ac-kv]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-home-titanvideo ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
function plakVast(){
var n = sec.parentElement;
while(n && n !== document.body){
var cs = getComputedStyle(n);
if(parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) || parseFloat(cs.marginTop) || parseFloat(cs.marginBottom)){
n.style.paddingTop = '0px'; n.style.paddingBottom = '0px';
n.style.marginTop = '0px'; n.style.marginBottom = '0px';
}
n = n.parentElement;
}
}
plakVast();
window.addEventListener('load', plakVast);
var pt = null;
window.addEventListener('resize', function(){ clearTimeout(pt); pt = setTimeout(plakVast, 140); });
var kader = sec.querySelector('[data-ac-tv-kader]');
var video = sec.querySelector('[data-ac-tv-video]');
if(kader && video){
var play = kader.querySelector('[data-ac-tv-play]');
var geluid = kader.querySelector('[data-ac-tv-geluid]');
function sync(){
var loopt = !video.paused && !video.ended;
kader.classList.toggle('speelt', loopt);
if(play) play.setAttribute('aria-label', loopt ? play.getAttribute('data-pauze') : play.getAttribute('data-play'));
if(geluid){ geluid.classList.toggle('is-aan', !video.muted); geluid.setAttribute('aria-pressed', String(!video.muted)); }
}
if(play) play.addEventListener('click', function(){ if(video.paused){ video.play().catch(function(){}); } else { video.pause(); } });
if(geluid) geluid.addEventListener('click', function(){ video.muted = !video.muted; if(!video.muted && video.paused) video.play().catch(function(){}); sync(); });
['play','pause','ended','volumechange'].forEach(function(e){ video.addEventListener(e, sync); });
var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if(!stil && 'IntersectionObserver' in window){
new IntersectionObserver(function(rijen){
rijen.forEach(function(r){
if(r.isIntersecting){ if(video.paused && video.muted) video.play().catch(function(){}); }
else if(!video.paused){ video.pause(); }
});
}, { threshold: 0.35 }).observe(kader);
}
sync();
}
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = '<span class="ac-tv__regel"><i style="animation-delay:0s">' + el.dataset.bron + '</i></span>';
return 1;
}
function bouw(){
var kop = sec.querySelector('[data-ac-tv-kop]');
if(kop) knip(kop);
var basis = 0.14;
Array.prototype.slice.call(sec.querySelectorAll('[data-ac-tv-na]')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.07).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.1 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
var tm = null, breed = window.innerWidth;
window.addEventListener('resize', function(){ if(window.innerWidth === breed) return; clearTimeout(tm); tm = setTimeout(function(){ breed = window.innerWidth; bouw(); }, 280); });
}
function init(){ document.querySelectorAll('[data-ac-tv]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-home-rollervideo ===== */
(function(){
var sec = document.querySelector('[data-ac-roll-h]');
if(!sec || sec.dataset.klaar) return;
sec.dataset.klaar = '1';
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = '<span class="ac-roll-h__regel"><i style="animation-delay:0s">' + el.dataset.bron + '</i></span>';
return 1;
}
function bouw(){
var kop = sec.querySelector('[data-ac-kop-h]');
if(kop) knip(kop);
var basis = 0.14;
var na = sec.querySelector('[data-ac-na-h]');
if(na) na.style.animationDelay = basis.toFixed(2) + 's';
Array.prototype.slice.call(sec.querySelectorAll('[data-ac-kaart-h]')).forEach(function(el, i){ el.style.animationDelay = (basis + 0.12 + i * 0.055).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.18 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
var tm = null, breed = window.innerWidth;
window.addEventListener('resize', function(){ if(window.innerWidth === breed) return; clearTimeout(tm); tm = setTimeout(function(){ breed = window.innerWidth; bouw(); }, 280); });
})();

/* ===== ac-home-rollers ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var tabs = Array.prototype.slice.call(sec.querySelectorAll('[data-ac-rol-tab]'));
var panelen = Array.prototype.slice.call(sec.querySelectorAll('[data-ac-rol-paneel]'));
/* Het starttabblad stond als Liquid in dit script; in een gecachet bestand
   blijft dat letterlijke tekst. Nu leest het script het van de sectie. */
var acStart = parseInt(sec.getAttribute('data-ac-rol-start') || '0', 10) || 0;
var huidig = acStart;
function toon(i){
var n = panelen.length;
huidig = ((i % n) + n) % n;
tabs.forEach(function(t, k){ var aan = k === huidig; t.classList.toggle('is-aan', aan); t.setAttribute('aria-selected', aan ? 'true' : 'false'); t.setAttribute('tabindex', aan ? '0' : '-1'); });
panelen.forEach(function(p, k){ var aan = k === huidig; p.classList.toggle('is-aan', aan); p.setAttribute('aria-hidden', aan ? 'false' : 'true'); });
}
tabs.forEach(function(t, i){
t.addEventListener('click', function(){ toon(i); });
t.addEventListener('keydown', function(e){
if(['ArrowLeft','ArrowRight','Home','End'].indexOf(e.key) === -1) return;
e.preventDefault();
var n = huidig;
if(e.key === 'ArrowLeft') n = huidig - 1;
if(e.key === 'ArrowRight') n = huidig + 1;
if(e.key === 'Home') n = 0;
if(e.key === 'End') n = tabs.length - 1;
toon(n);
if(tabs[huidig]) tabs[huidig].focus();
});
});
var v = sec.querySelector('[data-ac-rol-vorige]'), w = sec.querySelector('[data-ac-rol-volgende]');
if(v) v.addEventListener('click', function(){ toon(huidig - 1); });
if(w) w.addEventListener('click', function(){ toon(huidig + 1); });
var vlak = sec.querySelector('[data-ac-rol-swipe]'), sx = 0, sy = 0;
if(vlak){
vlak.addEventListener('touchstart', function(e){ var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; }, { passive: true });
vlak.addEventListener('touchend', function(e){ var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; if(Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return; toon(dx < 0 ? huidig + 1 : huidig - 1); }, { passive: true });
}
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = '<span class="ac-rol__regel"><i style="animation-delay:0s">' + el.dataset.bron + '</i></span>';
return 1;
}
function bouw(){
var kop = sec.querySelector('[data-ac-rol-kop]');
if(kop) knip(kop);
var basis = 0.14;
Array.prototype.slice.call(sec.querySelectorAll('[data-ac-rol-na]')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.06).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
setTimeout(function(){ sec.classList.add('speelt'); }, 1500);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
var tm = null, breed = window.innerWidth;
window.addEventListener('resize', function(){ if(window.innerWidth === breed) return; clearTimeout(tm); tm = setTimeout(function(){ breed = window.innerWidth; bouw(); }, 280); });
toon(acStart);
}
function init(){ document.querySelectorAll('[data-ac-rol]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-faq-home ===== */

(function () {
function init() {
document.querySelectorAll('[data-ac-faq-h]').forEach(function (root) {
if (root.dataset.acReady === '1') return;
root.dataset.acReady = '1';
var items = Array.prototype.slice.call(root.querySelectorAll('.ac-faq-h__item'));
items.forEach(function (item) {
item.addEventListener('toggle', function () {
if (!item.open) return;
items.forEach(function (other) {
if (other !== item) other.open = false;
});
});
});
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

/* ===== ac-modellen-home ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-xs-h]:not([data-ac-ready-h])').forEach(function (root) {
      root.setAttribute('data-ac-ready-h', '1');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ac-tab-h]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-ac-panel-h]'));
      if (!tabs.length) { return; }
      var select = function (key) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-ac-tab-h') === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          if (p.getAttribute('data-ac-panel-h') === key) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
      };
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t.getAttribute('data-ac-tab-h')); });
        t.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = (i + 1) % tabs.length; }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = (i - 1 + tabs.length) % tabs.length; }
          if (next === null) { return; }
          e.preventDefault();
          select(tabs[next].getAttribute('data-ac-tab-h'));
          tabs[next].focus();
        });
      });
      /* Productpagina's alvast ophalen zodra een link wordt aangeraakt;
         de doorklik voelt daardoor direct. Elke URL maar een keer. */
      var geladen = {};
      root.querySelectorAll('.ac-xs-h__main, .ac-xs-h__var').forEach(function (link) {
        var laad = function () {
          if (!link.href || geladen[link.href]) { return; }
          geladen[link.href] = true;
          var l = document.createElement('link');
          l.rel = 'prefetch';
          l.href = link.href;
          document.head.appendChild(l);
        };
        link.addEventListener('mouseenter', laad);
        link.addEventListener('touchstart', laad, { passive: true });
      });
      /* Over een kleurvariant bewegen wisselt alvast de grote foto van
         het model. Klikken gaat naar de pagina van die kleur. */
      root.querySelectorAll('.ac-xs-h__card').forEach(function (card) {
        var groot = card.querySelector('.ac-xs-h__imgwrap img');
        if (!groot) { return; }
        card.querySelectorAll('.ac-xs-h__var[data-ac-img-h]').forEach(function (v) {
          v.addEventListener('mouseenter', function () {
            var bron = v.getAttribute('data-ac-img-h');
            if (!bron || groot.src === bron) { return; }
            groot.src = bron;
            groot.removeAttribute('srcset');
          });
        });
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-home-kennisbank ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-kb]:not([data-ac-kb-klaar])').forEach(function (sec) {
      sec.setAttribute('data-ac-kb-klaar', '1');
      var loc = sec.getAttribute('data-loc') || 'nl-NL';
      var rij = sec.querySelector('[data-ac-kb-rij]');
      var leeg = sec.querySelector('[data-ac-kb-leeg]');
      var kaarten = Array.prototype.slice.call(sec.querySelectorAll('.ac-kb__kaart'));

      /* De datum uitschrijven in de taal van de bezoeker. Het Liquid-filter
         geeft alleen Engelse maandnamen; de browser weet het beter. */
      sec.querySelectorAll('[data-datum]').forEach(function (el) {
        var d = new Date(el.getAttribute('data-datum') + 'T12:00:00');
        if (isNaN(d.getTime())) { return; }
        try {
          el.textContent = d.toLocaleDateString(loc, { day: 'numeric', month: 'long', year: 'numeric' });
        } catch (e) { /* dan blijft de datum staan zoals hij stond */ }
      });

      var chips = Array.prototype.slice.call(sec.querySelectorAll('[data-thema]')).filter(function (el) {
        return el.classList.contains('ac-kb__chip');
      });
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var kies = chip.getAttribute('data-thema');
          chips.forEach(function (o) {
            var aan = o === chip;
            o.classList.toggle('is-aan', aan);
            o.setAttribute('aria-pressed', aan ? 'true' : 'false');
          });
          var zichtbaar = 0;
          kaarten.forEach(function (k) {
            var toon = kies === 'alles' || k.getAttribute('data-thema') === kies;
            k.hidden = !toon;
            if (toon) { zichtbaar++; }
          });
          if (leeg) { leeg.hidden = zichtbaar > 0; }
          if (rij) { rij.scrollLeft = 0; }
        });
      });
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* Flush-helper. Shopify zet een Custom Liquid-sectie in een container die
   smaller is dan het scherm, met eigen ruimte eromheen. Bij een witte
   sectie zie je dat niet, bij een grijze krijg je stroken paginakleur
   links, rechts, boven en onder. Dit meet dat op en trekt de sectie door
   tot de rand. Draait één keer per pagina. */

/* Kopanimatie §4.8 — identiek blok in alle AlienComfort-secties, idempotent. */

/* ===== ac-collectie-andromeda ===== */

/* ===== ac-collectie-melkweg ===== */

/* ===== ac-collectie-quasar ===== */

/* ===== ac-am-melkweg ===== */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ac-mw-slider-shell').forEach(function (shell) {
      var slider = shell.querySelector('[data-ac-mw-slider]');
      var prev = shell.querySelector('.ac-mw-scroll-prev');
      var next = shell.querySelector('.ac-mw-scroll-next');

      if (!slider || !prev || !next) return;

      function getScrollAmount() {
        var card = slider.querySelector('.ac-mw-card');
        if (!card) return slider.clientWidth * 0.85;

        var gap = parseFloat(window.getComputedStyle(slider).gap) || 12;
        return card.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        var maxScroll = slider.scrollWidth - slider.clientWidth - 2;

        prev.classList.toggle('is-disabled', slider.scrollLeft <= 2);
        next.classList.toggle('is-disabled', slider.scrollLeft >= maxScroll);
      }

      prev.addEventListener('click', function () {
        slider.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });

      next.addEventListener('click', function () {
        slider.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });

      slider.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);

      setTimeout(updateButtons, 150);
    });
  });

/* ===== ac-am-quasar ===== */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ac-quasar-slider-shell').forEach(function (shell) {
      var slider = shell.querySelector('[data-ac-quasar-slider]');
      var prev = shell.querySelector('.ac-quasar-scroll-prev');
      var next = shell.querySelector('.ac-quasar-scroll-next');

      if (!slider || !prev || !next) return;

      function getScrollAmount() {
        var card = slider.querySelector('.ac-quasar-card');
        if (!card) return slider.clientWidth * 0.85;

        var gap = parseFloat(window.getComputedStyle(slider).gap) || 12;
        return card.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        var maxScroll = slider.scrollWidth - slider.clientWidth - 2;

        prev.classList.toggle('is-disabled', slider.scrollLeft <= 2);
        next.classList.toggle('is-disabled', slider.scrollLeft >= maxScroll);
      }

      prev.addEventListener('click', function () {
        slider.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });

      next.addEventListener('click', function () {
        slider.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });

      slider.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);

      setTimeout(updateButtons, 150);
    });
  });

/* ===== ac-am-andromeda ===== */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ac-andromeda-slider-shell').forEach(function (shell) {
      var slider = shell.querySelector('[data-ac-andromeda-slider]');
      var prev = shell.querySelector('.ac-andromeda-scroll-prev');
      var next = shell.querySelector('.ac-andromeda-scroll-next');

      if (!slider || !prev || !next) return;

      function getScrollAmount() {
        var card = slider.querySelector('.ac-andromeda-card');
        if (!card) return slider.clientWidth * 0.85;

        var gap = parseFloat(window.getComputedStyle(slider).gap) || 12;
        return card.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        var maxScroll = slider.scrollWidth - slider.clientWidth - 2;

        prev.classList.toggle('is-disabled', slider.scrollLeft <= 2);
        next.classList.toggle('is-disabled', slider.scrollLeft >= maxScroll);
      }

      prev.addEventListener('click', function () {
        slider.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
      });

      next.addEventListener('click', function () {
        slider.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
      });

      slider.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);

      setTimeout(updateButtons, 150);
    });
  });

/* ===== ac-keuzehulp ===== */
!function(){var e="stap van vorige volgende toon klaar uitleg meer lbl0 lbl1 lbl2 bekijk leeg geenmatch let_op waarom preorder bi bd bz buiten wluna watlas wvast wbudget wpre srkop srtekst srknop opnieuw en sep".split(" "),a="int diep zacht var prec rug omh voet warm inst gem str zitb".split(" "),t="rail vast diep brw scan w45 w2 been voetruim tractie thai var24 tech5 rol16 zacht tablet prijs kg150 kg140 cm210 smal breed".split(" "),r=[{k:"zone",v:["nek","rug","benen","alles"],an:0},{k:"duur",v:["soms","vaak","lang"]},{k:"stevig",v:["2","3","4","5"]},{k:"extra",v:["warm","voet","str","var"],m:1},{k:"inst",v:["1","3","5"],an:1},{k:"zitb",v:["2","3","5"]},{k:"maat",d:[["lengte",["190","205","210"]],["gewicht",["120","140","150"]]]},{k:"budget",v:["1000","2000","3000","9999"]}],n=[["rol","sl"],["brw","brd"]];function c(e,a){return'<svg viewBox="0 0 100 70" aria-hidden="true"><line class="kh-n" x1="50" y1="10" x2="50" y2="60"></line><g class="'+e+'"><circle class="kh-h" cx="-9" cy="0" r="6"></circle><circle class="kh-h" cx="9" cy="0" r="6"></circle></g>'+(a?'<path class="kh-p" d="M74 16 h10 M79 11 v10"></path>':"")+"</svg>"}function s(){document.querySelectorAll("[data-ac-kh]").forEach(function(s){if("1"!==s.dataset.acReady){s.dataset.acReady="1";var i=s.querySelector("[data-ac-kh-data]");if(i){var o;try{o=JSON.parse(i.textContent)}catch(e){return}var l={rol:o.svg[0],sl:o.svg[1],brw:c("kh-w",0),brd:c("kh-x",1)},u=o.producten,p={};e.forEach(function(e,a){p[e]=o.s[a]}),p.p={},t.forEach(function(e,a){p.p[e]=o.p[a]});var h=o.modellen.map(function(e){var r={};return a.forEach(function(a,t){r[a]=e[1][t]}),{n:e[0],a:r,L:e[2],G:e[3],p:e[4].map(function(e){return t[e]})}}),d=s.querySelector("[data-ac-kh-form]"),k=s.querySelector("[data-ac-kh-result]"),v=s.querySelector("[data-ac-kh-cards]"),g=s.querySelector("[data-ac-kh-melding]"),f=s.querySelector("[data-ac-kh-fill]"),b=s.querySelector("[data-ac-kh-step]"),_=0,m={extra:[]},w="";r.forEach(function(e,a){var t=o.q[a],r=1;w+='<fieldset class="ac-kh__stap" data-stap="'+a+'"><legend class="ac-kh__q">'+q(t[0])+"</legend>",e.m&&(w+='<p class="ac-kh__hint">'+q(p.meer)+"</p>"),e.d?e.d.forEach(function(e){w+='<p class="ac-kh__sub">'+q(t[r++])+'</p><div class="ac-kh__opts ac-kh__opts--3">',e[1].forEach(function(a,n){var c="ackh-"+e[0]+"-"+n;w+='<label class="ac-kh__opt" for="'+c+'"><input id="'+c+'" type="radio" name="'+e[0]+'" value="'+a+'"><span>'+q(t[r++])+"</span></label>"}),w+="</div>"}):(w+='<div class="ac-kh__opts'+(3===e.v.length?" ac-kh__opts--3":"")+'">',e.v.forEach(function(a,r){var n="ackh-"+e.k+"-"+r;w+='<label class="ac-kh__opt'+(e.m?" ac-kh__opt--vink":"")+'" for="'+n+'"><input id="'+n+'" type="'+(e.m?"checkbox":"radio")+'" name="'+e.k+'" value="'+a+'"><span>'+q(t[r+1])+"</span></label>"}),w+="</div>"),o.u[a]&&(w+='<details class="ac-kh__uitleg"><summary>'+q(p.uitleg)+'</summary><div class="ac-kh__uitleg-in">'+function(e){return null==e?"":'<div class="kh-a">'+n[e].map(function(a,t){return"<figure>"+l[a]+"<figcaption>"+q(o.b[2*e+t])+"</figcaption></figure>"}).join("")+"</div>"}(e.an)+"<p>"+q(o.u[a])+"</p></div></details>"),w+="</fieldset>"}),w+='<div class="ac-kh__nav"><button type="button" class="ac-kh__knop ac-kh__knop--outline" data-ac-kh-prev>'+q(p.vorige)+'</button><button type="button" class="ac-kh__knop" data-ac-kh-next>'+q(p.volgende)+"</button></div>",d.innerHTML=w,s.querySelector("[data-ac-kh-sr]").innerHTML='<h4 class="ac-kh__srkop">'+q(p.srkop)+'</h4><p class="ac-kh__srtekst">'+q(p.srtekst)+'</p><div class="ac-kh__sracties"><a class="ac-kh__knop ac-kh__knop--champ" href="'+q(o.sr)+'">'+q(p.srknop)+'</a><button type="button" class="ac-kh__knop ac-kh__knop--outline" data-ac-kh-reset>'+q(p.opnieuw)+"</button></div>";var y=Array.prototype.slice.call(d.querySelectorAll(".ac-kh__stap")),x=d.querySelector("[data-ac-kh-prev]"),z=d.querySelector("[data-ac-kh-next]");d.addEventListener("change",function(e){var a=e.target;"checkbox"===a.type?m.extra=Array.prototype.slice.call(d.querySelectorAll('input[name="extra"]:checked')).map(function(e){return e.value}):"radio"===a.type&&(m[a.name]=a.value),z.disabled=!E(_),"radio"===a.type&&!r[_].d&&_<y.length-1&&setTimeout(function(){E(_)&&(_++,L())},190)}),z.addEventListener("click",function(){E(_)&&(_<y.length-1?(_++,L()):function(){var e=function(){var e={};u.forEach(function(a){var t=function(e){for(var a=String(e).toUpperCase(),t=0;t<j.length;t++)if(a.indexOf(j[t].n)>-1)return j[t];return null}(a.titel);if(t){var r=e[t.n];(!r||a.voorraad&&!r.p.voorraad||a.voorraad===r.p.voorraad&&a.prijs<r.p.prijs)&&(e[t.n]={p:a,m:t})}});var a=Object.keys(e).map(function(a){return e[a]});function t(e,a){return a.n!==e.n?a.n-e.n:e.p.prijs-a.p.prijs}a.forEach(function(e){e.n=function(e,a){var t=a.a,r=0;"nek"===m.zone?r+=5*t.prec+3*t.int:"rug"===m.zone?r+=6*t.rug+4*t.warm:"benen"===m.zone?r+=11*t.voet:r+=4*t.gem+4*(5-t.int)+2*t.omh;"lang"===m.duur?r+=5*(t.prec+t.rug+t.diep):"vaak"===m.duur?r+=3*(t.prec+t.rug):r+=3*t.gem+2*(5-t.prec);r-=14*Math.abs(t.int-+m.stevig),+m.stevig<=2&&(r+=9*t.zacht);A("warm")&&(r+=8*t.warm);A("voet")&&(r+=8*t.voet);A("str")&&(r+=9*t.str);A("var")&&(r+=8*t.var);"1"===m.inst?r+=3*t.gem:r-=12*Math.abs(t.inst-+m.inst);r-=11*Math.abs(t.zitb-+m.zitb);var n=+m.budget,c=e.prijs/100;c<=n?r+=26:r-=Math.min(75,(c-n)/20);return r}(e.p,e.m)});var r=a.filter(function(e){return M(e.m)}).sort(t),n=a.filter(function(e){return!M(e.m)}).sort(t),c=r.slice(0,3);return n.slice(0,3-c.length).forEach(function(e){e.buiten=!0,c.push(e)}),{lijst:c,krap:0===r.length}}();g.hidden=!e.krap,e.krap&&(g.textContent=p.geenmatch);e.lijst.length?v.innerHTML=e.lijst.map(function(e,a){var t=e.p,r=e.m,n=r.n,c=function(e){var a=e.m,t=e.p,r=[];e.buiten&&r.push(p.buiten.replace("{L}",a.L).replace("{G}",a.G));"LUNA"===a.n&&+m.stevig<=3&&r.push(p.wluna);"ATLAS"===a.n&&+m.stevig<=2&&r.push(p.watlas);"lang"===m.duur&&a.a.prec<=1&&r.push(p.wvast);t.prijs/100>+m.budget&&r.push(p.wbudget);t.voorraad||r.push(p.wpre);return r.slice(0,2)}(e);return'<li class="ac-kh__card'+(0===a?" ac-kh__card--top":"")+'"><span class="ac-kh__label">'+q(p["lbl"+a]||"")+"</span>"+(t.afbeelding?'<a class="ac-kh__beeld" href="'+q(t.url)+'" tabindex="-1" aria-hidden="true"><img src="'+q(t.afbeelding)+'" alt="" loading="lazy"></a>':"")+'<h4 class="ac-kh__naam"><a href="'+q(t.url)+'">'+q(n)+'</a></h4><span class="ac-kh__prijs">'+q(t.prijsTekst)+'</span><span class="ac-kh__chips">'+function(e){var a=e.a.rug<=2;return'<span class="ac-kh__sys">'+l[a?"rol":"sl"]+"<b>"+q(o.b[a?0:1])+"</b></span>"}(r)+(t.voorraad?"":'<span class="ac-kh__po">'+q(p.preorder)+"</span>")+'</span><p class="ac-kh__waaromkop">'+q(p.waarom)+'</p><p class="ac-kh__reden">'+q(function(e){var a=e.p.filter(T).sort(function(e,a){return(S[a]||0)-(S[e]||0)}),t=e.p.filter(function(e){return a.indexOf(e)<0}),r=a.slice(0,3);for(;r.length<2&&t.length;)r.push(t.shift());var n=r.map(function(e){return p.p[e]}).filter(Boolean);return n.length?1===n.length?n[0]+".":n.slice(0,-1).join(p.sep)+" "+p.en+" "+n[n.length-1]+".":""}(r))+"</p>"+c.map(function(e){return'<p class="ac-kh__waarschuw"><strong>'+q(p.let_op)+":</strong> "+q(e)+"</p>"}).join("")+'<span class="ac-kh__balken">'+C(p.bi,r.a.int)+C(p.bd,r.a.diep)+C(p.bz,r.a.zitb)+'</span><a class="ac-kh__knop ac-kh__kaartknop" href="'+q(t.url)+'">'+q(p.bekijk.replace("{N}",n))+"</a></li>"}).join(""):v.innerHTML='<li class="ac-kh__card"><p class="ac-kh__reden">'+q(p.leeg)+"</p></li>";d.hidden=!0,k.hidden=!1,f.style.width="100%",b.textContent=p.klaar,k.scrollIntoView&&k.scrollIntoView({behavior:window.matchMedia("(prefers-reduced-motion: reduce)").matches?"auto":"smooth",block:"start"})}())}),x.addEventListener("click",function(){_>0&&(_--,L())});var j=h.slice().sort(function(e,a){return a.n.length-e.n.length}),S={diep:4,been:4,voetruim:4,tractie:4,thai:4,w45:4,var24:4,brw:4,vast:3,tablet:3,w2:3,zacht:3,prijs:3,smal:3,breed:3,kg150:3,kg140:3,cm210:3,rail:2,scan:2,rol16:2,tech5:1};s.querySelector("[data-ac-kh-reset]").addEventListener("click",function(){d.reset(),m={extra:[]},_=0,d.hidden=!1,k.hidden=!0,v.innerHTML="",g.hidden=!0,L(),s.scrollIntoView({behavior:"smooth",block:"start"})}),L()}}function q(e){return String(null==e?"":e).replace(/[&<>"']/g,function(e){return{"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[e]})}function E(e){var a=r[e];return!!a.m||(a.d?a.d.every(function(e){return!!d.querySelector('input[name="'+e[0]+'"]:checked')}):!!y[e].querySelector("input:checked"))}function L(){y.forEach(function(e,a){e.hidden=a!==_}),f.style.width=(_+1)/y.length*100+"%",b.textContent=p.stap+" "+(_+1)+" "+p.van+" "+y.length,x.disabled=0===_,z.textContent=_===y.length-1?p.toon:p.volgende,z.disabled=!E(_)}function M(e){return e.L>=+m.lengte&&e.G>=+m.gewicht}function A(e){return m.extra.indexOf(e)>-1}function T(e){switch(e){case"rail":return"lang"===m.duur||"vaak"===m.duur||"rug"===m.zone;case"scan":return"lang"===m.duur||"nek"===m.zone;case"vast":return"1"===m.inst||"soms"===m.duur;case"diep":return"5"===m.inst;case"brw":return"3"===m.inst;case"w45":return A("warm")||"rug"===m.zone;case"w2":return A("warm");case"been":return A("voet")||A("str")||"benen"===m.zone;case"voetruim":return A("voet")||"benen"===m.zone;case"tractie":case"thai":return A("str");case"var24":return A("var");case"rol16":return+m.stevig>=4;case"tech5":return"soms"===m.duur||"alles"===m.zone;case"zacht":return+m.stevig<=2;case"tablet":return"1"===m.inst;case"prijs":return"1000"===m.budget;case"kg150":case"kg140":return+m.gewicht>=120;case"cm210":return+m.lengte>=205;case"smal":return"2"===m.zitb;case"breed":return"5"===m.zitb}return!1}function C(e,a){return'<span class="ac-kh__balk">'+q(e)+'<i><b style="width:'+20*a+'%"></b></i></span>'}})}"loading"===document.readyState?document.addEventListener("DOMContentLoaded",s):s(),document.addEventListener("shopify:section:load",s)}();

(function(){if(window.__acKhFlush)return;window.__acKhFlush=true;function a(){document.querySelectorAll('.ac-kh.ac-cosmos--flush').forEach(function(s){var w=s.closest('.shopify-section')||s.parentElement;if(w){w.style.marginTop='0px';w.style.marginBottom='0px';var x=w.previousElementSibling,y=w.nextElementSibling;if(x)x.style.marginBottom='0px';if(y)y.style.marginTop='0px'}var n=s.parentElement;while(n&&n!==document.body){var c=getComputedStyle(n);if(parseFloat(c.paddingTop)||parseFloat(c.paddingBottom)||parseFloat(c.marginTop)||parseFloat(c.marginBottom)){n.style.paddingTop='0px';n.style.paddingBottom='0px';n.style.marginTop='0px';n.style.marginBottom='0px'}n=n.parentElement}s.style.marginLeft='';s.style.marginRight='';s.style.width='auto';s.style.maxWidth='none';var r=s.getBoundingClientRect(),v=document.documentElement.clientWidth,l=r.left,q=v-r.right;if(l>0.5)s.style.marginLeft=-l+'px';if(q>0.5)s.style.marginRight=-q+'px'})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',a)}else{a()}window.addEventListener('load',a);document.addEventListener('shopify:section:load',a);var t;window.addEventListener('resize',function(){clearTimeout(t);t=setTimeout(a,120)})})();

/* ===== ac-keuzehulp-collecties ===== */
(function () {
/* Garantie op twee regels: nowrap plus deze fitter, die de lettergrootte
   verlaagt tot de breedste regel in de kolom past (bouwafspraak 14). */
function pas(sec) {
var kop = sec.querySelector('.ackc__kop');
if (!kop) return;
var vak = kop.parentElement;
var regels = Array.prototype.slice.call(kop.querySelectorAll('.ackc__regel > span'));
if (!regels.length) return;
kop.style.fontSize = '';
var maat = parseFloat(getComputedStyle(kop).fontSize) || 26;
for (var i = 0; i < 40; i++) {
var ruimte = vak.clientWidth, breedst = 0;
regels.forEach(function (s) { if (s.scrollWidth > breedst) breedst = s.scrollWidth; });
if (!ruimte || breedst <= ruimte || maat <= 14) break;
maat = Math.max(14, maat - Math.max(1, Math.round(maat * 0.04)));
kop.style.fontSize = maat + 'px';
}
}
function start() {
document.querySelectorAll('[data-ackc]').forEach(function (sec) {
pas(sec);
if (sec.dataset.ackcKlaar === '1') return;
sec.dataset.ackcKlaar = '1';
var vak = sec.querySelector('.ackc__inner');
if (window.ResizeObserver && vak) {
var b = 0, tm = null;
new ResizeObserver(function (e) {
var nb = Math.round(e[0].contentRect.width);
if (nb === b || !nb) return;
b = nb; clearTimeout(tm);
tm = setTimeout(function () { pas(sec); }, 90);
}).observe(vak);
} else {
window.addEventListener('resize', function () { setTimeout(function () { pas(sec); }, 140); });
}
if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { pas(sec); });
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
window.addEventListener('load', start);
document.addEventListener('shopify:section:load', start);
})();

/* ===== ac-keuzehulp-showroom ===== */
(function () {
/* Garantie op twee regels: nowrap plus deze fitter, die de lettergrootte
   verlaagt tot de breedste regel in de kolom past. */
function pas(sec) {
var kop = sec.querySelector('.acsw__kop');
if (!kop) return;
var vak = kop.parentElement;
var regels = Array.prototype.slice.call(kop.querySelectorAll('.acsw__regel > span'));
if (!regels.length) return;
kop.style.fontSize = '';
var maat = parseFloat(getComputedStyle(kop).fontSize) || 26;
for (var i = 0; i < 40; i++) {
var ruimte = vak.clientWidth, breedst = 0;
regels.forEach(function (s) { if (s.scrollWidth > breedst) breedst = s.scrollWidth; });
if (!ruimte || breedst <= ruimte || maat <= 14) break;
maat = Math.max(14, maat - Math.max(1, Math.round(maat * 0.04)));
kop.style.fontSize = maat + 'px';
}
}
function start() {
document.querySelectorAll('[data-acsw]').forEach(function (sec) {
pas(sec);
if (sec.dataset.acswKlaar === '1') return;
sec.dataset.acswKlaar = '1';
var vak = sec.querySelector('.acsw__inner');
if (window.ResizeObserver && vak) {
var b = 0, tm = null;
new ResizeObserver(function (e) {
var nb = Math.round(e[0].contentRect.width);
if (nb === b || !nb) return;
b = nb; clearTimeout(tm);
tm = setTimeout(function () { pas(sec); }, 90);
}).observe(vak);
} else {
window.addEventListener('resize', function () { setTimeout(function () { pas(sec); }, 140); });
}
if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { pas(sec); });
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
window.addEventListener('load', start);
document.addEventListener('shopify:section:load', start);
})();

(function(){function plak(){document.querySelectorAll('.acsw').forEach(function(k){var w=k.closest('.shopify-section')||k.parentElement;if(!w)return;w.style.marginTop='0px';w.style.marginBottom='0px';var a=w.previousElementSibling,b=w.nextElementSibling;if(a)a.style.marginBottom='0px';if(b)b.style.marginTop='0px'})}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',plak)}else{plak()}window.addEventListener('load',plak)})();

/* ===== ac-keuzehulp-intro ===== */
(function () {
/* Garantie op twee regels: nowrap plus deze fitter, die de lettergrootte
   verlaagt tot de breedste regel in de kolom past. */
function pas(sec) {
var kop = sec.querySelector('.acvi__kop');
if (!kop) return;
var vak = kop.parentElement;
var regels = Array.prototype.slice.call(kop.querySelectorAll('.acvi__regel > span'));
if (!regels.length) return;
kop.style.fontSize = '';
var maat = parseFloat(getComputedStyle(kop).fontSize) || 26;
for (var i = 0; i < 40; i++) {
var ruimte = vak.clientWidth, breedst = 0;
regels.forEach(function (s) { if (s.scrollWidth > breedst) breedst = s.scrollWidth; });
if (!ruimte || breedst <= ruimte || maat <= 14) break;
maat = Math.max(14, maat - Math.max(1, Math.round(maat * 0.04)));
kop.style.fontSize = maat + 'px';
}
}
function start() {
document.querySelectorAll('[data-acvi]').forEach(function (sec) {
pas(sec);
if (sec.dataset.acviKlaar === '1') return;
sec.dataset.acviKlaar = '1';
var vak = sec.querySelector('.acvi__inner');
if (window.ResizeObserver && vak) {
var b = 0, tm = null;
new ResizeObserver(function (e) {
var nb = Math.round(e[0].contentRect.width);
if (nb === b || !nb) return;
b = nb; clearTimeout(tm);
tm = setTimeout(function () { pas(sec); }, 90);
}).observe(vak);
} else {
window.addEventListener('resize', function () { setTimeout(function () { pas(sec); }, 140); });
}
if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { pas(sec); });
/* De knop wijst naar de vergelijker op dezelfde pagina. Staat die er niet,
   dan blijft de gewone link staan (bouwafspraak 8). */
var knop = sec.querySelector('.acvi__knop');
if (knop) {
knop.addEventListener('click', function (e) {
var doel = document.getElementById('ac-vergelijker') || document.querySelector('[data-ac-vg]');
if (!doel) return;
e.preventDefault();
var y = doel.getBoundingClientRect().top + window.pageYOffset - 92;
var zacht = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: zacht ? 'smooth' : 'auto' });
});
}
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
window.addEventListener('load', start);
document.addEventListener('shopify:section:load', start);
})();

/* ===== ac-keuzehulp-cta ===== */

/* ===== ac-zakelijk-partner ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var kop = sec.querySelector('[data-ac-zp-kop]');
var binnen = sec.querySelector('.ac-cosmos__inner');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-zp__kern') || k.classList.contains('ac-zp__semi'))){ k.setAttribute('data-accent','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-zp__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-zp__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-zp]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* Flush-helper. Shopify zet een Custom Liquid-sectie in een container die
   smaller is dan het scherm, met eigen ruimte eromheen. Dit meet het
   verschil op en trekt de sectie door tot de schermrand. Draait één keer
   per pagina, ook voor andere secties met dezelfde klasse. */

/* ===== ac-zakelijk-mogelijkheden ===== */
(function () {
  function init() {
    var sec = document.getElementById('ac-b2b-options');
    if (!sec) return;
    var select = document.getElementById('ac-b2b-interest');
    sec.querySelectorAll('.ac-b2b__pick').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-interest');
        if (!select || !v) return;
        Array.prototype.forEach.call(select.options, function (o) { if (o.value === v) { select.value = v; } });
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

(function(){
var sec = document.getElementById('ac-b2b-options');
if(!sec || sec.dataset.acKopKlaar) return;
sec.dataset.acKopKlaar = '1';
var kop = sec.querySelector('[data-ac-zb-kop]');
var binnen = sec.querySelector('.ac-cosmos__inner');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-zb__kern') || k.classList.contains('ac-zb__semi'))){ k.setAttribute('data-accent','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-zb__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-zb__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
})();

/* Flush-helper. Shopify zet een Custom Liquid-sectie in een container die
   smaller is dan het scherm, met eigen ruimte eromheen. Dit meet het
   verschil op en trekt de sectie door tot de schermrand. Draait één keer
   per pagina, ook voor andere secties met dezelfde klasse. */

/* ===== ac-zakelijk-kopen ===== */
/* Binnenkomen zodra de sectie in beeld is, en de inhoudsopgave die
   meeloopt met het blok dat in beeld staat. Bij prefers-reduced-motion
   staat alles direct (5.6). */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
  var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!stil && 'IntersectionObserver' in window) {
    sec.classList.add('is-js');
    var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) { sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.08 });
    io.observe(sec);
    setTimeout(function () { sec.classList.add('speelt'); }, 1500);
  }
  var links = Array.prototype.slice.call(sec.querySelectorAll('[data-aczs-nav]'));
  var blokken = Array.prototype.slice.call(sec.querySelectorAll('[data-aczs-blok]'));
  function zet(id) { links.forEach(function (l) { l.classList.toggle('is-actief', l.getAttribute('data-aczs-nav') === id); }); }
  if ('IntersectionObserver' in window && blokken.length) {
    var actief = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { zet(e.target.getAttribute('data-aczs-blok')); } });
    }, { rootMargin: '-35% 0px -55% 0px', threshold: 0 });
    blokken.forEach(function (b) { actief.observe(b); });
  }
  /* Zachte sprong met correctie voor een vaste header. */
  function headerhoogte() {
    var h = 0;
    Array.prototype.slice.call(document.body.querySelectorAll('header,[class*="header"]')).forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.top > 4 || r.height < 20 || r.height > 220) return;
      if (r.height > h) h = r.height;
    });
    return h;
  }
  links.forEach(function (l) {
    l.addEventListener('click', function (e) {
      var doel = document.getElementById(l.getAttribute('data-aczs-nav'));
      if (!doel) return;
      e.preventDefault();
      var y = doel.getBoundingClientRect().top + window.pageYOffset - headerhoogte() - 16;
      window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: stil ? 'auto' : 'smooth' });
      if (history.replaceState) { history.replaceState(null, '', '#' + l.getAttribute('data-aczs-nav')); }
    });
  });
}
function init(){ document.querySelectorAll('[data-aczs]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* Flush-helper met een eigen vlag en een eigen klasse: zet de ruimte van
   de thema-wrapper op nul en trekt de sectie door tot de rand. */
(function () {
  if (window.__acZsFlush) return;
  window.__acZsFlush = true;
  function apply() {
    document.querySelectorAll('.aczs--flush').forEach(function (sec) {
      var node = sec.parentElement;
      while (node && node !== document.body) {
        var cs = getComputedStyle(node);
        if (parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) || parseFloat(cs.marginTop) || parseFloat(cs.marginBottom)) {
          node.style.paddingTop = '0px'; node.style.paddingBottom = '0px';
          node.style.marginTop = '0px'; node.style.marginBottom = '0px';
        }
        node = node.parentElement;
      }
      sec.style.marginLeft = ''; sec.style.marginRight = '';
      sec.style.width = 'auto'; sec.style.maxWidth = 'none';
      var rect = sec.getBoundingClientRect();
      var docWidth = document.documentElement.clientWidth;
      var left = rect.left, right = docWidth - rect.right;
      if (left > 0.5) sec.style.marginLeft = (-left) + 'px';
      if (right > 0.5) sec.style.marginRight = (-right) + 'px';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  window.addEventListener('load', apply);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 120); });
})();

/* ===== ac-zakelijk-contact ===== */
/* De cijfers tellen omhoog zodra de sectie in beeld komt, één keer.
   Zonder JavaScript, zonder IntersectionObserver en bij
   prefers-reduced-motion staan de eindgetallen er gewoon (§5.6): ze staan
   al in de HTML, het script verlaagt ze alleen tijdelijk. Een bezoeker
   ziet dus nooit een leeg vak. */
(function () {
  var init = function () {
    document.querySelectorAll('[data-accf]:not([data-accf-klaar])').forEach(function (sec) {
      sec.setAttribute('data-accf-klaar', '1');
      var stil = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (stil || !('IntersectionObserver' in window)) { return; }
      sec.classList.add('accf-js');
      var cijfers = Array.prototype.slice.call(sec.querySelectorAll('[data-accf-naar]'));
      cijfers.forEach(function (el) {
        var doel = parseInt(el.getAttribute('data-accf-naar'), 10);
        if (!isNaN(doel)) { el.textContent = '0'; }
      });
      var tel = function () {
        cijfers.forEach(function (el) {
          var doel = parseInt(el.getAttribute('data-accf-naar'), 10);
          if (isNaN(doel)) { return; }
          var duur = 1100, start = null;
          var stap = function (nu) {
            if (start === null) { start = nu; }
            var d = Math.min((nu - start) / duur, 1);
            var e = 1 - Math.pow(1 - d, 3);
            el.textContent = Math.round(doel * e);
            if (d < 1) { requestAnimationFrame(stap); }
          };
          requestAnimationFrame(stap);
        });
      };
      var gedaan = false;
      var speel = function () {
        if (gedaan) { return; }
        gedaan = true;
        sec.classList.add('is-in');
        setTimeout(tel, 180);
      };
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { speel(); io.disconnect(); }
      }, { threshold: 0 });
      io.observe(sec);
      /* Vangnet: staat de sectie na anderhalve seconde wel in beeld maar is
         er niets gebeurd, dan zetten wij hem alsnog aan. Een gemiste
         animatie is niet erg, een sectie met nullen erin wel. */
      setTimeout(function () {
        var r = sec.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { speel(); }
      }, 1500);
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* Flush-helper met een EIGEN naam. Shopify zet een Custom Liquid-sectie in
   een container die smaller is dan het scherm, met eigen ruimte eromheen.
   Bij een witte sectie zie je dat niet, bij een ruimtezwarte krijg je
   witte stroken links, rechts, boven en onder.
   LET OP, DIT GING EERDER MIS: dit blok heette net als in de andere
   secties __acCosmosFlush en keek alleen naar .ac-cosmos--flush. Staat er
   hoger op de pagina al zo'n sectie, dan zet die de vlag op true, stopt
   dit blok meteen en wordt deze sectie nooit doorgetrokken. Vandaar een
   eigen vlagnaam en een eigen selector: de twee helpers lopen nu naast
   elkaar zonder elkaar uit te zetten. */
(function () {
  if (window.__acAccfFlush) return;
  window.__acAccfFlush = true;
  function apply() {
    document.querySelectorAll('.accf--flush').forEach(function (sec) {
      var node = sec.parentElement;
      while (node && node !== document.body) {
        var cs = getComputedStyle(node);
        if (parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) ||
            parseFloat(cs.marginTop)  || parseFloat(cs.marginBottom)) {
          node.style.paddingTop = '0px'; node.style.paddingBottom = '0px';
          node.style.marginTop = '0px';  node.style.marginBottom = '0px';
        }
        node = node.parentElement;
      }
      sec.style.marginLeft = ''; sec.style.marginRight = '';
      sec.style.width = 'auto'; sec.style.maxWidth = 'none';
      var rect = sec.getBoundingClientRect();
      var docWidth = document.documentElement.clientWidth;
      var left = rect.left, right = docWidth - rect.right;
      if (left  > 0.5) sec.style.marginLeft  = (-left)  + 'px';
      if (right > 0.5) sec.style.marginRight = (-right) + 'px';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  window.addEventListener('load', apply);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 120); });
})();

/* ===== ac-zakelijk-hero ===== */
(function () {
function initAcB2BVideoHero() {
var hero = document.querySelector('[data-ac-b2b-video-hero-zk]');
if (!hero) return;
if (hero.getAttribute('data-ac-b2b-initialized-zk') === 'true') return;
hero.setAttribute('data-ac-b2b-initialized-zk', 'true');
var section = hero.closest('.shopify-section');
var ticking = false;
var headerMarked = false;
var menuObserver = null;
var reviewMutationObserver = null;
var reviewResizeObserver = null;
var reviewAttributeObserver = null;
var observedReviewBar = null;
var reviewSyncQueued = false;
if (section) { section.classList.add('ac-b2b-video-hero-section'); }
document.body.classList.remove('ac-v12-header-transparent-zk','ac-v12-header-normal','ac-v11-header-transparent','ac-v11-header-normal','ac-v10-header-transparent','ac-v10-header-normal','ac-v9-header-transparent','ac-v9-header-normal','ac-v8-transparent-header','ac-v8-scrolled-header','ac-v7-desktop-transparent-header','ac-v7-desktop-scrolled-header','ac-video-final-transparent-header','ac-video-final-scrolled-header','ac-video-v3-at-top','ac-video-v3-scrolled','ac-video-v4-at-top','ac-video-v4-scrolled','ac-v4-hero-active','ac-v4-hero-scrolled','ac-video-v5-at-top','ac-video-v5-scrolled','ac-video-v6-at-top','ac-video-v6-scrolled');
function findHeader() {
return (document.querySelector('x-header') || document.querySelector('sticky-header') || document.querySelector('#shopify-section-header header') || document.querySelector('[id*="__header"] header') || document.querySelector('header.header') || document.querySelector('header[role="banner"]') || document.querySelector('header'));
}
function isVisibleReviewCandidate(el) {
if (!el || !el.getBoundingClientRect) return false;
var rect = el.getBoundingClientRect();
var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
var style = window.getComputedStyle ? window.getComputedStyle(el) : null;
if (style) {
if (style.display === 'none' || style.visibility === 'hidden') return false;
if (parseFloat(style.opacity || '1') <= 0.05) return false;
}
if (rect.width < viewportWidth * 0.55) return false;
if (rect.height < 20) return false;
if (rect.top < -12 || rect.top > 150) return false;
if (rect.bottom <= 20 || rect.bottom > 230) return false;
if (el.closest && (el.closest('.ac-b2b-header-shell') || el.closest('.ac-b2b-header-target') || el.closest('.ac-b2b-video-hero') || el.closest('#acd-drawer') || el.closest('#acd-overlay'))) { return false; }
return true;
}
function looksLikeReviewElement(el) {
if (!el) return false;
var text = (el.innerText || el.textContent || '').toLowerCase();
var meta = ((typeof el.className === 'string' ? el.className : '') + ' ' + (el.id || '') + ' ' + (el.getAttribute ? (el.getAttribute('src') || '') : '') + ' ' + (el.getAttribute ? (el.getAttribute('title') || '') : '') + ' ' + (el.getAttribute ? (el.getAttribute('aria-label') || '') : '')).toLowerCase();
return (text.indexOf('webwinkelkeur') !== -1 || text.indexOf('reviews') !== -1 || text.indexOf('review') !== -1 || text.indexOf('9,9') !== -1 || meta.indexOf('webwinkel') !== -1 || meta.indexOf('keur') !== -1 || meta.indexOf('review') !== -1);
}
function findReviewBarInfo() {
if (!window.matchMedia('(max-width: 749px)').matches) { return { offset: 0, element: null }; }
var candidates = [];
var seen = new Set();
var selectors = ['[class*="webwinkel" i]','[id*="webwinkel" i]','[class*="review" i]','[id*="review" i]','[aria-label*="review" i]','iframe[src*="webwinkel" i]','iframe[title*="review" i]'];
function addCandidate(el) { if (!el || seen.has(el)) return; seen.add(el); candidates.push(el); }
selectors.forEach(function (selector) { try { document.querySelectorAll(selector).forEach(addCandidate); } catch (error) {} });
var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
var xs = [12, Math.round(viewportWidth / 2), Math.max(12, viewportWidth - 12)];
var ys = [4, 20, 40, 64, 88, 112, 136, 160, 190];
xs.forEach(function (x) {
ys.forEach(function (y) {
var el = document.elementFromPoint(x, y);
var depth = 0;
while (el && el !== document.body && depth < 8) { addCandidate(el); el = el.parentElement; depth++; }
});
});
var bestOffset = 0;
var bestElement = null;
candidates.forEach(function (el) {
if (!looksLikeReviewElement(el)) return;
if (!isVisibleReviewCandidate(el)) return;
var rect = el.getBoundingClientRect();
var bottom = Math.round(rect.bottom);
if (bottom > bestOffset) { bestOffset = bottom; bestElement = el; }
});
if (bestOffset < 20 || bestOffset > 230) { return { offset: 0, element: null }; }
return { offset: bestOffset, element: bestElement };
}
function observeReviewBarElement(element) {
if (observedReviewBar === element) return;
observedReviewBar = element;
if (reviewResizeObserver) { reviewResizeObserver.disconnect(); reviewResizeObserver = null; }
if (reviewAttributeObserver) { reviewAttributeObserver.disconnect(); reviewAttributeObserver = null; }
if (!element) return;
if (window.ResizeObserver) { reviewResizeObserver = new ResizeObserver(function () { requestReviewBarSync(); }); reviewResizeObserver.observe(element); }
if (window.MutationObserver) { reviewAttributeObserver = new MutationObserver(function () { requestReviewBarSync(); }); reviewAttributeObserver.observe(element, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] }); }
}
function syncReviewBarOffset() {
var info = findReviewBarInfo();
document.documentElement.style.setProperty('--ac-b2b-header-top', info.offset + 'px');
observeReviewBarElement(info.element);
return info.offset;
}
function requestReviewBarSync() {
if (reviewSyncQueued) return;
reviewSyncQueued = true;
requestAnimationFrame(function () { reviewSyncQueued = false; syncReviewBarOffset(); updateHeaderState(); });
}
function observeReviewBarChanges() {
if (reviewMutationObserver || !window.MutationObserver || !document.body) return;
reviewMutationObserver = new MutationObserver(function () { requestReviewBarSync(); });
reviewMutationObserver.observe(document.body, { childList: true, subtree: true });
}
function markHeader(recalculateOffset) {
var header = findHeader();
if (!header) return null;
var shell = header.closest('.shopify-section-group-header-group') || header.closest('.section-header') || header.closest('[id^="shopify-section-sections--"]') || header.closest('[id^="shopify-section-header"]') || header.closest('.shopify-section') || header.parentElement;
if (shell) { shell.classList.add('ac-b2b-header-shell'); }
header.classList.add('ac-b2b-header-target');
var headerInner = header.matches('.header') ? header : header.querySelector('.header');
if (headerInner) { headerInner.classList.add('ac-b2b-header-target'); }
var headerWrapper = header.matches('.header-wrapper') ? header : header.querySelector('.header-wrapper') || header.closest('.header-wrapper');
if (headerWrapper) { headerWrapper.classList.add('ac-b2b-header-target'); }
var measureTarget = headerInner || headerWrapper || header;
var height = Math.round(measureTarget.getBoundingClientRect().height || 72);
if (!height || height < 40) { height = 72; }
document.documentElement.style.setProperty('--ac-b2b-header-height', height + 'px');
if (recalculateOffset) { syncReviewBarOffset(); }
headerMarked = true;
return header;
}
function headerHasOpenPanel(header) {
if (!header) return false;
return !!(header.querySelector('details[open]') || header.querySelector('[aria-expanded="true"]') || header.querySelector('.mega-menu.is-open') || header.querySelector('.mega-menu.open') || header.querySelector('.menu-drawer.active') || header.querySelector('.menu-drawer.is-open'));
}
function syncOpenMenuState() {
var header = findHeader();
var hasOpenPanel = headerHasOpenPanel(header);
document.body.classList.toggle('ac-b2b-menu-open', hasOpenPanel);
}
function observeHeaderMenus() {
if (menuObserver) return;
var header = findHeader();
if (!header || !window.MutationObserver) return;
menuObserver = new MutationObserver(function () { syncOpenMenuState(); });
menuObserver.observe(header, { subtree: true, attributes: true, attributeFilter: ['open', 'aria-expanded', 'class', 'hidden', 'style'] });
}
function updateHeaderState() {
if (!headerMarked) { markHeader(true); }
var heroRect = hero.getBoundingClientRect();
var headerHeightRaw = getComputedStyle(document.documentElement).getPropertyValue('--ac-b2b-header-height');
var headerHeight = parseInt(headerHeightRaw, 10) || 72;
var stillOverHero = heroRect.bottom > headerHeight + 8;
if (stillOverHero) { document.body.classList.add('ac-b2b-header-transparent'); document.body.classList.remove('ac-b2b-header-normal'); }
else { document.body.classList.remove('ac-b2b-header-transparent'); document.body.classList.add('ac-b2b-header-normal'); }
}
function cleanBottomSpacing() {
if (!section) return;
section.style.setProperty('margin-bottom', '0', 'important');
section.style.setProperty('padding-bottom', '0', 'important');
section.style.setProperty('background', '#ffffff', 'important');
section.style.setProperty('background-color', '#ffffff', 'important');
section.style.setProperty('line-height', '0', 'important');
section.style.setProperty('font-size', '0', 'important');
var nextSection = section.nextElementSibling;
if (nextSection) {
nextSection.style.setProperty('margin-top', '0', 'important');
nextSection.style.setProperty('background', '#ffffff', 'important');
nextSection.style.setProperty('background-color', '#ffffff', 'important');
}
}
function run(recalculateOffset) {
markHeader(!!recalculateOffset);
updateHeaderState();
syncOpenMenuState();
observeHeaderMenus();
observeReviewBarChanges();
cleanBottomSpacing();
}
function requestRun() {
if (ticking) return;
ticking = true;
requestAnimationFrame(function () { updateHeaderState(); syncOpenMenuState(); cleanBottomSpacing(); ticking = false; });
}
run(true);
requestAnimationFrame(function () { run(true); });
setTimeout(function () { run(true); }, 300);
setTimeout(function () { run(true); }, 1200);
setTimeout(function () { run(true); }, 2500);
setTimeout(function () { run(true); }, 5000);
window.addEventListener('scroll', requestRun, { passive: true });
window.addEventListener('resize', function () { run(true); });
window.addEventListener('pageshow', function () { run(true); });
document.addEventListener('toggle', function (event) { if (event.target && event.target.matches && event.target.matches('details')) { syncOpenMenuState(); } }, true);
document.addEventListener('click', function () {
setTimeout(function () { syncOpenMenuState(); run(true); }, 40);
setTimeout(function () { syncOpenMenuState(); run(true); }, 160);
setTimeout(function () { syncOpenMenuState(); run(true); }, 600);
});
}
initAcB2BVideoHero();
document.addEventListener('DOMContentLoaded', initAcB2BVideoHero);
document.addEventListener('shopify:section:load', initAcB2BVideoHero);
})();

/* ===== ac-cam-videoheader ===== */
(function () {
    function initAcVideoHeroV12() {
      var hero = document.querySelector('[data-ac-video-hero-v12-ca]');
      if (!hero) return;

      if (hero.getAttribute('data-ac-v12-initialized-ca') === 'true') return;
      hero.setAttribute('data-ac-v12-initialized-ca', 'true');

      var section = hero.closest('.shopify-section');
      var ticking = false;
      var headerMarked = false;
      var menuObserver = null;
      var reviewMutationObserver = null;
      var reviewResizeObserver = null;
      var reviewAttributeObserver = null;
      var observedReviewBar = null;
      var reviewSyncQueued = false;

      if (section) {
        section.classList.add('ac-video-hero-v12-section-ca');
      }

      document.body.classList.remove(
        'ac-v11-header-transparent',
        'ac-v11-header-normal',
        'ac-v10-header-transparent',
        'ac-v10-header-normal',
        'ac-v9-header-transparent',
        'ac-v9-header-normal',
        'ac-v8-transparent-header',
        'ac-v8-scrolled-header',
        'ac-v7-desktop-transparent-header',
        'ac-v7-desktop-scrolled-header',
        'ac-video-final-transparent-header',
        'ac-video-final-scrolled-header',
        'ac-video-v3-at-top',
        'ac-video-v3-scrolled',
        'ac-video-v4-at-top',
        'ac-video-v4-scrolled',
        'ac-v4-hero-active',
        'ac-v4-hero-scrolled',
        'ac-video-v5-at-top',
        'ac-video-v5-scrolled',
        'ac-video-v6-at-top',
        'ac-video-v6-scrolled'
      );

      function findHeader() {
        return (
          document.querySelector('x-header') ||
          document.querySelector('sticky-header') ||
          document.querySelector('#shopify-section-header header') ||
          document.querySelector('[id*="__header"] header') ||
          document.querySelector('header.header') ||
          document.querySelector('header[role="banner"]') ||
          document.querySelector('header')
        );
      }

      function isVisibleReviewCandidate(el) {
        if (!el || !el.getBoundingClientRect) return false;

        var rect = el.getBoundingClientRect();
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        var style = window.getComputedStyle ? window.getComputedStyle(el) : null;

        if (style) {
          if (style.display === 'none' || style.visibility === 'hidden') return false;
          if (parseFloat(style.opacity || '1') <= 0.05) return false;
        }

        if (rect.width < viewportWidth * 0.55) return false;
        if (rect.height < 20) return false;
        if (rect.top < -12 || rect.top > 150) return false;
        if (rect.bottom <= 20 || rect.bottom > 230) return false;

        if (
          el.closest &&
          (
            el.closest('.ac-v12-header-shell-ca') ||
            el.closest('.ac-v12-header-target-ca') ||
            el.closest('.ac-video-hero-v12-ca') ||
            el.closest('#acd-drawer') ||
            el.closest('#acd-overlay')
          )
        ) {
          return false;
        }

        return true;
      }

      function looksLikeReviewElement(el) {
        if (!el) return false;

        var text = (el.innerText || el.textContent || '').toLowerCase();
        var meta = (
          (typeof el.className === 'string' ? el.className : '') + ' ' +
          (el.id || '') + ' ' +
          (el.getAttribute ? (el.getAttribute('src') || '') : '') + ' ' +
          (el.getAttribute ? (el.getAttribute('title') || '') : '') + ' ' +
          (el.getAttribute ? (el.getAttribute('aria-label') || '') : '')
        ).toLowerCase();

        return (
          text.indexOf('webwinkelkeur') !== -1 ||
          text.indexOf('reviews') !== -1 ||
          text.indexOf('review') !== -1 ||
          text.indexOf('9,9') !== -1 ||
          meta.indexOf('webwinkel') !== -1 ||
          meta.indexOf('keur') !== -1 ||
          meta.indexOf('review') !== -1
        );
      }

      function findReviewBarInfo() {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          return { offset: 0, element: null };
        }

        var candidates = [];
        var seen = new Set();
        var selectors = [
          '[class*="webwinkel" i]',
          '[id*="webwinkel" i]',
          '[class*="review" i]',
          '[id*="review" i]',
          '[aria-label*="review" i]',
          'iframe[src*="webwinkel" i]',
          'iframe[title*="review" i]'
        ];

        function addCandidate(el) {
          if (!el || seen.has(el)) return;
          seen.add(el);
          candidates.push(el);
        }

        selectors.forEach(function (selector) {
          try {
            document.querySelectorAll(selector).forEach(addCandidate);
          } catch (error) {}
        });

        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        var xs = [12, Math.round(viewportWidth / 2), Math.max(12, viewportWidth - 12)];
        var ys = [4, 20, 40, 64, 88, 112, 136, 160, 190];

        xs.forEach(function (x) {
          ys.forEach(function (y) {
            var el = document.elementFromPoint(x, y);
            var depth = 0;

            while (el && el !== document.body && depth < 8) {
              addCandidate(el);
              el = el.parentElement;
              depth++;
            }
          });
        });

        var bestOffset = 0;
        var bestElement = null;

        candidates.forEach(function (el) {
          if (!looksLikeReviewElement(el)) return;
          if (!isVisibleReviewCandidate(el)) return;

          var rect = el.getBoundingClientRect();
          var bottom = Math.round(rect.bottom);

          if (bottom > bestOffset) {
            bestOffset = bottom;
            bestElement = el;
          }
        });

        if (bestOffset < 20 || bestOffset > 230) {
          return { offset: 0, element: null };
        }

        return { offset: bestOffset, element: bestElement };
      }

      function observeReviewBarElement(element) {
        if (observedReviewBar === element) return;

        observedReviewBar = element;

        if (reviewResizeObserver) {
          reviewResizeObserver.disconnect();
          reviewResizeObserver = null;
        }

        if (reviewAttributeObserver) {
          reviewAttributeObserver.disconnect();
          reviewAttributeObserver = null;
        }

        if (!element) return;

        if (window.ResizeObserver) {
          reviewResizeObserver = new ResizeObserver(function () {
            requestReviewBarSync();
          });
          reviewResizeObserver.observe(element);
        }

        if (window.MutationObserver) {
          reviewAttributeObserver = new MutationObserver(function () {
            requestReviewBarSync();
          });
          reviewAttributeObserver.observe(element, {
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
          });
        }
      }

      function syncReviewBarOffset() {
        var info = findReviewBarInfo();
        document.documentElement.style.setProperty('--ac-v12-header-top', info.offset + 'px');
        observeReviewBarElement(info.element);
        return info.offset;
      }

      function requestReviewBarSync() {
        if (reviewSyncQueued) return;
        reviewSyncQueued = true;

        requestAnimationFrame(function () {
          reviewSyncQueued = false;
          syncReviewBarOffset();
          updateHeaderState();
        });
      }

      function observeReviewBarChanges() {
        if (reviewMutationObserver || !window.MutationObserver || !document.body) return;

        reviewMutationObserver = new MutationObserver(function () {
          requestReviewBarSync();
        });

        reviewMutationObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }

      function markHeader(recalculateOffset) {
        var header = findHeader();
        if (!header) return null;

        var shell =
          header.closest('.shopify-section-group-header-group') ||
          header.closest('.section-header') ||
          header.closest('[id^="shopify-section-sections--"]') ||
          header.closest('[id^="shopify-section-header"]') ||
          header.closest('.shopify-section') ||
          header.parentElement;

        if (shell) {
          shell.classList.add('ac-v12-header-shell-ca');
        }

        header.classList.add('ac-v12-header-target-ca');

        var headerInner = header.matches('.header') ? header : header.querySelector('.header');
        if (headerInner) {
          headerInner.classList.add('ac-v12-header-target-ca');
        }

        var headerWrapper =
          header.matches('.header-wrapper') ? header :
          header.querySelector('.header-wrapper') ||
          header.closest('.header-wrapper');

        if (headerWrapper) {
          headerWrapper.classList.add('ac-v12-header-target-ca');
        }

        var measureTarget = headerInner || headerWrapper || header;
        var height = Math.round(measureTarget.getBoundingClientRect().height || 72);

        if (!height || height < 40) {
          height = 72;
        }

        document.documentElement.style.setProperty('--ac-v12-header-height', height + 'px');

        if (recalculateOffset) {
          syncReviewBarOffset();
        }

        headerMarked = true;
        return header;
      }

      function headerHasOpenPanel(header) {
        if (!header) return false;

        return !!(
          header.querySelector('details[open]') ||
          header.querySelector('[aria-expanded="true"]') ||
          header.querySelector('.mega-menu.is-open') ||
          header.querySelector('.mega-menu.open') ||
          header.querySelector('.menu-drawer.active') ||
          header.querySelector('.menu-drawer.is-open')
        );
      }

      function syncOpenMenuState() {
        var header = findHeader();
        var hasOpenPanel = headerHasOpenPanel(header);
        document.body.classList.toggle('ac-v12-menu-open', hasOpenPanel);
      }

      function observeHeaderMenus() {
        if (menuObserver) return;

        var header = findHeader();
        if (!header || !window.MutationObserver) return;

        menuObserver = new MutationObserver(function () {
          syncOpenMenuState();
        });

        menuObserver.observe(header, {
          subtree: true,
          attributes: true,
          attributeFilter: ['open', 'aria-expanded', 'class', 'hidden', 'style']
        });
      }

      function updateHeaderState() {
        if (!headerMarked) {
          markHeader(true);
        }

        var heroRect = hero.getBoundingClientRect();
        var headerHeightRaw = getComputedStyle(document.documentElement).getPropertyValue('--ac-v12-header-height');
        var headerHeight = parseInt(headerHeightRaw, 10) || 72;
        var stillOverHero = heroRect.bottom > headerHeight + 8;

        if (stillOverHero) {
          document.body.classList.add('ac-v12-header-transparent-ca');
          document.body.classList.remove('ac-v12-header-normal-ca');
        } else {
          document.body.classList.remove('ac-v12-header-transparent-ca');
          document.body.classList.add('ac-v12-header-normal-ca');
        }
      }

      function cleanBottomSpacing() {
        if (!section) return;

        section.style.setProperty('margin-bottom', '0', 'important');
        section.style.setProperty('padding-bottom', '0', 'important');
        section.style.setProperty('background', '#ffffff', 'important');
        section.style.setProperty('background-color', '#ffffff', 'important');
        section.style.setProperty('line-height', '0', 'important');
        section.style.setProperty('font-size', '0', 'important');

        var nextSection = section.nextElementSibling;

        if (nextSection) {
          nextSection.style.setProperty('margin-top', '0', 'important');
          nextSection.style.setProperty('background', '#ffffff', 'important');
          nextSection.style.setProperty('background-color', '#ffffff', 'important');
        }
      }

      function run(recalculateOffset) {
        markHeader(!!recalculateOffset);
        updateHeaderState();
        syncOpenMenuState();
        observeHeaderMenus();
        observeReviewBarChanges();
        cleanBottomSpacing();
      }

      function requestRun() {
        if (ticking) return;

        ticking = true;

        requestAnimationFrame(function () {
          updateHeaderState();
          syncOpenMenuState();
          cleanBottomSpacing();
          ticking = false;
        });
      }

      run(true);

      requestAnimationFrame(function () {
        run(true);
      });

      setTimeout(function () {
        run(true);
      }, 300);

      setTimeout(function () {
        run(true);
      }, 1200);

      setTimeout(function () {
        run(true);
      }, 2500);

      setTimeout(function () {
        run(true);
      }, 5000);

      window.addEventListener('scroll', requestRun, { passive: true });

      window.addEventListener('resize', function () {
        run(true);
      });

      window.addEventListener('pageshow', function () {
        run(true);
      });

      document.addEventListener('toggle', function (event) {
        if (event.target && event.target.matches && event.target.matches('details')) {
          syncOpenMenuState();
        }
      }, true);

      document.addEventListener('click', function () {
        setTimeout(function () {
          syncOpenMenuState();
          run(true);
        }, 40);

        setTimeout(function () {
          syncOpenMenuState();
          run(true);
        }, 160);

        setTimeout(function () {
          syncOpenMenuState();
          run(true);
        }, 600);
      });
    }

    initAcVideoHeroV12();

    document.addEventListener('DOMContentLoaded', initAcVideoHeroV12);
    document.addEventListener('shopify:section:load', initAcVideoHeroV12);
  })();

/* ===== ac-cam-waarom ===== */
/* Opkomst zodra de sectie in beeld komt. Zonder waarnemer, en als het
   vangnet afgaat terwijl de sectie in beeld staat, staat alles gewoon aan. */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acRevealReady) return;
sec.dataset.acRevealReady = '1';
function show(){ sec.classList.add('is-visible'); }
if(!('IntersectionObserver' in window)){ show(); return; }
var io = new IntersectionObserver(function(entries){ entries.forEach(function(entry){ if(entry.isIntersecting){ show(); io.disconnect(); } }); }, { threshold: .12 });
io.observe(sec);
function inBeeld(){ var b = sec.getBoundingClientRect(); return b.top < window.innerHeight * 0.92 && b.bottom > 0; }
setTimeout(function(){ if(sec.classList.contains('is-visible')) return; if(inBeeld()){ show(); io.disconnect(); return; } var op = function(){ if(inBeeld()){ show(); io.disconnect(); window.removeEventListener('scroll', op); } }; window.addEventListener('scroll', op, { passive: true }); }, 1500);
}
function init(){ document.querySelectorAll('[data-ac-brand-statement]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* Brochure: eerst als echte download via fetch, en als de CDN dat blokkeert
   opent de PDF in een nieuw tabblad. */
(function(){
function init(){
document.querySelectorAll('[data-ac-brochure-download]').forEach(function(button){
if(button.dataset.acDownloadInitialized === 'true') return;
button.dataset.acDownloadInitialized = 'true';
button.addEventListener('click', async function(event){
if(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
event.preventDefault();
var downloadUrl = button.dataset.downloadUrl || button.getAttribute('href');
var downloadName = button.dataset.downloadName || 'AlienComfort_product_Brochure_2026_5.pdf';
var label = button.querySelector('[data-ac-download-label]');
var originalLabel = label ? label.textContent.trim() : 'Download onze 2026 brochure';
var loadingLabel = button.dataset.loadingLabel || 'Brochure downloaden...';
button.classList.add('is-loading');
button.setAttribute('aria-busy', 'true');
if(label){ label.textContent = loadingLabel; }
try {
var response = await fetch(downloadUrl, { method: 'GET', mode: 'cors', cache: 'no-store' });
if(!response.ok){ throw new Error('Brochure kon niet worden geladen.'); }
var fileBlob = await response.blob();
if(!fileBlob || fileBlob.size === 0){ throw new Error('Leeg brochurebestand ontvangen.'); }
var blobUrl = window.URL.createObjectURL(fileBlob);
var downloadLink = document.createElement('a');
downloadLink.href = blobUrl; downloadLink.download = downloadName; downloadLink.style.display = 'none';
document.body.appendChild(downloadLink); downloadLink.click(); downloadLink.remove();
window.setTimeout(function(){ window.URL.revokeObjectURL(blobUrl); }, 5000);
} catch(error) {
var fallbackLink = document.createElement('a');
fallbackLink.href = downloadUrl; fallbackLink.target = '_blank'; fallbackLink.rel = 'noopener'; fallbackLink.style.display = 'none';
document.body.appendChild(fallbackLink); fallbackLink.click(); fallbackLink.remove();
} finally {
window.setTimeout(function(){ button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); if(label){ label.textContent = originalLabel; } }, 600);
}
});
});
}
if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-cam-navigatie ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
/* De sectie zit boven aan de collectiepagina; het thema zet daar vaak nog
   ruimte omheen. Weghalen, anders zweeft de strip los van de header. */
var n = sec.parentElement;
while(n && n !== document.body){
var cs = getComputedStyle(n);
if(parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) || parseFloat(cs.marginTop) || parseFloat(cs.marginBottom)){
n.style.paddingTop = '0px'; n.style.paddingBottom = '0px';
n.style.marginTop = '0px'; n.style.marginBottom = '0px';
}
n = n.parentElement;
}
Array.prototype.slice.call(sec.querySelectorAll('[data-ac-cn-spring-ca]')).forEach(function(link){
link.addEventListener('click', function(e){
var sel = link.getAttribute('data-ac-cn-spring-ca'), doel = null;
try { doel = document.querySelector(sel); } catch(err){ doel = null; }
if(!doel && sel.charAt(0) !== '.' && sel.charAt(0) !== '#'){ doel = document.getElementById(sel); }
if(!doel || doel.contains(link)) return;
e.preventDefault();
var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var offset = parseInt(link.getAttribute('data-ac-cn-offset-ca'), 10) || 0;
var top = doel.getBoundingClientRect().top + window.pageYOffset - offset;
window.scrollTo({ top: top, behavior: stil ? 'auto' : 'smooth' });
if(doel.id && history.replaceState) history.replaceState(null, '', '#' + doel.id);
});
});
function bouw(){
var kop = sec.querySelector('[data-ac-cn-kop-ca]');
if(kop && kop.dataset.bron !== undefined){ kop.innerHTML = kop.dataset.bron; }
if(kop && !kop.dataset.bron){ kop.dataset.bron = kop.innerHTML; }
var basis = 0.18;
Array.prototype.slice.call(sec.querySelectorAll('[data-ac-cn-na-ca]')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.07).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.14 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
var tm = null, breed = window.innerWidth;
window.addEventListener('resize', function(){ if(window.innerWidth === breed) return; clearTimeout(tm); tm = setTimeout(function(){ breed = window.innerWidth; bouw(); }, 160); });
}
function init(){ document.querySelectorAll('[data-ac-cn-ca]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-cam-melkweg ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-rail-ca]:not([data-ac-ready-ca])').forEach(function (root) {
      root.setAttribute('data-ac-ready-ca', '1');
      var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* ---- kleurkiezer per stoel ---- */
      root.querySelectorAll('[data-ac-combi-ca]').forEach(function (stop) {
        var swatches = Array.prototype.slice.call(stop.querySelectorAll('[data-ac-swatch-ca]'));
        var vars = Array.prototype.slice.call(stop.querySelectorAll('[data-ac-var-ca]'));
        if (!swatches.length) { return; }
        var select = function (key) {
          swatches.forEach(function (s) {
            var on = s.getAttribute('data-ac-swatch-ca') === key;
            s.classList.toggle('is-active', on);
            s.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          vars.forEach(function (v) { v.classList.toggle('is-active', v.getAttribute('data-ac-var-ca') === key); });
        };
        swatches.forEach(function (s, i) {
          s.addEventListener('click', function () { select(s.getAttribute('data-ac-swatch-ca')); });
          s.addEventListener('keydown', function (e) {
            var next = null;
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = (i + 1) % swatches.length; }
            if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = (i - 1 + swatches.length) % swatches.length; }
            if (next === null) { return; }
            e.preventDefault();
            select(swatches[next].getAttribute('data-ac-swatch-ca'));
            swatches[next].focus();
          });
        });
      });
      /* ---- productpagina voorladen ----
         Zodra de bezoeker een halte aanraakt of eroverheen beweegt, wordt
         de productpagina alvast opgehaald. De doorklik voelt daardoor
         direct. Elke URL maar een keer. */
      var geladen = {};
      var prefetch = function (stop) {
        var actief = stop.querySelector('.ac-rail__buy.is-active .ac-rail__cta') || stop.querySelector('.ac-rail__cta');
        if (!actief || !actief.href || geladen[actief.href]) { return; }
        geladen[actief.href] = true;
        var l = document.createElement('link');
        l.rel = 'prefetch';
        l.href = actief.href;
        document.head.appendChild(l);
      };
      root.querySelectorAll('[data-ac-stop-ca]').forEach(function (stop) {
        stop.addEventListener('mouseenter', function () { prefetch(stop); });
        stop.addEventListener('touchstart', function () { prefetch(stop); }, { passive: true });
      });
      if (stil) { return; }
      /* ---- het percentage laten meetellen ----
         Loopt één keer, gelijk met de balk eronder. */
      root.querySelectorAll('[data-ac-count-ca]').forEach(function (el) {
        var target = parseInt(el.getAttribute('data-ac-count-ca'), 10) || 0;
        if (!('IntersectionObserver' in window)) { el.textContent = target + '%'; return; }
        el.textContent = '0%';
        var run = function () {
          if (el.dataset.done === '1') { return; }
          el.dataset.done = '1';
          var start = null;
          var tick = function (now) {
            if (start === null) { start = now; }
            var p = Math.min(1, (now - start) / 1100);
            el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))) + '%';
            if (p < 1) { window.requestAnimationFrame(tick); }
          };
          window.requestAnimationFrame(tick);
        };
        var ioCount = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { run(); ioCount.unobserve(e.target); } });
        }, { threshold: 0.4 });
        ioCount.observe(el);
      });
      /* ---- knopen laten oplichten ---- */
      var stops = Array.prototype.slice.call(root.querySelectorAll('[data-ac-stop-ca]'));
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('is-inview', entry.isIntersecting);
          });
        }, { threshold: 0.3 });
        stops.forEach(function (s) { io.observe(s); });
      } else {
        stops.forEach(function (s) { s.classList.add('is-inview'); });
      }
      /* ---- de rail vullen op scrollpositie ----
         Eén listener met requestAnimationFrame, dus geen rekenwerk per
         scroll-event. */
      var track = root.querySelector('.ac-rail__track');
      if (!track) { return; }
      var ticking = false;
      var update = function () {
        ticking = false;
        var rect = track.getBoundingClientRect();
        var mid = window.innerHeight * 0.62;
        var p = (mid - rect.top) / rect.height;
        if (p < 0) { p = 0; }
        if (p > 1) { p = 1; }
        root.style.setProperty('--ac-rail-fill', (p * 100).toFixed(1) + '%');
      };
      var onScroll = function () {
        if (ticking) { return; }
        ticking = true;
        window.requestAnimationFrame(update);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-cam-intro ===== */
/* Deze sectie heeft geen §4.8-kop, dus ook geen kopanimatie die het
   binnenkomen regelt. Eén kleine waarnemer doet dat hier zelf. Valt JS
   weg, dan staat de tekst er gewoon: de startstand hangt aan .ac-js. */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-in-ca]:not([data-ac-in-klaar-ca])').forEach(function (sec) {
      sec.setAttribute('data-ac-in-klaar-ca', '1');
      sec.classList.add('ac-js');
      var speel = function () { sec.classList.add('is-in'); };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) { speel(); return; }
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { speel(); io.disconnect(); }
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      io.observe(sec);
      /* Vangnet: staat de sectie na 1,5 s nog steeds op onzichtbaar,
         bijvoorbeeld omdat een thema-laag ertussen zit, dan tonen we hem
         alsnog. Onzichtbare tekst is erger dan een gemiste animatie. */
      setTimeout(speel, 1500);
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();

/* Flush-helper. Trekt de sectie door tot de rand van de pagina; zonder dit
   staat een Custom Liquid-blok in een smallere container met stroken
   paginakleur ernaast. Draait één keer per pagina. */

/* ===== ac-cam-quasar ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-rail-cal]:not([data-ac-ready-cal])').forEach(function (root) {
      root.setAttribute('data-ac-ready-cal', '1');
      var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* ---- kleurkiezer per stoel ---- */
      root.querySelectorAll('[data-ac-combi-cal]').forEach(function (stop) {
        var swatches = Array.prototype.slice.call(stop.querySelectorAll('[data-ac-swatch-cal]'));
        var vars = Array.prototype.slice.call(stop.querySelectorAll('[data-ac-var-cal]'));
        if (!swatches.length) { return; }
        var select = function (key) {
          swatches.forEach(function (s) {
            var on = s.getAttribute('data-ac-swatch-cal') === key;
            s.classList.toggle('is-active', on);
            s.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          vars.forEach(function (v) { v.classList.toggle('is-active', v.getAttribute('data-ac-var-cal') === key); });
        };
        swatches.forEach(function (s, i) {
          s.addEventListener('click', function () { select(s.getAttribute('data-ac-swatch-cal')); });
          s.addEventListener('keydown', function (e) {
            var next = null;
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = (i + 1) % swatches.length; }
            if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = (i - 1 + swatches.length) % swatches.length; }
            if (next === null) { return; }
            e.preventDefault();
            select(swatches[next].getAttribute('data-ac-swatch-cal'));
            swatches[next].focus();
          });
        });
      });
      /* ---- productpagina voorladen ----
         Zodra de bezoeker een halte aanraakt of eroverheen beweegt, wordt
         de productpagina alvast opgehaald. De doorklik voelt daardoor
         direct. Elke URL maar een keer. */
      var geladen = {};
      var prefetch = function (stop) {
        var actief = stop.querySelector('.ac-rail-cal__buy.is-active .ac-rail-cal__cta') || stop.querySelector('.ac-rail-cal__cta');
        if (!actief || !actief.href || geladen[actief.href]) { return; }
        geladen[actief.href] = true;
        var l = document.createElement('link');
        l.rel = 'prefetch';
        l.href = actief.href;
        document.head.appendChild(l);
      };
      root.querySelectorAll('[data-ac-stop-cal]').forEach(function (stop) {
        stop.addEventListener('mouseenter', function () { prefetch(stop); });
        stop.addEventListener('touchstart', function () { prefetch(stop); }, { passive: true });
      });
      if (stil) { return; }
      /* ---- het percentage laten meetellen ----
         Loopt één keer, gelijk met de balk eronder. */
      root.querySelectorAll('[data-ac-count-cal]').forEach(function (el) {
        var target = parseInt(el.getAttribute('data-ac-count-cal'), 10) || 0;
        if (!('IntersectionObserver' in window)) { el.textContent = target + '%'; return; }
        el.textContent = '0%';
        var run = function () {
          if (el.dataset.done === '1') { return; }
          el.dataset.done = '1';
          var start = null;
          var tick = function (now) {
            if (start === null) { start = now; }
            var p = Math.min(1, (now - start) / 1100);
            el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))) + '%';
            if (p < 1) { window.requestAnimationFrame(tick); }
          };
          window.requestAnimationFrame(tick);
        };
        var ioCount = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { run(); ioCount.unobserve(e.target); } });
        }, { threshold: 0.4 });
        ioCount.observe(el);
      });
      /* ---- knopen laten oplichten ---- */
      var stops = Array.prototype.slice.call(root.querySelectorAll('[data-ac-stop-cal]'));
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('is-inview', entry.isIntersecting);
          });
        }, { threshold: 0.3 });
        stops.forEach(function (s) { io.observe(s); });
      } else {
        stops.forEach(function (s) { s.classList.add('is-inview'); });
      }
      /* ---- de rail vullen op scrollpositie ----
         Eén listener met requestAnimationFrame, dus geen rekenwerk per
         scroll-event. */
      var track = root.querySelector('.ac-rail-cal__track');
      if (!track) { return; }
      var ticking = false;
      var update = function () {
        ticking = false;
        var rect = track.getBoundingClientRect();
        var mid = window.innerHeight * 0.62;
        var p = (mid - rect.top) / rect.height;
        if (p < 0) { p = 0; }
        if (p > 1) { p = 1; }
        root.style.setProperty('--ac-rail-fill', (p * 100).toFixed(1) + '%');
      };
      var onScroll = function () {
        if (ticking) { return; }
        ticking = true;
        window.requestAnimationFrame(update);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-cam-andromeda-intro ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var kop = sec.querySelector('[data-ac-int-kop]');
var binnen = sec.querySelector('.ac-int__in');
/* Het thema zet vaak nog ruimte om de sectie heen. Weghalen, anders staat
   er een strook paginakleur boven en onder. */
(function(){ var n = sec.parentElement; while(n && n !== document.body){ var cs = getComputedStyle(n); if(parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) || parseFloat(cs.marginTop) || parseFloat(cs.marginBottom)){ n.style.paddingTop='0px'; n.style.paddingBottom='0px'; n.style.marginTop='0px'; n.style.marginBottom='0px'; } n = n.parentElement; } })();
/* De pijl. Een gewone ankersprong schuift de doelsectie onder een vaste
   header; daarom meten we de hoogste vaste of plakkende balk bovenaan op
   en trekken die eraf. Wordt het doel niet gevonden, dan gaat hij één
   schermhoogte naar beneden — dat is nog altijd wat de bezoeker wilde. */
(function(){
var pijl = sec.querySelector('[data-ac-int-pijl]');
if(!pijl) return;
function headerhoogte(){
var h = 0;
Array.prototype.slice.call(document.body.querySelectorAll('header,[class*="header"],[data-header]')).forEach(function(el){
var cs = getComputedStyle(el);
if(cs.position !== 'fixed' && cs.position !== 'sticky') return;
var r = el.getBoundingClientRect();
if(r.top > 4 || r.height < 20 || r.height > 220) return;
if(r.height > h) h = r.height;
});
return h;
}
pijl.addEventListener('click', function(e){
/* De doelsectie stond als Liquid in dit script; in een gecachet bestand
   blijft dat letterlijke tekst. De pijl zelf wijst er al naar. */
var doelId = (pijl.getAttribute('href') || '').replace(/^#/, '');
var doel = doelId ? document.getElementById(doelId) : null;
var zacht = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
e.preventDefault();
var y;
if(doel){ y = doel.getBoundingClientRect().top + window.pageYOffset - headerhoogte() - 8; }
else { y = window.pageYOffset + window.innerHeight * 0.9; }
window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: zacht ? 'smooth' : 'auto' });
});
})();
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-int__kern') || k.classList.contains('ac-int__semi'))){ k.setAttribute('data-accent','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-int__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.26;
Array.prototype.slice.call(sec.querySelectorAll('[data-ac-int-na]')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.15 });
io.observe(sec);
/* Vangnet: komt "speelt" niet, dan blijft de tekst op opacity 0 staan. Het
   vangnet zet de opkomst alleen aan als de sectie ook echt in beeld staat;
   anders wacht het op scrollen, zodat de opkomst niet ongezien afspeelt. */
function inBeeld(){ var b = sec.getBoundingClientRect(); return b.top < window.innerHeight * 0.92 && b.bottom > 0; }
function vangnet(){ if(sec.classList.contains('speelt')) return true; if(inBeeld()){ sec.classList.add('speelt'); io.disconnect(); return true; } return false; }
setTimeout(function(){ if(!vangnet()){ var op = function(){ if(vangnet()){ window.removeEventListener('scroll', op); } }; window.addEventListener('scroll', op, { passive: true }); } }, 1500);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
/* Opnieuw opknippen zodra de CONTAINER van breedte verandert, niet alleen
   bij window-resize. Een opgeknipte kop kan zelf niet meer herwikkelen: laat
   je dit weg, dan blijft een oude regelindeling staan zodra het thema, een
   scrollbalk of een lettertype de breedte nog verschuift, en komt er een los
   woord op een eigen regel. */
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
} else {
var tm2 = null, breed = window.innerWidth;
window.addEventListener('resize', function(){ if(window.innerWidth === breed) return; clearTimeout(tm2); tm2 = setTimeout(function(){ breed = window.innerWidth; bouw(); }, 200); });
}
}
function init(){ document.querySelectorAll('[data-ac-int]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-cam-andromeda ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-rail-call]:not([data-ac-ready-call])').forEach(function (root) {
      root.setAttribute('data-ac-ready-call', '1');
      var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      /* ---- kleurkiezer per stoel ---- */
      root.querySelectorAll('[data-ac-combi-call]').forEach(function (stop) {
        var swatches = Array.prototype.slice.call(stop.querySelectorAll('[data-ac-swatch-call]'));
        var vars = Array.prototype.slice.call(stop.querySelectorAll('[data-ac-var-call]'));
        if (!swatches.length) { return; }
        var select = function (key) {
          swatches.forEach(function (s) {
            var on = s.getAttribute('data-ac-swatch-call') === key;
            s.classList.toggle('is-active', on);
            s.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          vars.forEach(function (v) { v.classList.toggle('is-active', v.getAttribute('data-ac-var-call') === key); });
        };
        swatches.forEach(function (s, i) {
          s.addEventListener('click', function () { select(s.getAttribute('data-ac-swatch-call')); });
          s.addEventListener('keydown', function (e) {
            var next = null;
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = (i + 1) % swatches.length; }
            if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = (i - 1 + swatches.length) % swatches.length; }
            if (next === null) { return; }
            e.preventDefault();
            select(swatches[next].getAttribute('data-ac-swatch-call'));
            swatches[next].focus();
          });
        });
      });
      /* ---- productpagina voorladen ----
         Zodra de bezoeker een halte aanraakt of eroverheen beweegt, wordt
         de productpagina alvast opgehaald. De doorklik voelt daardoor
         direct. Elke URL maar een keer. */
      var geladen = {};
      var prefetch = function (stop) {
        var actief = stop.querySelector('.ac-rail-call__buy.is-active .ac-rail-call__cta') || stop.querySelector('.ac-rail-call__cta');
        if (!actief || !actief.href || geladen[actief.href]) { return; }
        geladen[actief.href] = true;
        var l = document.createElement('link');
        l.rel = 'prefetch';
        l.href = actief.href;
        document.head.appendChild(l);
      };
      root.querySelectorAll('[data-ac-stop-call]').forEach(function (stop) {
        stop.addEventListener('mouseenter', function () { prefetch(stop); });
        stop.addEventListener('touchstart', function () { prefetch(stop); }, { passive: true });
      });
      if (stil) { return; }
      /* ---- het percentage laten meetellen ----
         Loopt één keer, gelijk met de balk eronder. */
      root.querySelectorAll('[data-ac-count-call]').forEach(function (el) {
        var target = parseInt(el.getAttribute('data-ac-count-call'), 10) || 0;
        if (!('IntersectionObserver' in window)) { el.textContent = target + '%'; return; }
        el.textContent = '0%';
        var run = function () {
          if (el.dataset.done === '1') { return; }
          el.dataset.done = '1';
          var start = null;
          var tick = function (now) {
            if (start === null) { start = now; }
            var p = Math.min(1, (now - start) / 1100);
            el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))) + '%';
            if (p < 1) { window.requestAnimationFrame(tick); }
          };
          window.requestAnimationFrame(tick);
        };
        var ioCount = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { run(); ioCount.unobserve(e.target); } });
        }, { threshold: 0.4 });
        ioCount.observe(el);
      });
      /* ---- knopen laten oplichten ---- */
      var stops = Array.prototype.slice.call(root.querySelectorAll('[data-ac-stop-call]'));
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            entry.target.classList.toggle('is-inview', entry.isIntersecting);
          });
        }, { threshold: 0.3 });
        stops.forEach(function (s) { io.observe(s); });
      } else {
        stops.forEach(function (s) { s.classList.add('is-inview'); });
      }
      /* ---- de rail vullen op scrollpositie ----
         Eén listener met requestAnimationFrame, dus geen rekenwerk per
         scroll-event. */
      var track = root.querySelector('.ac-rail-call__track');
      if (!track) { return; }
      var ticking = false;
      var update = function () {
        ticking = false;
        var rect = track.getBoundingClientRect();
        var mid = window.innerHeight * 0.62;
        var p = (mid - rect.top) / rect.height;
        if (p < 0) { p = 0; }
        if (p > 1) { p = 1; }
        root.style.setProperty('--ac-rail-fill', (p * 100).toFixed(1) + '%');
      };
      var onScroll = function () {
        if (ticking) { return; }
        ticking = true;
        window.requestAnimationFrame(update);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-cam-seo ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var kop = sec.querySelector('[data-ac-seo-kop]');
var binnen = sec.querySelector('.ac-seo__in');
(function(){ var n = sec.parentElement; while(n && n !== document.body){ var cs = getComputedStyle(n); if(parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) || parseFloat(cs.marginTop) || parseFloat(cs.marginBottom)){ n.style.paddingTop='0px'; n.style.paddingBottom='0px'; n.style.marginTop='0px'; n.style.marginBottom='0px'; } n = n.parentElement; } })();
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-seo__kern') || k.classList.contains('ac-seo__semi'))){ k.setAttribute('data-accent','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-seo__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('[data-ac-seo-na]')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.06).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
} else {
var tm2 = null, breed = window.innerWidth;
window.addEventListener('resize', function(){ if(window.innerWidth === breed) return; clearTimeout(tm2); tm2 = setTimeout(function(){ breed = window.innerWidth; bouw(); }, 200); });
}
}
function init(){ document.querySelectorAll('[data-ac-seo]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-cam-rollers ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var kop = sec.querySelector('[data-ac-rk-kop]');
var binnen = sec.querySelector('.ac-rk__in');
(function(){ var n = sec.parentElement; while(n && n !== document.body){ var cs = getComputedStyle(n); if(parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) || parseFloat(cs.marginTop) || parseFloat(cs.marginBottom)){ n.style.paddingTop='0px'; n.style.paddingBottom='0px'; n.style.marginTop='0px'; n.style.marginBottom='0px'; } n = n.parentElement; } })();
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-rk__kern') || k.classList.contains('ac-rk__semi'))){ k.setAttribute('data-accent','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
var los = x.getAttribute && x.getAttribute('data-accent');
var vorigeAccent = j > 0 && reg[j-1].getAttribute && reg[j-1].getAttribute('data-accent');
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent) && !(los && vorigeAccent)) stuk += ' ';
if(los){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-rk__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('[data-ac-rk-na]')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
/* Vangnet: komt "speelt" niet, dan blijven de intro en de kaarten op
   opacity 0 staan. Onzichtbare inhoud is erger dan een gemiste animatie. */
setTimeout(function(){ sec.classList.add('speelt'); }, 1500);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
} else {
var tm2 = null, breed = window.innerWidth;
window.addEventListener('resize', function(){ if(window.innerWidth === breed) return; clearTimeout(tm2); tm2 = setTimeout(function(){ breed = window.innerWidth; bouw(); }, 200); });
}
}
function init(){ document.querySelectorAll('[data-ac-rk]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-cam-levering ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(blok){
if(!blok || blok.dataset.acKlaar) return;
blok.dataset.acKlaar = '1';
if(!('IntersectionObserver' in window)){ blok.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ blok.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.25 });
io.observe(blok);
}
function init(){ document.querySelectorAll('[data-ac-lev-ca]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-faq-collectie ===== */

(function () {
function init() {
document.querySelectorAll('[data-ac-faq-ca]').forEach(function (root) {
if (root.dataset.acReady === '1') return;
root.dataset.acReady = '1';
var items = Array.prototype.slice.call(root.querySelectorAll('.ac-faq-ca__item'));
items.forEach(function (item) {
item.addEventListener('toggle', function () {
if (!item.open) return;
items.forEach(function (other) {
if (other !== item) other.open = false;
});
});
});
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

/* ===== ac-faq-pagina ===== */

(function () {
function init() {
document.querySelectorAll('[data-ac-faq-fq]').forEach(function (root) {
if (root.dataset.acReady === '1') return;
root.dataset.acReady = '1';
var items = Array.prototype.slice.call(root.querySelectorAll('.ac-faq-fq__item'));
items.forEach(function (item) {
item.addEventListener('toggle', function () {
if (!item.open) return;
items.forEach(function (other) {
if (other !== item) other.open = false;
});
});
});
});
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();

/* ===== ac-sauna-beschrijving ===== */
(function () {
    function initSaunamatDescription() {
      var sections = document.querySelectorAll('[data-ac-desc-saunamat]');

      sections.forEach(function (section) {
        if (section.dataset.initialized === 'true') return;
        section.dataset.initialized = 'true';

        var button = section.querySelector('.ac-desc-saunamat__btn');
        var panel = section.querySelector('.ac-desc-saunamat__panel');

        if (!button || !panel) return;

        button.addEventListener('click', function () {
          var isOpen = panel.classList.contains('is-open');

          if (isOpen) {
            panel.classList.remove('is-open');
            button.classList.remove('is-open');
            button.setAttribute('aria-expanded', 'false');
          } else {
            panel.classList.add('is-open');
            button.classList.add('is-open');
            button.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    document.addEventListener('DOMContentLoaded', initSaunamatDescription);
    document.addEventListener('shopify:section:load', initSaunamatDescription);

    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      initSaunamatDescription();
    }
  })();

/* ===== ac-ct-intro ===== */
/* Kopanimatie §4.8 — identiek blok in alle AlienComfort-secties, idempotent.
   Regel voor regel met 80 ms ertussen, accent 220 ms na zijn eigen regel,
   de rest 300 ms na de laatste regel.
   Het script meet één keer waar de regels vallen en vervangt de kop door
   vaste regelblokken. Vanaf dat moment is text-wrap: balance dood, dus een
   ResizeObserver op de inhoudscontainer meet opnieuw zodra de breedte
   verandert. Window-resize alleen is niet genoeg: thema-CSS die later
   landt, een scrollbalk of een lettertype dat omwisselt geven geen
   resize-event en laten anders één woord alleen op een regel achter. */

/* Flush-helper. Shopify zet een Custom Liquid-sectie in een container die
   smaller is dan het scherm, met eigen ruimte eromheen. Bij een witte
   sectie zie je dat niet, bij een ruimtezwarte krijg je stroken
   paginakleur links, rechts, boven en onder. Hoeveel dat is verschilt per
   thema en per instelling, dus dit meet het op en trekt de sectie door tot
   de rand. Draait één keer per pagina. */

/* ===== ac-ct-kanalen ===== */
/* Kopanimatie §4.8 — regel voor regel, 80 ms ertussen, accent 220 ms later,
   de alinea 300 ms na de laatste regel.
   Het script meet één keer waar de regels vallen en vervangt de kop door
   vaste regelblokken. Vanaf dat moment is text-wrap: balance dood, dus een
   ResizeObserver op de inhoudscontainer meet opnieuw zodra de breedte
   verandert. Window-resize alleen is niet genoeg: thema-CSS die later
   landt, een scrollbalk of een lettertype dat omwisselt geven geen
   resize-event en laten anders één woord alleen op een regel achter.
   Dit blok is identiek in alle AlienComfort-secties en is idempotent:
   staat het twee keer op een pagina, dan gebeurt er niets dubbels. */

/* ===== ac-ct-formulier ===== */
/* Kopanimatie §4.8 — identiek blok in alle AlienComfort-secties, idempotent.
   Regel voor regel met 80 ms ertussen, accent 220 ms na zijn eigen regel,
   de rest 300 ms na de laatste regel. Alleen transform en opacity: een
   geanimeerde filter: blur() kostte gemeten tot 50 ms per frame.
   De ResizeObserver op de inhoudscontainer is er omdat een opgeknipte kop
   niet meer kan herwikkelen; zonder hem blijft er een los woord staan. */

/* ===== ac-ct-kennisbank ===== */
/* Tabs en accordeon. */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-kb-ct]:not([data-ac-ready-ct])').forEach(function (root) {
      root.setAttribute('data-ac-ready-ct', '1');
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.ac-kb-ct__tab'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.ac-kb-ct__panel'));
      var select = function (i) {
        tabs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === i);
          t.setAttribute('aria-selected', n === i ? 'true' : 'false');
        });
        panels.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
      };
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(i); });
        /* pijltjestoetsen tussen de tabs, zoals een tablist hoort te werken */
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') { next = (i + 1) % tabs.length; }
          if (e.key === 'ArrowLeft') { next = (i - 1 + tabs.length) % tabs.length; }
          if (next === null) { return; }
          e.preventDefault();
          select(next);
          tabs[next].focus();
        });
      });
      /* binnen een tab staat er één vraag tegelijk open */
      panels.forEach(function (panel) {
        var items = Array.prototype.slice.call(panel.querySelectorAll('.ac-kb-ct__item'));
        items.forEach(function (item) {
          item.addEventListener('toggle', function () {
            if (!item.open) { return; }
            items.forEach(function (other) { if (other !== item) { other.open = false; } });
          });
        });
      });
      select(0);
    });
  };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
/* Kopanimatie §4.8 — identiek blok in alle AlienComfort-secties, idempotent.
   Regel voor regel met 80 ms ertussen, accent 220 ms na zijn eigen regel,
   de rest 300 ms na de laatste regel. Alleen transform en opacity: een
   geanimeerde filter: blur() kostte gemeten tot 50 ms per frame.
   ResizeObserver op de inhoudscontainer, want een opgeknipte kop kan niet
   meer herwikkelen. */

/* ===== ac-ct-verder ===== */
/* Kopanimatie §4.8 — identiek blok in alle AlienComfort-secties, idempotent.
   Regel voor regel met 80 ms ertussen, accent 220 ms na zijn eigen regel,
   de rest 300 ms na de laatste regel. Alleen transform en opacity.
   ResizeObserver op de inhoudscontainer: een opgeknipte kop kan niet meer
   herwikkelen, en zonder die observer blijft er een los woord achter. */

/* ===== ac-sh-uitnodiging ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var kop = sec.querySelector('[data-ac-sw-kop]');
var binnen = sec.querySelector('.ac-sw__in');
(function(){ var n = sec.parentElement; while(n && n !== document.body){ var cs = getComputedStyle(n); if(parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) || parseFloat(cs.marginTop) || parseFloat(cs.marginBottom)){ n.style.paddingTop='0px'; n.style.paddingBottom='0px'; n.style.marginTop='0px'; n.style.marginBottom='0px'; } n = n.parentElement; } })();
/* De knop springt naar de datumprikker op dezelfde pagina. Wordt die
   niet gevonden (andere pagina), dan blijft de gewone link staan. */
var spring = sec.querySelector('[data-ac-sw-spring]');
function zoekDoel(){
if(!spring) return null;
var sel = spring.getAttribute('data-ac-sw-spring'), doel = null;
try { doel = document.querySelector(sel); } catch(err){ doel = null; }
if(!doel && sel.charAt(0) !== '.' && sel.charAt(0) !== '#' && sel.charAt(0) !== '['){ doel = document.getElementById(sel); }
if(doel && (doel === sec || doel.contains(spring) || sec.contains(doel))) return null;
return doel;
}
if(spring){
function merk(){ if(zoekDoel()) spring.classList.add('is-omlaag'); else spring.classList.remove('is-omlaag'); }
merk();
window.addEventListener('load', merk);
spring.addEventListener('click', function(e){
var doel = zoekDoel();
if(!doel){ merk(); return; }
e.preventDefault();
var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var offset = parseInt(spring.getAttribute('data-ac-sw-offset'), 10) || 0;
var top = doel.getBoundingClientRect().top + window.pageYOffset - offset;
window.scrollTo({ top: top < 0 ? 0 : top, behavior: stil ? 'auto' : 'smooth' });
});
}
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-sw__kern') || k.classList.contains('ac-sw__semi'))){ k.setAttribute('data-accent','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-sw__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('[data-ac-sw-na]')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.08).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.18 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
} else {
var tm2 = null, breed = window.innerWidth;
window.addEventListener('resize', function(){ if(window.innerWidth === breed) return; clearTimeout(tm2); tm2 = setTimeout(function(){ breed = window.innerWidth; bouw(); }, 200); });
}
}
function init(){ document.querySelectorAll('[data-ac-sw]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-sh-boeken ===== */

(function () {
function init() {
document.querySelectorAll('[data-ac-boek-sh]:not([data-ac-klaar-sh])').forEach(function (root) {
var endpoint = root.getAttribute('data-endpoint');
if (!endpoint) { return; }
root.setAttribute('data-ac-klaar-sh', '1');
var T = JSON.parse(root.querySelector('[data-ac-boek-t-sh]').textContent);
var loc = root.getAttribute('data-loc') || 'nl-NL';
var taal = root.getAttribute('data-taal') || 'nl';
var bedankt = root.getAttribute('data-bedankt');
var elMaand = root.querySelector('[data-ac-maand-sh]');
var elDagnamen = root.querySelector('[data-ac-dagnamen-sh]');
var elDagen = root.querySelector('[data-ac-dagen-sh]');
var elSlots = root.querySelector('[data-ac-slots-sh]');
var elTijdkop = root.querySelector('[data-ac-tijdkop-sh]');
var form = root.querySelector('[data-ac-form-sh]');
var elGekozen = root.querySelector('[data-ac-gekozen-sh]');
var elFout = root.querySelector('[data-ac-fout-sh]');
var knop = root.querySelector('[data-ac-verstuur-sh]');

var terugval = {};
try { terugval = JSON.parse(root.getAttribute('data-open') || '{}'); } catch (fout) { terugval = {}; }
var cfg = { open: terugval, duur: 60, minUren: 4, maxDagen: 60, gesloten: [] };
var vol = {};
var kijk = new Date(); kijk.setDate(1);
var dagKeuze = null, tijdKeuze = null;

function pad(n) { return (n < 10 ? '0' : '') + n; }
function sleutel(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}

/* Dagnamen komen uit de browser, in de taal van de bezoeker. Maandag
   eerst, want zo kijkt men hier naar een kalender. */
(function () {
var uit = '';
for (var i = 0; i < 7; i++) {
var d = new Date(2024, 0, 1 + i); // 1 januari 2024 was een maandag
uit += '<span>' + esc(d.toLocaleDateString(loc, { weekday: 'short' }).slice(0, 2)) + '</span>';
}
elDagnamen.innerHTML = uit;
})();

function open_(d) {
var dag = d.getDay();
var uren = cfg.open[dag] || cfg.open[String(dag)];
if (!uren) { return null; }
if (cfg.gesloten.indexOf(sleutel(d)) > -1) { return null; }
return uren;
}
function slotsVoor(d) {
var uren = open_(d);
if (!uren) { return []; }
var uit = [], stap = cfg.duur / 60;
for (var u = uren[0]; u + stap <= uren[1]; u += stap) {
var t = new Date(d.getFullYear(), d.getMonth(), d.getDate(), u, 0, 0);
if (t.getTime() - Date.now() < cfg.minUren * 3600000) { continue; }
var k = sleutel(d) + 'T' + pad(u) + ':00';
uit.push({ uur: pad(u) + ':00', k: k, vol: !!vol[k] });
}
return uit;
}
function dagVrij(d) { return slotsVoor(d).some(function (s) { return !s.vol; }); }

function tekenKalender() {
elMaand.textContent = kijk.toLocaleDateString(loc, { month: 'long', year: 'numeric' });
var eerste = new Date(kijk.getFullYear(), kijk.getMonth(), 1);
var offset = (eerste.getDay() + 6) % 7; // maandag als eerste kolom
var dagen = new Date(kijk.getFullYear(), kijk.getMonth() + 1, 0).getDate();
var grens = new Date(); grens.setDate(grens.getDate() + cfg.maxDagen);
var uit = '';
for (var i = 0; i < offset; i++) { uit += '<span class="ac-boek__leeg"></span>'; }
for (var n = 1; n <= dagen; n++) {
var d = new Date(kijk.getFullYear(), kijk.getMonth(), n);
var kan = d <= grens && dagVrij(d);
var gekozen = dagKeuze && sleutel(d) === sleutel(dagKeuze);
uit += '<button type="button" class="ac-boek__dag' + (kan ? '' : ' is-uit') + (gekozen ? ' is-gekozen' : '')
+ '" data-datum="' + sleutel(d) + '"' + (kan ? '' : ' disabled') + '>' + n + '</button>';
}
elDagen.innerHTML = uit;
}

function tekenSlots() {
if (!dagKeuze) { elSlots.innerHTML = '<p class="ac-boek__hint">' + esc(T.eerst_dag) + '</p>'; return; }
var lijst = slotsVoor(dagKeuze);
elTijdkop.textContent = dagKeuze.toLocaleDateString(loc, { weekday: 'long', day: 'numeric', month: 'long' });
if (!lijst.length) { elSlots.innerHTML = '<p class="ac-boek__hint">' + esc(T.geen_tijden) + '</p>'; return; }
elSlots.innerHTML = lijst.map(function (s) {
return '<button type="button" class="ac-boek__slot' + (s.vol ? ' is-vol' : '') + (tijdKeuze === s.uur ? ' is-gekozen' : '')
+ '" data-tijd="' + s.uur + '"' + (s.vol ? ' disabled' : '') + '>' + s.uur
+ (s.vol ? '<small>' + esc(T.vol) + '</small>' : '') + '</button>';
}).join('');
}

function toonForm() {
if (!dagKeuze || !tijdKeuze) { form.hidden = true; return; }
elGekozen.textContent = dagKeuze.toLocaleDateString(loc, { weekday: 'long', day: 'numeric', month: 'long' }) + ', ' + tijdKeuze;
form.hidden = false;
}

elDagen.addEventListener('click', function (e) {
var b = e.target.closest('.ac-boek__dag'); if (!b || b.disabled) { return; }
var d = b.getAttribute('data-datum').split('-');
dagKeuze = new Date(Number(d[0]), Number(d[1]) - 1, Number(d[2]));
tijdKeuze = null; tekenKalender(); tekenSlots(); toonForm();
});
elSlots.addEventListener('click', function (e) {
var b = e.target.closest('.ac-boek__slot'); if (!b || b.disabled) { return; }
tijdKeuze = b.getAttribute('data-tijd'); tekenSlots(); toonForm();
form.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
});
root.querySelector('[data-ac-vorige-sh]').addEventListener('click', function () {
kijk = new Date(kijk.getFullYear(), kijk.getMonth() - 1, 1); tekenKalender();
});
root.querySelector('[data-ac-volgende-sh]').addEventListener('click', function () {
kijk = new Date(kijk.getFullYear(), kijk.getMonth() + 1, 1); tekenKalender();
});

/* Alles gaat met JSONP naar het Apps Script. Een gewone fetch of POST
   zou op de beveiliging van de browser stuiten, omdat het script bij
   Google staat en de winkel bij Shopify. Een script inladen mag wel. */
var teller = 0;
function vraag(params, klaar, mis) {
teller += 1;
var naam = 'acBoek' + teller + '_' + (new Date()).getTime();
var s = document.createElement('script');
var af = false;
var tikker = setTimeout(function () { if (!af) { af = true; delete window[naam]; opruimen(); mis('tijd'); } }, 25000);
function opruimen() { clearTimeout(tikker); if (s.parentNode) { s.parentNode.removeChild(s); } }
window[naam] = function (data) { if (af) { return; } af = true; delete window[naam]; opruimen(); klaar(data); };
var stukken = ['callback=' + naam];
Object.keys(params).forEach(function (k) { stukken.push(k + '=' + encodeURIComponent(params[k])); });
s.src = endpoint + (endpoint.indexOf('?') > -1 ? '&' : '?') + stukken.join('&');
s.onerror = function () { if (af) { return; } af = true; delete window[naam]; opruimen(); mis('bereik'); };
document.body.appendChild(s);
}

function haalVrij() {
var van = new Date(), tot = new Date(); tot.setDate(tot.getDate() + 70);
vraag({ actie: 'vrij', van: sleutel(van), tot: sleutel(tot) }, function (data) {
if (data && data.ok) {
cfg.open = data.open || terugval; cfg.duur = data.duur || 60;
cfg.minUren = data.minUren != null ? data.minUren : 4;
cfg.maxDagen = data.maxDagen || 60; cfg.gesloten = data.gesloten || [];
vol = {}; (data.vol || []).forEach(function (k) { vol[k] = true; });
}
tekenKalender(); tekenSlots();
}, function () { tekenKalender(); tekenSlots(); });
}

/* Zet ?acdebug=1 achter de pagina-URL om de technische reden te zien.
   Handig bij het inrichten, bezoekers krijgen hem nooit te zien. */
var pluis = window.location.search.indexOf('acdebug') > -1;
function misgegaan(reden) {
knop.disabled = false; knop.textContent = T.versturen;
elFout.textContent = reden === 'vol' ? T.fout_vol : T.fout;
if (pluis) { elFout.textContent += ' [' + reden + ']'; }
elFout.hidden = false;
if (reden === 'vol') { haalVrij(); }
if (window.console) { console.log('AC boeking mislukt:', reden); }
}

form.addEventListener('submit', function (e) {
e.preventDefault();
if (!form.checkValidity()) { form.reportValidity(); return; }
elFout.hidden = true;
knop.disabled = true; knop.textContent = T.bezig;
vraag({
actie: 'boek', datum: sleutel(dagKeuze), tijd: tijdKeuze, taal: taal,
naam: form.naam.value.trim(), email: form.email.value.trim(),
telefoon: form.telefoon.value.trim(), reden: form.reden.value.trim()
}, function (d) {
if (d && d.ok) {
window.location.href = bedankt + '?d=' + encodeURIComponent(sleutel(dagKeuze))
+ '&t=' + encodeURIComponent(tijdKeuze) + '&n=' + encodeURIComponent(form.naam.value.trim());
return;
}
misgegaan(d && d.fout ? d.fout : 'onbekend');
}, misgegaan);
});

tekenKalender();
haalVrij();
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

(function(){
var sec = document.querySelector('[data-ac-boek-sh]:not([data-ac-kop-klaar-sh])');
if(!sec) return;
sec.setAttribute('data-ac-kop-klaar-sh','1');
var kop = sec.querySelector('.ac-cosmos__heading');
var binnen = sec.querySelector('.ac-cosmos__inner') || sec;
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-bk__kern') || k.classList.contains('ac-bk__semi'))){ k.setAttribute('data-accent-sh','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent-sh')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-bk__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-bk__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.08).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
})();

/* ===== ac-sh-contact ===== */
(function(){
var sec = document.querySelector('.ac-showroom-contact:not([data-ac-kop-klaar-sh])');
if(!sec) return;
sec.setAttribute('data-ac-kop-klaar-sh','1');
var kop = sec.querySelector('.ac-showroom-contact__header h2');
var binnen = sec.querySelector('.ac-showroom-contact__inner') || sec;
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-ct__kern') || k.classList.contains('ac-ct__semi'))){ k.setAttribute('data-accent-sh','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent-sh')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-ct__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-ct__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.08).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
})();

/* ===== ac-sh-afspraak ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var kop = sec.querySelector('[data-ac-as-kop]');
var binnen = sec.querySelector('.ac-as__in');
/* Ruimte van de thema-wrapper weghalen, anders staat er een strook
   paginakleur tussen de golven en de secties ernaast. */
(function(){ var n = sec.parentElement; while(n && n !== document.body){ var cs = getComputedStyle(n); if(parseFloat(cs.paddingTop) || parseFloat(cs.paddingBottom) || parseFloat(cs.marginTop) || parseFloat(cs.marginBottom)){ n.style.paddingTop='0px'; n.style.paddingBottom='0px'; n.style.marginTop='0px'; n.style.marginBottom='0px'; } n = n.parentElement; } })();
var spring = sec.querySelector('[data-ac-as-spring]');
if(spring){
spring.addEventListener('click', function(e){
var sel = spring.getAttribute('data-ac-as-spring'), doel = null;
try { doel = document.querySelector(sel); } catch(err){ doel = null; }
if(!doel && sel.charAt(0) !== '.' && sel.charAt(0) !== '#'){ doel = document.getElementById(sel); }
if(!doel || doel.contains(spring)) return;
e.preventDefault();
var stil = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var offset = parseInt(spring.getAttribute('data-ac-as-offset'), 10) || 0;
var top = doel.getBoundingClientRect().top + window.pageYOffset - offset;
window.scrollTo({ top: top, behavior: stil ? 'auto' : 'smooth' });
});
}
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-as__kern') || k.classList.contains('ac-as__semi'))){ k.setAttribute('data-accent','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-as__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-as__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.08).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.1 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-as]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-sh-proefzitten ===== */
/* Liep op een id dat Liquid in het script schreef. Nu op de sectie zelf,
   zodat dit script in een gecachet bestand kan staan. */
(function(){
function pd(sec){
if(!sec || sec.dataset.acKlaar) return;
sec.dataset.acKlaar = '1';
var kop = sec.querySelector('[data-ac-pw-kop]');
var binnen = sec.querySelector('.ac-pw__in');
function knip(el){
if(!el.dataset.bron) el.dataset.bron = el.innerHTML;
el.innerHTML = el.dataset.bron;
var woorden = [];
(function loop(n){
Array.prototype.slice.call(n.childNodes).forEach(function(k){
if(k.nodeType === 3){
var f = document.createDocumentFragment();
k.textContent.split(/(\s+)/).forEach(function(s){
if(!s) return;
if(/^\s+$/.test(s)){ f.appendChild(document.createTextNode(' ')); return; }
var x = document.createElement('span'); x.textContent = s; x.style.display = 'inline-block'; f.appendChild(x); woorden.push(x);
});
n.replaceChild(f, k);
} else if(k.nodeType === 1){
if(k.classList && (k.classList.contains('ac-pw__kern') || k.classList.contains('ac-pw__semi'))){ k.setAttribute('data-accent','1'); woorden.push(k); }
else { loop(k); }
}
});
})(el);
var r = [], vorige = null;
woorden.forEach(function(x){ var t = Math.round(x.offsetTop); if(vorige === null || Math.abs(t - vorige) > 4){ r.push([]); vorige = t; } r[r.length - 1].push(x); });
var uit = '';
r.forEach(function(reg, i){
var stuk = '';
reg.forEach(function(x, j){
if(j > 0 && !/^[,.;:!?)\]]/.test(x.textContent)) stuk += ' ';
if(x.getAttribute && x.getAttribute('data-accent')){ stuk += '<span class="' + x.className + '" style="animation-delay:' + (i * 0.07 + 0.2).toFixed(2) + 's">' + x.innerHTML + '</span>'; }
else { stuk += x.textContent; }
});
uit += '<span class="ac-pw__regel"><i style="animation-delay:' + (i * 0.07).toFixed(2) + 's">' + stuk + '</i></span>';
});
el.innerHTML = uit;
return r.length;
}
function bouw(){
var regels = kop ? (knip(kop) || 1) : 1;
var basis = regels * 0.07 + 0.24;
Array.prototype.slice.call(sec.querySelectorAll('.ac-pw__op')).forEach(function(el, i){ el.style.animationDelay = (basis + i * 0.09).toFixed(2) + 's'; });
}
function start(){
bouw();
if(!('IntersectionObserver' in window)){ sec.classList.add('speelt'); return; }
var io = new IntersectionObserver(function(e){ e.forEach(function(x){ if(x.isIntersecting){ sec.classList.add('speelt'); io.disconnect(); } }); }, { threshold: 0.12 });
io.observe(sec);
}
var f = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
f.then(start).catch(start);
if(binnen && window.ResizeObserver){
var laatste = Math.round(binnen.getBoundingClientRect().width), tm = null;
new ResizeObserver(function(){
var nu = Math.round(binnen.getBoundingClientRect().width);
if(nu === laatste || !nu) return;
laatste = nu;
clearTimeout(tm);
tm = setTimeout(bouw, 120);
}).observe(binnen);
}
}
function init(){ document.querySelectorAll('[data-ac-pw]').forEach(pd); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

/* ===== ac-ab-dank ===== */

(function () {
function init() {
document.querySelectorAll('[data-ac-dank-ab]:not([data-ac-klaar-ab])').forEach(function (root) {
root.setAttribute('data-ac-klaar-ab', '1');
var p = new URLSearchParams(window.location.search);
var datum = p.get('d'), tijd = p.get('t');
var loc = root.getAttribute('data-loc') || 'nl-NL';
var adres = root.getAttribute('data-adres') || '';
if (!datum || !tijd) { return; }
var d = datum.split('-'), u = tijd.split(':');
var start = new Date(Number(d[0]), Number(d[1]) - 1, Number(d[2]), Number(u[0]) || 0, Number(u[1]) || 0);
if (isNaN(start.getTime())) { return; }
var eind = new Date(start.getTime() + 3600000);

var regel = root.querySelector('[data-ac-wanneer-ab]');
regel.querySelector('[data-ac-wanneer-tekst-ab]').textContent =
start.toLocaleDateString(loc, { weekday: 'long', day: 'numeric', month: 'long' }) + ', ' + tijd;
regel.hidden = false;

/* Een agendabestand dat wij zelf samenstellen, zodat de knop werkt in
   Apple Agenda, Outlook en Google Agenda zonder tussenpartij. */
function stempel(x) {
return x.getUTCFullYear() + ('0' + (x.getUTCMonth() + 1)).slice(-2) + ('0' + x.getUTCDate()).slice(-2)
+ 'T' + ('0' + x.getUTCHours()).slice(-2) + ('0' + x.getUTCMinutes()).slice(-2) + '00Z';
}
var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//AlienComfort//showroom//NL', 'BEGIN:VEVENT',
'UID:' + start.getTime() + '@aliencomfort.nl', 'DTSTAMP:' + stempel(new Date()),
'DTSTART:' + stempel(start), 'DTEND:' + stempel(eind),
'SUMMARY:Proefzitten bij AlienComfort', 'LOCATION:' + adres,
'DESCRIPTION:Uw showroomafspraak bij AlienComfort.', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
var knop = root.querySelector('[data-ac-agenda-ab]');
knop.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics);
knop.hidden = false;

/* Melding voor Google Tag Manager. Werk je alleen met GA4 zonder GTM,
   dan heb je dit niet nodig: daar telt het adres van deze pagina al. */
window.dataLayer = window.dataLayer || [];
window.dataLayer.push({ event: 'showroom_afspraak', afspraak_datum: datum, afspraak_tijd: tijd });
});
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-vg-tabel ===== */
(function(){
var sec=document.getElementById('ac-vergelijker');if(!sec||sec.dataset.acKlaar)return;sec.dataset.acKlaar='1';
var LIVE=JSON.parse(sec.querySelector('[data-vg-live]').textContent),DATA=JSON.parse(sec.querySelector('[data-vg-data]').textContent),T=DATA.t;
var IDS=['pluto','nova','luna','astron','pulsar','atlas','titan'];
var COLS=[{label:T.col1,ids:['pluto']},{label:T.col2,ids:['nova','luna']},{label:T.col3,ids:['astron','pulsar','atlas','titan']}];
var lijst=sec.querySelector('[data-vg-lijst]'),tabbar=sec.querySelector('[data-vg-tabs]');
function esc(x){return String(x==null?'':x).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
var sysTeller=0;function sysKaart(sys){sysTeller++;var binnen;if(sys==='3d'){binnen='<svg viewBox="0 0 52 40" fill="none" aria-hidden="true"><circle cx="26" cy="20" r="13" stroke="rgba(41,184,122,.3)" stroke-width="1.5"/><circle class="ac-vg-vg__anim-puls" cx="26" cy="20" r="6.5" fill="#29b87a"/></svg><span class="ac-vg-vg__sysnaam">3D</span><span class="ac-vg-vg__syssub">'+esc(T.sys3)+'</span>'}else{var plus=sys==='4dplus',pad='M 30 4 C 38 13, 15 20, 20 28 C 22 33, 29 35, 28 38',pid='ac-vg-p'+sysTeller;binnen='<svg viewBox="0 0 52 40" fill="none" aria-hidden="true"><path id="'+pid+'" d="'+pad+'" stroke="rgba(0,8,5,.14)" stroke-width="1.5" stroke-linecap="round"/><circle class="ac-vg-vg__raildot'+(plus?' ac-vg-vg__anim-diep':'')+'" r="3.5" fill="#29b87a"><animateMotion dur="3.4s" repeatCount="indefinite" keyPoints="0;1;0" keyTimes="0;.5;1" calcMode="linear"><mpath href="#'+pid+'"/></animateMotion></circle><circle class="ac-vg-vg__railstil" cx="30" cy="4" r="3.5" fill="#29b87a"/>'+(plus?'<path d="M42 6h8M46 2v8" stroke="#12855A" stroke-width="2" stroke-linecap="round"/>':'')+'</svg><span class="ac-vg-vg__sysnaam">'+(plus?'4D+':'4D')+'</span><span class="ac-vg-vg__syssub">'+esc(plus?T.sys4p:T.sys4)+'</span>'}return'<span class="ac-vg-vg__sys">'+binnen+'</span>'}
function kaarten(id){var ci=IDS.indexOf(id),c=LIVE[id]||{},uit='';DATA.groepen.forEach(function(g,gi){var titel='<span class="ac-vg-vg__kaartkop">'+esc(T.tabs[gi]||g.n)+'</span>',inhoud;if(gi===0){inhoud=sysKaart(c.sys||'3d')}else{var eerste=g.rows[0],hv=eerste[1][ci],hero,meter='';if(eerste[2]==='m4'){var d=String(hv).split('|'),n=parseInt(d[0],10)||0,bl='';hero=esc(d[1]||'—');for(var i=1;i<=4;i++)bl+='<i'+(i<=n?' class="is-aan"':'')+'></i>';meter='<span class="ac-vg-vg__mblok">'+bl+'</span>'}else hero=esc(hv);var leeg=hv==='—',cijfer=/^[0-9]/.test(String(hv));inhoud='<span class="ac-vg-vg__eyebrow">'+esc(eerste[0])+'</span><span class="ac-vg-vg__groot'+(cijfer?'':' is-woord')+(leeg?' is-leeg':'')+'">'+hero+'</span>'+meter;var rest='';g.rows.slice(1).forEach(function(r){var v=r[1][ci];if(r[2]==='m4')v=String(v).split('|')[1]||'—';rest+='<div><dt>'+esc(r[0])+'</dt><dd'+(v==='—'?' class="is-leeg"':'')+'>'+esc(v)+'</dd></div>'});if(rest)inhoud+='<dl class="ac-vg-vg__extra">'+rest+'</dl>'}uit+='<div class="ac-vg-vg__kaart" data-card-i="'+gi+'">'+titel+inhoud+'</div>'});return uit}
var BANEN=['wit','zwart','grijs'],KLEUR={zwart:'#000805',grijs:'#F0F0F0',wit:'#fff'},GOLF='M0,32 C280,58 620,8 900,26 C1130,40 1300,50 1440,34 L1440,61 L0,61 Z',uit='';
COLS.forEach(function(col,bi){var baan=BANEN[bi]||'wit',boven=bi?KLEUR[BANEN[bi-1]]:null;uit+='<section class="ac-vg-vg__baan ac-vg-vg__baan--'+baan+'">';if(boven)uit+='<div class="ac-vg-vg__baangolf" aria-hidden="true"><svg viewBox="0 0 1440 60" preserveAspectRatio="none"><path fill="'+boven+'" d="'+GOLF+'"/></svg></div>';uit+='<div class="ac-vg-vg__baan-in"><h2 class="ac-vg-vg__colkop">'+esc(col.label)+'</h2>';col.ids.forEach(function(id){var c=LIVE[id]||{};uit+='<div class="ac-vg-vg__rij"><div class="ac-vg-vg__rijkop">'+(c.img?'<img class="ac-vg-vg__foto" src="'+esc(c.img)+'" alt="" loading="lazy" decoding="async">':'')+'<span class="ac-vg-vg__wie"><span class="ac-vg-vg__naam">'+(c.url?'<a href="'+esc(c.url)+'">'+esc(c.naam)+'</a>':esc(c.naam))+'</span><span class="ac-vg-vg__prijsrij"><span class="ac-vg-vg__prijs">'+esc(c.prijs||'')+'</span>'+(c.was?'<span class="ac-vg-vg__was">'+esc(c.was)+'</span>':'')+'</span><span class="ac-vg-vg__status '+(c.op?'is-op':'is-pre')+'">'+esc(c.op?T.op:T.pre)+'</span></span>'+(c.url?'<a class="ac-vg-vg__knop" href="'+esc(c.url)+'">'+esc(T.bekijk)+'</a>':'')+'</div><div class="ac-vg-vg__spoor" data-vg-spoor>'+kaarten(id)+'</div></div>'});uit+='</div>';if(bi===COLS.length-1)uit+='<div class="ac-vg-vg__baangolf ac-vg-vg__baangolf--onder" aria-hidden="true"><svg viewBox="0 0 1440 60" preserveAspectRatio="none"><path fill="#fff" d="'+GOLF+'"/></svg></div>';uit+='</section>'});lijst.innerHTML=uit;
var ICO=['<path d="M12 4v16M4 12h16"/><circle cx="12" cy="12" r="8"/>','<path d="M4 15h3M9 15h3M14 15h3M19 15h1M4 10h2M8 10h4M14 10h6"/>','<circle cx="8" cy="12" r="3"/><circle cx="16" cy="12" r="3"/>','<rect x="4" y="5" width="16" height="14" rx="3"/><path d="M8 10h8M8 14h5"/>','<path d="M4 17v-5a8 8 0 0 1 16 0v5M3 17h18"/>','<path d="M4 8V5h3M20 8V5h-3M4 16v3h3M20 16v3h-3"/>','<path d="M12 3l7 4v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V7zM9 12l2 2 4-4"/>'];
var tabsUit='<button type="button" class="ac-vg-vg__pijl" data-vg-vorige aria-label="Vorige"><svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg></button>';T.tabs.forEach(function(n,i){tabsUit+='<button type="button" class="ac-vg-vg__tab'+(i?'':' is-aan')+'" data-i="'+i+'" aria-pressed="'+(i?'false':'true')+'"><svg viewBox="0 0 24 24" aria-hidden="true">'+ICO[i]+'</svg><span>'+esc(n)+'</span></button>'});tabsUit+='<button type="button" class="ac-vg-vg__pijl" data-vg-volgende aria-label="Volgende"><svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg></button>';tabbar.innerHTML=tabsUit;
var tabs=[].slice.call(tabbar.querySelectorAll('.ac-vg-vg__tab')),pV=tabbar.querySelector('[data-vg-vorige]'),pN=tabbar.querySelector('[data-vg-volgende]'),sporen=[].slice.call(sec.querySelectorAll('[data-vg-spoor]')),huidig=0,zacht=!matchMedia('(prefers-reduced-motion:reduce)').matches,syncing=false,syncTimer;
function cardLeft(sp,i){var c=sp.querySelector('[data-card-i="'+i+'"]');return c?Math.max(0,c.offsetLeft-sp.offsetLeft):0}
function nearest(sp){var best=0,dist=Infinity;[].slice.call(sp.children).forEach(function(c,i){if(!c.classList.contains('ac-vg-vg__kaart'))return;var d=Math.abs((c.offsetLeft-sp.offsetLeft)-sp.scrollLeft);if(d<dist){dist=d;best=i}});return Math.max(0,Math.min(T.tabs.length-1,best))}
function centerTab(i){var t=tabs[i];if(!t)return;var left=t.offsetLeft-(tabbar.clientWidth-t.offsetWidth)/2;tabbar.scrollTo({left:Math.max(0,left),behavior:zacht?'smooth':'auto'})}
function zetTab(i,center){huidig=i;tabs.forEach(function(t,j){var on=j===i;t.classList.toggle('is-aan',on);t.setAttribute('aria-pressed',on?'true':'false')});pV.disabled=i===0;pN.disabled=i===T.tabs.length-1;if(center)centerTab(i)}
function syncTo(i,source,smooth){syncing=true;var vh=innerHeight||800;sporen.forEach(function(sp){if(sp===source)return;var r=sp.getBoundingClientRect(),visible=r.bottom>-60&&r.top<vh+60,behavior=smooth&&visible&&zacht?'smooth':'auto';sp.scrollTo({left:cardLeft(sp,i),behavior:behavior})});zetTab(i,true);clearTimeout(syncTimer);syncTimer=setTimeout(function(){syncing=false},smooth?500:120)}
function go(i){i=Math.max(0,Math.min(T.tabs.length-1,i));syncTo(i,null,true)}
tabs.forEach(function(t){t.addEventListener('click',function(){go(+t.dataset.i)});t.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();go(huidig+1)}else if(e.key==='ArrowLeft'){e.preventDefault();go(huidig-1)}else if(e.key==='Home'){e.preventDefault();go(0)}else if(e.key==='End'){e.preventDefault();go(T.tabs.length-1)}})});pV.onclick=function(){go(huidig-1)};pN.onclick=function(){go(huidig+1)};
sporen.forEach(function(sp){var st,drag=false,moved=false,sx=0,sl=0,pid=null;function settle(){if(syncing||drag)return;var i=nearest(sp);syncTo(i,sp,false);sp.scrollTo({left:cardLeft(sp,i),behavior:zacht?'smooth':'auto'})}sp.addEventListener('scroll',function(){if(syncing||drag)return;clearTimeout(st);st=setTimeout(settle,120)},{passive:true});sp.addEventListener('pointerdown',function(e){if(e.pointerType==='touch'||e.button!==0)return;drag=true;moved=false;pid=e.pointerId;sx=e.clientX;sl=sp.scrollLeft;sp.classList.add('is-drag');try{sp.setPointerCapture(pid)}catch(x){}});sp.addEventListener('pointermove',function(e){if(!drag||e.pointerId!==pid)return;var d=e.clientX-sx;if(Math.abs(d)>4)moved=true;sp.scrollLeft=sl-d});function end(e){if(!drag||(e&&e.pointerId!==pid))return;drag=false;sp.classList.remove('is-drag');try{sp.releasePointerCapture(pid)}catch(x){}settle()}sp.addEventListener('pointerup',end);sp.addEventListener('pointercancel',end);sp.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation()}},true)});
(function(){var wie=null;try{wie=new URLSearchParams(location.search).get('stoel')}catch(e){}if(!wie||IDS.indexOf(wie)<0)return;var volg=[];COLS.forEach(function(c){volg=volg.concat(c.ids)});var doel=sec.querySelectorAll('.ac-vg-vg__rij')[volg.indexOf(wie)];if(doel)setTimeout(function(){var top=parseFloat(getComputedStyle(sec).getPropertyValue('--ac-vg-top'))||0,y=doel.getBoundingClientRect().top+pageYOffset-top-8;scrollTo({top:Math.max(0,Math.round(y)),behavior:zacht?'smooth':'auto'})},250)})();
function meetTop(){var h=0;document.querySelectorAll('header,[class*="header"]').forEach(function(el){var cs=getComputedStyle(el),r=el.getBoundingClientRect();if((cs.position==='fixed'||cs.position==='sticky')&&r.top<=4&&r.height>=20&&r.height<=200)h=Math.max(h,r.height)});sec.style.setProperty('--ac-vg-top',h+'px')}var rt;addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){meetTop();sporen.forEach(function(sp){sp.scrollLeft=cardLeft(sp,huidig)})},120)});meetTop();zetTab(0,false);
})();

/* ===== ac-wk-laatste-stap ===== */
(function () {
  var init = function () {
    document.querySelectorAll('[data-ac-stap2-wk]:not([data-ac-ready-wk])').forEach(function (root) {
      root.setAttribute('data-ac-ready-wk', '1');
      kop(root);
      dots(root);
      inbeeld(root);
    });
  };
  /* De kop wordt in regels geknipt zodat elke regel apart omhoog kan komen.
     Eén keer meten is niet genoeg: verandert de breedte later alsnog (thema-CSS
     die later landt, een scrollbalk, een lettertype dat omwisselt), dan blijft
     de oude opdeling staan en valt er een los woord op een eigen regel.
     Daarom een ResizeObserver op de inhoudscontainer (bouwafspraak 2). */
  var kop = function (root) {
    var el = root.querySelector('[data-ac-kop-wk]');
    var houder = root.querySelector('.ac-stap2__inner');
    if (!el || !houder) { return; }
    var bron = el.innerHTML;
    var breedte = 0;
    var bouw = function () {
      el.removeAttribute('data-ac-geknipt-wk');
      el.innerHTML = bron;
      var woorden = [];
      var loop = function (node, kern, semi) {
        Array.prototype.slice.call(node.childNodes).forEach(function (k) {
          if (k.nodeType === 3) {
            var frag = document.createDocumentFragment();
            k.textContent.split(/(\s+)/).forEach(function (d) {
              if (!d) { return; }
              if (/^\s+$/.test(d)) { frag.appendChild(document.createTextNode(' ')); return; }
              var s = document.createElement('span');
              s.className = 'ac-stap2__w' + (kern ? ' ac-stap2__kern' : '') + (semi ? ' ac-stap2__semi' : '');
              s.textContent = d;
              frag.appendChild(s);
              woorden.push(s);
            });
            node.replaceChild(frag, k);
          } else if (k.nodeType === 1) {
            loop(k, kern || k.hasAttribute('data-ac-kern-wk'), semi || k.hasAttribute('data-ac-semi-wk'));
          }
        });
      };
      loop(el, false, false);
      if (!woorden.length) { return; }
      var regels = [];
      var rij = null;
      var top = null;
      woorden.forEach(function (w) {
        var t = w.offsetTop;
        if (top === null || Math.abs(t - top) > 4) { rij = []; regels.push(rij); top = t; }
        rij.push(w);
      });
      var frag = document.createDocumentFragment();
      regels.forEach(function (r, i) {
        var regel = document.createElement('span');
        regel.className = 'ac-stap2__regel';
        regel.style.setProperty('--i', i);
        var binnen = document.createElement('span');
        binnen.className = 'ac-stap2__regel-in';
        r.forEach(function (w, j) {
          if (j) { binnen.appendChild(document.createTextNode(' ')); }
          w.style.setProperty('--i', i);
          binnen.appendChild(w);
        });
        regel.appendChild(binnen);
        frag.appendChild(regel);
      });
      el.innerHTML = '';
      el.appendChild(frag);
      el.setAttribute('data-ac-geknipt-wk', '1');
      root.style.setProperty('--ac-na', regels.length);
    };
    breedte = houder.clientWidth;
    bouw();
    if (typeof ResizeObserver === 'function') {
      var wacht = false;
      new ResizeObserver(function () {
        if (wacht) { return; }
        wacht = true;
        window.requestAnimationFrame(function () {
          wacht = false;
          if (houder.clientWidth === breedte) { return; }
          breedte = houder.clientWidth;
          bouw();
        });
      }).observe(houder);
    } else {
      window.addEventListener('resize', function () {
        if (houder.clientWidth === breedte) { return; }
        breedte = houder.clientWidth;
        bouw();
      });
    }
  };
  /* De stipjes onder de swipe-rij lopen mee met de kaart die het dichtst bij
     het midden staat. Alleen zichtbaar op mobiel; op desktop staan ze uit. */
  var dots = function (root) {
    var rij = root.querySelector('[data-ac-swipe-wk]');
    var stippen = root.querySelectorAll('[data-ac-dots-wk] span');
    if (!rij || !stippen.length) { return; }
    var kaarten = Array.prototype.slice.call(rij.children);
    var bezig = false;
    var update = function () {
      bezig = false;
      var midden = rij.scrollLeft + rij.clientWidth / 2;
      var beste = 0;
      var kleinste = Infinity;
      kaarten.forEach(function (k, i) {
        var afstand = Math.abs(k.offsetLeft + k.offsetWidth / 2 - midden);
        if (afstand < kleinste) { kleinste = afstand; beste = i; }
      });
      stippen.forEach(function (d, i) { d.classList.toggle('is-active', i === beste); });
    };
    rij.addEventListener('scroll', function () {
      if (bezig) { return; }
      bezig = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  };
  /* De kop komt pas in beweging zodra de sectie in beeld staat. */
  var inbeeld = function (root) {
    if (typeof IntersectionObserver !== 'function') { root.classList.add('is-zichtbaar'); return; }
    var kijker = new IntersectionObserver(function (rijen) {
      rijen.forEach(function (r) {
        if (!r.isIntersecting) { return; }
        root.classList.add('is-zichtbaar');
        kijker.disconnect();
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    kijker.observe(root);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-wk-inhoud ===== */
(function () {
  /* Luistert mee met de winkelwagenverzoeken van het thema, zodat deze
     sectie meebeweegt met de rest (drawer, andere blokken). Eén keer per
     pagina; de andere AlienComfort-winkelwagensecties gebruiken dezelfde
     haak.
     DRIE DINGEN DIE HIER MIS WAREN EN NU GOED STAAN — zie de kop van de
     sectie voor de uitleg:
      1. De haak luisterde ook op /cart.js, en /cart.js is precies wat de
         luisteraars zélf ophalen. Elke verversing startte dus een nieuwe
         ronde. Nu alleen de verzoeken die de winkelwagen echt wijzigen.
      2. origineel.apply(this, ...) brak elke fetch() die niet via
         window.fetch(...) werd aangeroepen ("Illegal invocation"). Nu
         altijd window als context.
      3. Een reeks wijzigingen kort na elkaar gaf een reeks verversingen.
         Nu wordt er per 150 ms hoogstens één melding gedaan. */
  if (!window.__acCartHook_wk) {
    window.__acCartHook_wk = true;
    var origineel = window.fetch;
    var wijzigt = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var wacht = null;
    var meld = function () {
      window.clearTimeout(wacht);
      wacht = window.setTimeout(function () {
        document.dispatchEvent(new CustomEvent('ac:cart'));
      }, 150);
    };
    window.fetch = function () {
      var belofte = origineel.apply(window, arguments);
      try {
        var u = String((arguments[0] && arguments[0].url) || arguments[0] || '');
        if (wijzigt.test(u)) { belofte.then(meld, function () {}); }
      } catch (e) {}
      return belofte;
    };
  }
  var init = function () {
    document.querySelectorAll('[data-ac-cart-wkl]:not([data-ac-ready-wkl])').forEach(function (root) {
      root.setAttribute('data-ac-ready-wkl', '1');
      var valuta = root.getAttribute('data-ac-valuta-wkl') || 'EUR';
      var taal = root.getAttribute('data-ac-lang-wkl') || 'nl';
      var formaat = null;
      try { formaat = new Intl.NumberFormat(taal, { style: 'currency', currency: valuta }); } catch (e) {}
      var geld = function (c) { return formaat ? formaat.format(c / 100) : (c / 100).toFixed(2) + ' ' + valuta; };
      var bezig = false;
      var termijn = null;
      /* ---- alles bijwerken vanuit de winkelwagendata ---- */
      var toon = function (d) {
        /* Een antwoord van de winkelwagen-API heeft altijd item_count en
           items. Komt er iets anders terug (een foutmelding, of een 429
           omdat er te veel verzoeken achter elkaar gingen), dan laten we
           het scherm staan zoals het stond. Anders verschijnt er
           "undefined artikelen" en stopt de rest van deze functie. */
        if (!d || typeof d.item_count !== 'number' || !d.items || !d.items.length && d.item_count > 0) { return; }
        var aantalEl = root.querySelector('[data-ac-aantal-wkl]');
        if (aantalEl) { aantalEl.textContent = d.item_count + ' ' + (d.item_count === 1 ? root.getAttribute('data-ac-art1-wkl') : root.getAttribute('data-ac-artn-wkl')); }
        var leegEl = root.querySelector('[data-ac-leeg-wkl]');
        var volEl = root.querySelector('[data-ac-vol-wkl]');
        if (leegEl && volEl) {
          if (d.item_count === 0) { leegEl.removeAttribute('hidden'); volEl.setAttribute('hidden', ''); } else { leegEl.setAttribute('hidden', ''); volEl.removeAttribute('hidden'); }
        }
        root.querySelectorAll('[data-ac-item-wkl]').forEach(function (rij) {
          var sleutel = rij.getAttribute('data-ac-item-wkl');
          var item = null;
          for (var i = 0; i < d.items.length; i++) { if (d.items[i].key === sleutel) { item = d.items[i]; break; } }
          if (!item) { rij.remove(); return; }
          var q = rij.querySelector('[data-ac-qty-wkl]');
          if (q) { q.textContent = item.quantity; }
          var l = rij.querySelector('[data-ac-lijn-wkl]');
          if (l) { l.textContent = geld(item.final_line_price); }
        });
        var sub = root.querySelector('[data-ac-sub-wkl]');
        if (sub) { sub.textContent = geld(d.original_total_price); }
        var kortingRij = root.querySelector('[data-ac-korting-rij-wkl]');
        if (kortingRij) {
          if (d.total_discount > 0) {
            kortingRij.removeAttribute('hidden');
            var naam = root.querySelector('[data-ac-korting-naam-wkl]');
            if (naam) { naam.textContent = (d.cart_level_discount_applications && d.cart_level_discount_applications[0] && d.cart_level_discount_applications[0].title) || root.getAttribute('data-ac-korting-label-wkl'); }
            var kort = root.querySelector('[data-ac-korting-wkl]');
            if (kort) { kort.textContent = '−' + geld(d.total_discount); }
          } else {
            kortingRij.setAttribute('hidden', '');
          }
        }
        var tot = root.querySelector('[data-ac-totaal-wkl]');
        if (tot) { tot.textContent = geld(d.total_price); }
        if (termijn) { termijn.update(d); }
      };
      var vernieuw = function () {
        return window.fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(toon).catch(function () {});
      };
      /* Eén wijziging tegelijk naar Shopify, maar een klik gaat nooit
         verloren: wat er tijdens het wachten bij komt, wordt daarna
         verstuurd. Daardoor kunt u rustig drie keer op + tikken. */
      var wachtrij = null;
      var wijzig = function (sleutel, aantal) {
        if (bezig) { wachtrij = { sleutel: sleutel, aantal: aantal }; return; }
        bezig = true;
        window.fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: sleutel, quantity: aantal })
        }).then(function (r) { return r.json(); }).then(function (d) {
          toon(d);
        }).catch(function () {
          vernieuw();
        }).then(function () {
          bezig = false;
          if (wachtrij) { var w = wachtrij; wachtrij = null; wijzig(w.sleutel, w.aantal); }
        });
      };
      /* ---- aantallen en verwijderen ---- */
      root.querySelectorAll('[data-ac-item-wkl]').forEach(function (rij) {
        var sleutel = rij.getAttribute('data-ac-item-wkl');
        var q = rij.querySelector('[data-ac-qty-wkl]');
        var lees = function () { return parseInt(q && q.textContent, 10) || 1; };
        var min = rij.querySelector('[data-ac-min-wkl]');
        var plus = rij.querySelector('[data-ac-plus-wkl]');
        var weg = rij.querySelector('[data-ac-weg-wkl]');
        /* Het getal gaat meteen omhoog of omlaag. Dat is niet alleen
           prettiger, het is ook nodig: zonder dat leest een tweede klik
           nog het oude aantal en stuurt hij dezelfde waarde nog eens.
           Klopt het niet met wat Shopify teruggeeft, dan zet toon() het
           een fractie later recht. */
        var stel = function (n) { if (q) { q.textContent = n; } wijzig(sleutel, n); };
        if (min) { min.addEventListener('click', function () { stel(Math.max(0, lees() - 1)); }); }
        if (plus) { plus.addEventListener('click', function () { stel(lees() + 1); }); }
        if (weg) { weg.addEventListener('click', function () { stel(0); }); }
      });
      /* ---- bestelnotitie automatisch opslaan ---- */
      var notitie = root.querySelector('[data-ac-notitie-wkl]');
      if (notitie) {
        var wachter = null;
        notitie.addEventListener('input', function () {
          window.clearTimeout(wachter);
          wachter = window.setTimeout(function () {
            window.fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ note: notitie.value })
            }).catch(function () {});
          }, 800);
        });
      }
      /* ---- verzendblok: countdown ---- */
      var verz = root.querySelector('[data-ac-verz-wkl]');
      if (verz) {
        verz.setAttribute('data-ac-ready-wkl', '1');
        var chip = verz.querySelector('[data-ac-chip-wkl]');
        var tijd = verz.querySelector('[data-ac-tijd-wkl]');
        if (chip && tijd) {
          var tik = function () {
            var nu = new Date();
            var dag = nu.getDay();
            var deadline = new Date(nu.getFullYear(), nu.getMonth(), nu.getDate(), 17, 0, 0);
            if (dag >= 1 && dag <= 5 && nu < deadline) {
              var rest = Math.floor((deadline - nu) / 60000);
              tijd.textContent = Math.floor(rest / 60) + ':' + (rest % 60 < 10 ? '0' : '') + (rest % 60);
              chip.removeAttribute('hidden');
            } else {
              chip.setAttribute('hidden', '');
            }
          };
          tik();
          window.setInterval(tik, 30000);
        }
      }
      /* ---- gespreid betalen: 6, 9 of 12 termijnen ----
         De keuze gaat als cart-attributes mee met de bestelling. Bewaren
         gebeurt alleen als totaal of keuze echt veranderd is, zodat de
         cart-haak hierboven geen lus kan veroorzaken. */
      termijn = (function () {
        var el = root.querySelector('[data-ac-term-wkl]');
        if (!el) { return null; }
        var minimum = parseInt(el.getAttribute('data-ac-min-wkl'), 10) || 0;
        var sjabloon = el.getAttribute('data-ac-sjabloon-wkl') || '{schema}';
        var totaal = parseInt(el.getAttribute('data-ac-totaal-wkl'), 10) || 0;
        var keuze = parseInt(el.getAttribute('data-ac-keuze-wkl'), 10) || 0;
        var laatst = '';
        var knoppen = el.querySelectorAll('[data-ac-term-n-wkl]');
        var schemaEl = el.querySelector('[data-ac-term-schema-wkl]');
        var hoeEl = el.querySelector('[data-ac-term-hoe-wkl]');
        var wisEl = el.querySelector('[data-ac-term-wis-wkl]');
        /* Rentestaffel uit snippets/ac-rente.liquid. Staat de rente uit, dan
           zijn alle percentages 0 en rekent dit precies als voorheen. */
        var staffel = (function () {
          var d = (el.getAttribute('data-ac-rente-wkl') || '0|0|0|0').split('|');
          return { aan: d[0] === '1', t4: parseFloat(d[1]) || 0, t7: parseFloat(d[2]) || 0, t13: parseFloat(d[3]) || 0 };
        })();
        var pct = function (n) {
          if (!staffel.aan) { return 0; }
          if (n >= 13) { return staffel.t13 || 0; }
          if (n >= 7) { return staffel.t7 || 0; }
          if (n >= 4) { return staffel.t4 || 0; }
          return 0;
        };
        /* Naar beneden, net als Liquid: `prijs | times: pct | divided_by: 100`
           is een integerdeling. Zo rekenen de knop bij het laden en het script
           daarna tot op de cent hetzelfde. */
        var metRente = function (c, n) { return c + Math.floor(c * pct(n) / 100); };
        var deel = function (c, n) { var t = metRente(c, n); var p = Math.floor(t / n); return { per: p, rest: t - p * (n - 1) }; };
        var schema = function (c, n) { var d = deel(c, n); return d.rest === d.per ? n + ' × ' + geld(d.per) : (n - 1) + ' × ' + geld(d.per) + ' + 1 × ' + geld(d.rest); };
        var teken = function () {
          if (totaal < minimum) { el.setAttribute('hidden', ''); } else { el.removeAttribute('hidden'); }
          knoppen.forEach(function (k) {
            var n = parseInt(k.getAttribute('data-ac-term-n-wkl'), 10);
            var pm = k.querySelector('[data-ac-term-pm-wkl]');
            if (pm) { pm.textContent = geld(deel(totaal, n).per); }
            var actief = n === keuze;
            k.classList.toggle('is-actief', actief);
            k.setAttribute('aria-pressed', actief ? 'true' : 'false');
          });
          if (keuze > 0) {
            if (schemaEl) { schemaEl.textContent = sjabloon.replace('{schema}', schema(totaal, keuze)).replace('{totaal}', geld(metRente(totaal, keuze))); schemaEl.removeAttribute('hidden'); }
            if (hoeEl) { hoeEl.removeAttribute('hidden'); }
            if (wisEl) { wisEl.removeAttribute('hidden'); }
          } else {
            if (schemaEl) { schemaEl.setAttribute('hidden', ''); }
            if (hoeEl) { hoeEl.setAttribute('hidden', ''); }
            if (wisEl) { wisEl.setAttribute('hidden', ''); }
          }
        };
        var bewaar = function () {
          var sleutel = totaal + '|' + keuze;
          if (sleutel === laatst) { return; }
          laatst = sleutel;
          var attr = { 'Betaalwijze': '', 'Aantal termijnen': '', 'Bedrag per termijn': '', 'Termijnschema': '' };
          if (keuze > 0) {
            attr = {
              'Betaalwijze': el.getAttribute('data-ac-naam-wkl') || 'Gespreid betalen',
              'Aantal termijnen': String(keuze),
              'Bedrag per termijn': geld(deel(totaal, keuze).per),
              'Termijnschema': schema(totaal, keuze)
            };
          }
          window.fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: attr })
          }).catch(function () {});
        };
        knoppen.forEach(function (k) {
          k.addEventListener('click', function () {
            var n = parseInt(k.getAttribute('data-ac-term-n-wkl'), 10);
            keuze = keuze === n ? 0 : n;
            teken();
            bewaar();
          });
        });
        if (wisEl) { wisEl.addEventListener('click', function () { keuze = 0; teken(); bewaar(); }); }
        /* Stond er al een keuze en kloppen de opgeslagen bedragen nog bij
           het huidige totaal, dan hoeft er niets opnieuw bewaard te worden.
           Kloppen ze niet meer (totaal is intussen veranderd), dan wordt
           er één keer stil bijgewerkt. */
        if (keuze > 0 && totaal < minimum) { keuze = 0; }
        if (keuze > 0 && el.getAttribute('data-ac-opgeslagen-wkl') === geld(deel(totaal, keuze).per)) { laatst = totaal + '|' + keuze; }
        teken();
        if (keuze > 0) { bewaar(); }
        return {
          update: function (d) {
            totaal = d.total_price;
            if (totaal < minimum && keuze > 0) { keuze = 0; }
            teken();
            bewaar();
          }
        };
      })();
      /* ---- meebewegen met wijzigingen elders op de pagina ---- */
      document.addEventListener('ac:cart', vernieuw);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-wk-leverbanner ===== */
(function () {
  /* Trekt de banner naar de schermranden, ongeacht de paddings en
     marges die het thema om een sectie heen zet. */
  var pas = function (el) {
    el.style.marginLeft = '';
    el.style.width = '';
    var rect = el.getBoundingClientRect();
    var links = rect.left + window.scrollX - window.scrollX;
    var breed = document.documentElement.clientWidth;
    if (Math.abs(links) < 1 && Math.abs(rect.width - breed) < 1) { return; }
    el.style.marginLeft = (-links) + 'px';
    el.style.width = breed + 'px';
  };
  var init = function () {
    document.querySelectorAll('[data-ac-lever-wkll]:not([data-ac-ready-wkll])').forEach(function (root) {
      root.setAttribute('data-ac-ready-wkll', '1');
      /* Het thema zet ruimte onder de sectie; die halen we weg zodat de
         banner zonder witruimte doorloopt naar wat eronder komt. */
      var ouder = root.closest('.shopify-section');
      if (ouder) { ouder.style.marginBottom = '0'; ouder.style.paddingBottom = '0'; }
      var herpas = function () { pas(root); };
      herpas();
      window.addEventListener('resize', herpas);
      window.addEventListener('load', herpas);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ===== ac-wk-afrekenknop ===== */
(function () {
  /* Luistert mee met de winkelwagenverzoeken van het thema, zodat deze
     sectie meebeweegt met de rest (drawer, andere blokken). Eén keer per
     pagina; de andere AlienComfort-winkelwagensecties gebruiken dezelfde
     haak.
     DRIE DINGEN DIE HIER MIS WAREN EN NU GOED STAAN — zie de kop van de
     sectie voor de uitleg:
      1. De haak luisterde ook op /cart.js, en /cart.js is precies wat de
         luisteraars zélf ophalen. Elke verversing startte dus een nieuwe
         ronde. Nu alleen de verzoeken die de winkelwagen echt wijzigen.
      2. origineel.apply(this, ...) brak elke fetch() die niet via
         window.fetch(...) werd aangeroepen ("Illegal invocation"). Nu
         altijd window als context.
      3. Een reeks wijzigingen kort na elkaar gaf een reeks verversingen.
         Nu wordt er per 150 ms hoogstens één melding gedaan. */
  if (!window.__acCartHook_wk) {
    window.__acCartHook_wk = true;
    var origineel = window.fetch;
    var wijzigt = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var wacht = null;
    var meld = function () {
      window.clearTimeout(wacht);
      wacht = window.setTimeout(function () {
        document.dispatchEvent(new CustomEvent('ac:cart'));
      }, 150);
    };
    window.fetch = function () {
      var belofte = origineel.apply(window, arguments);
      try {
        var u = String((arguments[0] && arguments[0].url) || arguments[0] || '');
        if (wijzigt.test(u)) { belofte.then(meld, function () {}); }
      } catch (e) {}
      return belofte;
    };
  }
  var init = function () {
    document.querySelectorAll('[data-ac-koop-wklll]:not([data-ac-ready-wklll])').forEach(function (root) {
      root.setAttribute('data-ac-ready-wklll', '1');
      /* Sommige thema's zetten een Custom Liquid-blok in een witte kaart
         met eigen padding. Die wrappers kleuren we mee tot aan de
         sectie-wrapper, zodat het blok echt op #000805 staat. */
      var node = root.parentElement;
      while (node && node !== document.body) {
        node.style.setProperty('background', '#000805', 'important');
        if (node.classList && node.classList.contains('shopify-section')) { break; }
        node = node.parentElement;
      }
      var stand = root.querySelector('[data-ac-stand-wklll]');
      var knop = root.querySelector('[data-ac-knop-wklll]');
      var label = root.querySelector('[data-ac-knop-label-wklll]');
      if (!stand || !knop || !label) { return; }
      var valuta = root.getAttribute('data-ac-valuta-wklll') || 'EUR';
      var taal = root.getAttribute('data-ac-lang-wklll') || 'nl';
      var formaat;
      try { formaat = new Intl.NumberFormat(taal, { style: 'currency', currency: valuta }); } catch (e) { formaat = null; }
      var leegTekst = stand.classList.contains('is-leeg') ? stand.textContent : null;
      var vernieuw = function () {
        window.fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) {
          if (!d || typeof d.item_count === 'undefined') { return; }
          if (d.item_count === 0) {
            if (leegTekst === null) { leegTekst = ''; }
            stand.classList.add('is-leeg');
            stand.textContent = leegTekst || '';
            knop.setAttribute('href', knop.getAttribute('data-ac-leeg-url-wklll'));
            label.textContent = knop.getAttribute('data-ac-leeg-label-wklll');
            return;
          }
          var artikel = d.item_count === 1 ? root.getAttribute('data-ac-art1-wklll') : root.getAttribute('data-ac-artn-wklll');
          var bedrag = formaat ? formaat.format(d.total_price / 100) : (d.total_price / 100).toFixed(2) + ' ' + valuta;
          stand.classList.remove('is-leeg');
          stand.innerHTML = '<span data-ac-aantal-wklll>' + d.item_count + ' ' + artikel + '</span> · <strong data-ac-totaal-wklll>' + bedrag + '</strong>';
          knop.setAttribute('href', knop.getAttribute('data-ac-checkout-wklll'));
          label.textContent = knop.getAttribute('data-ac-vol-label-wklll');
        }).catch(function () {});
      };
      document.addEventListener('ac:cart', vernieuw);
      document.addEventListener('cart:updated', vernieuw);
      document.addEventListener('cart:refresh', vernieuw);
      window.addEventListener('pageshow', vernieuw);
      vernieuw();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
